
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5b49"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5b49"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1jJwX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Fragment = module.exports.jsxDEV = module.exports.jsxs = void 0;
module.exports.jsx = $0f5ae2342c6b0e18$var$jsx;

var $gkQP3 = parcelRequire("gkQP3");

var $kdqQ0 = parcelRequire("kdqQ0");

var $bFIzj = parcelRequire("bFIzj");
/**
 * @see {@link https://github.com/reactjs/rfcs/blob/createlement-rfc/text/0000-create-element-changes.md}
 * @see {@link https://babeljs.io/docs/babel-plugin-transform-react-jsx}
 */ function $0f5ae2342c6b0e18$var$jsx(type, _a, key) {
    var ref = _a.ref, is = _a.is, style = _a.style, children = _a.children, props = $gkQP3.__rest(_a, [
        "ref",
        "is",
        "style",
        "children"
    ]);
    if (typeof type === 'function' && (0, $kdqQ0.isHTMLElementClass)(type)) type = (0, $kdqQ0.tagNameOf)(type);
    children = [
        children
    ].flat(Infinity).map(function(node) {
        return node instanceof Object ? new $bFIzj.VNode(node) : node === 0 || node ? new $bFIzj.VNode({
            text: node.toString()
        }) : undefined;
    }).filter(Boolean);
    var commonProps = {
        key: key,
        ref: ref,
        is: is,
        style: style,
        children: children
    };
    return typeof type === 'string' ? new $bFIzj.VNode($gkQP3.__assign($gkQP3.__assign({}, commonProps), {
        tagName: type,
        props: props
    })) : type($gkQP3.__assign($gkQP3.__assign({}, commonProps), props));
}
module.exports.jsxs = $0f5ae2342c6b0e18$var$jsx;
module.exports.jsxDEV = $0f5ae2342c6b0e18$var$jsx;
/**
 * @see {@link https://babeljs.io/docs/babel-plugin-transform-react-jsx#react-automatic-runtime-1}
 */ var $0f5ae2342c6b0e18$var$Fragment = function(_a) {
    var key = _a.key, ref = _a.ref, is = _a.is, style = _a.style, children = _a.children, props = $gkQP3.__rest(_a, [
        "key",
        "ref",
        "is",
        "style",
        "children"
    ]);
    return new $bFIzj.VNode({
        key: key,
        ref: ref,
        is: is,
        props: (0, $kdqQ0.isEmpty)(props) ? undefined : props,
        style: style,
        children: children
    });
};
module.exports.Fragment = $0f5ae2342c6b0e18$var$Fragment;

});
parcelRegister("gkQP3", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $04dbd055bc5edd2b$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $04dbd055bc5edd2b$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $04dbd055bc5edd2b$export$3c9a16f847548506);
$parcel$export(module.exports, "__decorate", () => $04dbd055bc5edd2b$export$29e00dfd3077644b);
$parcel$export(module.exports, "__awaiter", () => $04dbd055bc5edd2b$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $04dbd055bc5edd2b$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $04dbd055bc5edd2b$export$f33643c0debef087);
$parcel$export(module.exports, "__values", () => $04dbd055bc5edd2b$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $04dbd055bc5edd2b$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $04dbd055bc5edd2b$export$1216008129fb82ed);
$parcel$export(module.exports, "__classPrivateFieldGet", () => $04dbd055bc5edd2b$export$d5dcaf168c640c35);
$parcel$export(module.exports, "__classPrivateFieldSet", () => $04dbd055bc5edd2b$export$d40a35129aaff81f);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $04dbd055bc5edd2b$var$extendStatics = function(d, b) {
    $04dbd055bc5edd2b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $04dbd055bc5edd2b$var$extendStatics(d, b);
};
function $04dbd055bc5edd2b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $04dbd055bc5edd2b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $04dbd055bc5edd2b$export$18ce0697a983be9b = function() {
    $04dbd055bc5edd2b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $04dbd055bc5edd2b$export$18ce0697a983be9b.apply(this, arguments);
};
function $04dbd055bc5edd2b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $04dbd055bc5edd2b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $04dbd055bc5edd2b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $04dbd055bc5edd2b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $04dbd055bc5edd2b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $04dbd055bc5edd2b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $04dbd055bc5edd2b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $04dbd055bc5edd2b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $04dbd055bc5edd2b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $04dbd055bc5edd2b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $04dbd055bc5edd2b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $04dbd055bc5edd2b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $04dbd055bc5edd2b$export$45d3717a4c69092e(o, m, p);
}
function $04dbd055bc5edd2b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $04dbd055bc5edd2b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $04dbd055bc5edd2b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($04dbd055bc5edd2b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $04dbd055bc5edd2b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $04dbd055bc5edd2b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $04dbd055bc5edd2b$export$10c90e4f7922046c(v) {
    return this instanceof $04dbd055bc5edd2b$export$10c90e4f7922046c ? (this.v = v, this) : new $04dbd055bc5edd2b$export$10c90e4f7922046c(v);
}
function $04dbd055bc5edd2b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $04dbd055bc5edd2b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $04dbd055bc5edd2b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $04dbd055bc5edd2b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $04dbd055bc5edd2b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $04dbd055bc5edd2b$export$19a8beecd37a4c45 === "function" ? $04dbd055bc5edd2b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $04dbd055bc5edd2b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $04dbd055bc5edd2b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $04dbd055bc5edd2b$var$ownKeys = function(o) {
    $04dbd055bc5edd2b$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $04dbd055bc5edd2b$var$ownKeys(o);
};
function $04dbd055bc5edd2b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $04dbd055bc5edd2b$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $04dbd055bc5edd2b$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $04dbd055bc5edd2b$var$__setModuleDefault(result, mod);
    return result;
}
function $04dbd055bc5edd2b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $04dbd055bc5edd2b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $04dbd055bc5edd2b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $04dbd055bc5edd2b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $04dbd055bc5edd2b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $04dbd055bc5edd2b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $04dbd055bc5edd2b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $04dbd055bc5edd2b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $04dbd055bc5edd2b$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $04dbd055bc5edd2b$export$2e2bcd8739ae039 = {
    __extends: $04dbd055bc5edd2b$export$a8ba968b8961cb8a,
    __assign: $04dbd055bc5edd2b$export$18ce0697a983be9b,
    __rest: $04dbd055bc5edd2b$export$3c9a16f847548506,
    __decorate: $04dbd055bc5edd2b$export$29e00dfd3077644b,
    __param: $04dbd055bc5edd2b$export$d5ad3fd78186038f,
    __esDecorate: $04dbd055bc5edd2b$export$3a84e1ae4e97e9b0,
    __runInitializers: $04dbd055bc5edd2b$export$d831c04e792af3d,
    __propKey: $04dbd055bc5edd2b$export$6a2a36740a146cb8,
    __setFunctionName: $04dbd055bc5edd2b$export$d1a06452d3489bc7,
    __metadata: $04dbd055bc5edd2b$export$f1db080c865becb9,
    __awaiter: $04dbd055bc5edd2b$export$1050f835b63b671e,
    __generator: $04dbd055bc5edd2b$export$67ebef60e6f28a6,
    __createBinding: $04dbd055bc5edd2b$export$45d3717a4c69092e,
    __exportStar: $04dbd055bc5edd2b$export$f33643c0debef087,
    __values: $04dbd055bc5edd2b$export$19a8beecd37a4c45,
    __read: $04dbd055bc5edd2b$export$8d051b38c9118094,
    __spread: $04dbd055bc5edd2b$export$afc72e2116322959,
    __spreadArrays: $04dbd055bc5edd2b$export$6388937ca91ccae8,
    __spreadArray: $04dbd055bc5edd2b$export$1216008129fb82ed,
    __await: $04dbd055bc5edd2b$export$10c90e4f7922046c,
    __asyncGenerator: $04dbd055bc5edd2b$export$e427f37a30a4de9b,
    __asyncDelegator: $04dbd055bc5edd2b$export$bbd80228419bb833,
    __asyncValues: $04dbd055bc5edd2b$export$e3b29a3d6162315f,
    __makeTemplateObject: $04dbd055bc5edd2b$export$4fb47efe1390b86f,
    __importStar: $04dbd055bc5edd2b$export$c21735bcef00d192,
    __importDefault: $04dbd055bc5edd2b$export$da59b14a69baef04,
    __classPrivateFieldGet: $04dbd055bc5edd2b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $04dbd055bc5edd2b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $04dbd055bc5edd2b$export$81fdc39f203e4e04,
    __addDisposableResource: $04dbd055bc5edd2b$export$88ac25d8e944e405,
    __disposeResources: $04dbd055bc5edd2b$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $04dbd055bc5edd2b$export$889dfb5d17574b0b
};

});

parcelRegister("kdqQ0", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $eb79d6f33a4e5d0d$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "toHyphenCase", () => $eb79d6f33a4e5d0d$export$3f34ca2fef821bbd);
$parcel$export(module.exports, "toCamelCase", () => $eb79d6f33a4e5d0d$export$86f54f62aa7a7514);
$parcel$export(module.exports, "encodeBase64", () => $eb79d6f33a4e5d0d$export$8fb536984ec8b4d7);
$parcel$export(module.exports, "DiffStatus", () => $eb79d6f33a4e5d0d$export$2ddabb89308e1a22);
$parcel$export(module.exports, "diffKeys", () => $eb79d6f33a4e5d0d$export$14527669107aa301);
$parcel$export(module.exports, "groupBy", () => $eb79d6f33a4e5d0d$export$3f063810d7bf01bd);
$parcel$export(module.exports, "likeArray", () => $eb79d6f33a4e5d0d$export$b5a4d6f439a5044d);
$parcel$export(module.exports, "isTypedArray", () => $eb79d6f33a4e5d0d$export$b119cc7e1840e59c);
$parcel$export(module.exports, "makeArray", () => $eb79d6f33a4e5d0d$export$7b85fd78dd236198);
$parcel$export(module.exports, "splitArray", () => $eb79d6f33a4e5d0d$export$697c3df919c0e61a);
$parcel$export(module.exports, "countBy", () => $eb79d6f33a4e5d0d$export$1d012a0dff3dab06);
$parcel$export(module.exports, "createAsyncIterator", () => $eb79d6f33a4e5d0d$export$86c18c6347f4a8c4);
$parcel$export(module.exports, "averageOf", () => $eb79d6f33a4e5d0d$export$e1f36757ecda301d);
$parcel$export(module.exports, "parseJSON", () => $eb79d6f33a4e5d0d$export$27924e57e9afff7f);
$parcel$export(module.exports, "isXDomain", () => $eb79d6f33a4e5d0d$export$71e6483fc2b024eb);
$parcel$export(module.exports, "parseURLData", () => $eb79d6f33a4e5d0d$export$eb9b2aadbe449a20);
$parcel$export(module.exports, "buildURLData", () => $eb79d6f33a4e5d0d$export$13397a83aa5915d6);
$parcel$export(module.exports, "XMLNamespace", () => $eb79d6f33a4e5d0d$export$f5a4056b78c72efa);
$parcel$export(module.exports, "templateOf", () => $eb79d6f33a4e5d0d$export$2ee022bbbc550b25);
$parcel$export(module.exports, "elementTypeOf", () => $eb79d6f33a4e5d0d$export$a549dd5cef7f8327);
$parcel$export(module.exports, "isHTMLElementClass", () => $eb79d6f33a4e5d0d$export$8eece510bcb9c62c);
$parcel$export(module.exports, "tagNameOf", () => $eb79d6f33a4e5d0d$export$b8a1af58c024fefd);
$parcel$export(module.exports, "stringifyDOM", () => $eb79d6f33a4e5d0d$export$b0709844452f8b6b);
$parcel$export(module.exports, "getVisibleText", () => $eb79d6f33a4e5d0d$export$be4650432daa84fd);
$parcel$export(module.exports, "importCSS", () => $eb79d6f33a4e5d0d$export$7cd14c57bbb84350);
$parcel$export(module.exports, "scrollTo", () => $eb79d6f33a4e5d0d$export$3f99968195accfaf);
$parcel$export(module.exports, "formToJSON", () => $eb79d6f33a4e5d0d$export$86d7c59254d6a2c9);
$parcel$export(module.exports, "delegate", () => $eb79d6f33a4e5d0d$export$10b1921597150314);
$parcel$export(module.exports, "documentReady", () => $eb79d6f33a4e5d0d$export$3e2b244719956741);
$parcel$export(module.exports, "serviceWorkerUpdate", () => $eb79d6f33a4e5d0d$export$d635d04af3887bbe);
function $eb79d6f33a4e5d0d$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports = {};
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $eb79d6f33a4e5d0d$export$61cc6ed0f143570b;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $eb79d6f33a4e5d0d$export$dd1bc94b04021eeb;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $eb79d6f33a4e5d0d$export$a09f818797e212c4;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $eb79d6f33a4e5d0d$export$170f4e08cad8229d;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $eb79d6f33a4e5d0d$export$2a489b3f92f4996a;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $eb79d6f33a4e5d0d$export$67a6ce548ae77071;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $eb79d6f33a4e5d0d$export$a48f0734ac7c2329;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $eb79d6f33a4e5d0d$export$3f34ca2fef821bbd;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $eb79d6f33a4e5d0d$export$86f54f62aa7a7514;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $eb79d6f33a4e5d0d$export$89912e019eef22aa;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "encodeBase64", function() {
    return $eb79d6f33a4e5d0d$export$8fb536984ec8b4d7;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "decodeBase64", function() {
    return $eb79d6f33a4e5d0d$export$94fdf11bafc8de6b;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $eb79d6f33a4e5d0d$export$1c8ba402144543e5;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $eb79d6f33a4e5d0d$export$2ddabb89308e1a22;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $eb79d6f33a4e5d0d$export$14527669107aa301;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $eb79d6f33a4e5d0d$export$3f063810d7bf01bd;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $eb79d6f33a4e5d0d$export$b5a4d6f439a5044d;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $eb79d6f33a4e5d0d$export$b119cc7e1840e59c;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $eb79d6f33a4e5d0d$export$7b85fd78dd236198;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $eb79d6f33a4e5d0d$export$697c3df919c0e61a;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $eb79d6f33a4e5d0d$export$1d012a0dff3dab06;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $eb79d6f33a4e5d0d$export$e6b5ff3168b5942b;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "clone", function() {
    return $eb79d6f33a4e5d0d$export$9cd59f9826255e47;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "treeFrom", function() {
    return $eb79d6f33a4e5d0d$export$fbc9cd6af26fa64f;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $eb79d6f33a4e5d0d$export$69a3209f1a06c04d;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $eb79d6f33a4e5d0d$export$86c18c6347f4a8c4;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $eb79d6f33a4e5d0d$export$dce9414bed0662c;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $eb79d6f33a4e5d0d$export$271f7c16f175f804;
});
var $eb79d6f33a4e5d0d$var$$6a9944941b4c1893$exports = {};
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$6a9944941b4c1893$exports, "sum", function() {
    return $eb79d6f33a4e5d0d$export$8a63f25cc62965f1;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $eb79d6f33a4e5d0d$export$e1f36757ecda301d;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $eb79d6f33a4e5d0d$export$8e694e1eafd55acb;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $eb79d6f33a4e5d0d$export$57d7c52a66287430;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $eb79d6f33a4e5d0d$export$2b4693832ca3ce16;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $eb79d6f33a4e5d0d$export$5b784e078da1ce6;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $eb79d6f33a4e5d0d$export$17ec9c9f4f23588c;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $eb79d6f33a4e5d0d$export$595dbf49c602a1f;
});
function $eb79d6f33a4e5d0d$export$8a63f25cc62965f1(...data) {
    return data.reduce((sum, item)=>sum + item, 0);
}
function $eb79d6f33a4e5d0d$export$e1f36757ecda301d(...data) {
    return $eb79d6f33a4e5d0d$export$8a63f25cc62965f1(...data) / data.length;
}
function $eb79d6f33a4e5d0d$export$8e694e1eafd55acb(data, sample = false) {
    const average = $eb79d6f33a4e5d0d$export$e1f36757ecda301d(...data);
    const summary = $eb79d6f33a4e5d0d$export$8a63f25cc62965f1(...data.map((item)=>(item - average) ** 2));
    return summary / (data.length - (sample ? 1 : 0));
}
function $eb79d6f33a4e5d0d$export$57d7c52a66287430(data, sample = false) {
    return Math.sqrt($eb79d6f33a4e5d0d$export$8e694e1eafd55acb(data, sample));
}
function $eb79d6f33a4e5d0d$export$2b4693832ca3ce16(...data) {
    return Math.sqrt($eb79d6f33a4e5d0d$export$8a63f25cc62965f1(...data.map((item)=>item ** 2)));
}
function $eb79d6f33a4e5d0d$export$5b784e078da1ce6(raw, length) {
    const text = raw.toFixed(length + 2);
    const offset = text.indexOf('.') + length + 1;
    const cut = (text)=>text.slice(0, offset - (length ? 0 : 1));
    if (!+text.slice(offset)) return cut(text);
    const result = cut((+cut(text) + 10 ** -length).toFixed(length));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
function $eb79d6f33a4e5d0d$export$17ec9c9f4f23588c(raw, length = 2) {
    const text = raw.toFixed(length + 2);
    const floatOffset = text.indexOf('.');
    if (floatOffset < 0) return length ? `${text}.${'0'.repeat(length)}` : text;
    const offset = floatOffset + length + 1;
    const before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    const carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $eb79d6f33a4e5d0d$export$5b784e078da1ce6(raw, length);
    const result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
class $eb79d6f33a4e5d0d$export$595dbf49c602a1f {
    constructor(value){
        this.value = value;
    }
    valueOf() {
        return this.value;
    }
    toShortString(fractionDigits = 2) {
        const { units: units, value: value } = this;
        const { base: base, name: name } = [
            ...units
        ].reverse().find(({ base: base })=>Math.abs(value) >= base) || units[0];
        return `${(value / base).toFixed(fractionDigits)} ${name}`;
    }
    static distanceOf(a, b) {
        return Reflect.construct(this, [
            a - b
        ]);
    }
}
const $eb79d6f33a4e5d0d$export$61cc6ed0f143570b = (value)=>!(value != null) || Number.isNaN(value);
const $eb79d6f33a4e5d0d$export$dd1bc94b04021eeb = (value)=>$eb79d6f33a4e5d0d$export$61cc6ed0f143570b(value) || (typeof value === 'object' ? !Object.keys(value).length : value === '');
const $eb79d6f33a4e5d0d$export$a09f818797e212c4 = (data)=>Object.prototype.toString.call(data).slice(8, -1);
const $eb79d6f33a4e5d0d$export$170f4e08cad8229d = (Sub, Super)=>Sub.prototype instanceof Super;
function $eb79d6f33a4e5d0d$export$2a489b3f92f4996a(target, dataStore, setter) {
    const prototype = Object.getPrototypeOf(target);
    const prototypeProxy = new Proxy(prototype, {
        set: (_, key, value, receiver)=>{
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter?.(key, value);
            return true;
        },
        get: (prototype, key, receiver)=>key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver)
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
const $eb79d6f33a4e5d0d$export$67a6ce548ae77071 = (raw)=>/^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + '', undefined, {
        numeric: true
    }) > 0;
const $eb79d6f33a4e5d0d$export$a48f0734ac7c2329 = (raw)=>raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, 'xx').length;
const $eb79d6f33a4e5d0d$export$3f34ca2fef821bbd = (raw)=>raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, (match, offset)=>`${offset ? '-' : ''}${(match[1] || match[0]).toLowerCase()}`);
const $eb79d6f33a4e5d0d$export$86f54f62aa7a7514 = (raw, large = false)=>raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, (match, offset)=>offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase());
const $eb79d6f33a4e5d0d$export$89912e019eef22aa = ()=>(Date.now() + parseInt((Math.random() + '').slice(2))).toString(36);
const $eb79d6f33a4e5d0d$export$8fb536984ec8b4d7 = (input)=>btoa(String.fromCharCode(...new TextEncoder().encode(input)));
const $eb79d6f33a4e5d0d$export$94fdf11bafc8de6b = (input)=>new TextDecoder().decode(Uint8Array.from(atob(input), (char)=>char.charCodeAt(0)));
const $eb79d6f33a4e5d0d$export$1c8ba402144543e5 = (values, keys)=>Object.fromEntries(values.map((value, index)=>[
            keys[index],
            value
        ]));
var $eb79d6f33a4e5d0d$export$2ddabb89308e1a22 = /*#__PURE__*/ function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
    return DiffStatus;
}({});
function $eb79d6f33a4e5d0d$export$14527669107aa301(oldList, newList) {
    const map = {};
    for (const item of oldList)map[item] = -1;
    for (const item of newList){
        map[item] ||= 0;
        map[item] += 1;
    }
    return {
        map: map,
        group: $eb79d6f33a4e5d0d$export$3f063810d7bf01bd(Object.entries(map), ([key, status])=>status)
    };
}
function $eb79d6f33a4e5d0d$export$b5a4d6f439a5044d(data) {
    if ($eb79d6f33a4e5d0d$export$61cc6ed0f143570b(data)) return false;
    const { length: length } = data;
    return typeof length === 'number' && length >= 0 && ~~length === length;
}
const $eb79d6f33a4e5d0d$export$b119cc7e1840e59c = (data)=>data instanceof Object.getPrototypeOf(Int8Array);
function $eb79d6f33a4e5d0d$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($eb79d6f33a4e5d0d$export$61cc6ed0f143570b(data)) return [];
    if ($eb79d6f33a4e5d0d$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
const $eb79d6f33a4e5d0d$export$697c3df919c0e61a = (array, unitLength)=>array.reduce((grid, item, index)=>{
        (grid[~~(index / unitLength)] ||= [])[index % unitLength] = item;
        return grid;
    }, []);
function $eb79d6f33a4e5d0d$export$3f063810d7bf01bd(list, iteratee) {
    const data = {};
    for (const item of list){
        let keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
        if (!(keys instanceof Array)) keys = [
            keys
        ];
        for (const key of new Set(keys.filter((key)=>key != null)))(data[key] = data[key] || []).push(item);
    }
    return data;
}
function $eb79d6f33a4e5d0d$export$1d012a0dff3dab06(list, iteratee) {
    const group = $eb79d6f33a4e5d0d$export$3f063810d7bf01bd(list, iteratee);
    const sortedList = Object.entries(group).map(([key, { length: length }])=>[
            key,
            length
        ]);
    return Object.fromEntries(sortedList);
}
function $eb79d6f33a4e5d0d$export$e6b5ff3168b5942b(list, subKey, handler) {
    for (const item of list){
        if (handler(item)) return [
            item
        ];
        if (item[subKey] instanceof Array) {
            const result = $eb79d6f33a4e5d0d$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
            if (result.length) return [
                item,
                ...result
            ];
        }
    }
    return [];
}
function $eb79d6f33a4e5d0d$export$9cd59f9826255e47(data) {
    try {
        return globalThis.structuredClone(data);
    } catch  {
        return JSON.parse(JSON.stringify(data));
    }
}
function $eb79d6f33a4e5d0d$export$fbc9cd6af26fa64f(list, idKey = 'id', parentIdKey = 'parentId', childrenKey = 'children') {
    list = $eb79d6f33a4e5d0d$export$9cd59f9826255e47(list);
    const map = {};
    const roots = [];
    for (const item of list)map[item[idKey]] = item;
    for (const item of list){
        const parent = map[item[parentIdKey]];
        if (!parent) roots.push(item);
        else {
            parent[childrenKey] ||= [];
            parent[childrenKey].push(item);
        }
    }
    if (!roots[0]) throw new ReferenceError('No root node is found');
    return roots;
}
function $eb79d6f33a4e5d0d$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function(...data) {
        if (cacheData != null) return cacheData;
        console.trace(`[Cache] execute: ${title}`);
        cacheData = executor.call(this, ()=>cacheData = undefined, ...data);
        Promise.resolve(cacheData).then((data)=>console.log(`[Cache] refreshed: ${title} => ${data}`), (error)=>console.error(`[Cache] failed: ${error?.message || error}`));
        return cacheData;
    };
}
async function* $eb79d6f33a4e5d0d$export$86c18c6347f4a8c4(executor) {
    let { promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers();
    const doneSymbol = Symbol('done'), done = Promise.withResolvers();
    const disposer = executor({
        next: (value)=>resolve(value),
        error: (error)=>{
            reject(error);
            // @ts-ignore
            disposer?.();
        },
        complete: ()=>{
            done.resolve(doneSymbol);
            // @ts-ignore
            disposer?.();
        }
    });
    while(true){
        const value = await Promise.race([
            promise,
            done.promise
        ]);
        if (value === doneSymbol) return;
        yield value;
        ({ promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers());
    }
}
async function* $eb79d6f33a4e5d0d$export$dce9414bed0662c(...sources) {
    var iterators = sources.map((item)=>item());
    while(iterators[0]){
        const dones = [];
        for(let i = 0, iterator; iterator = iterators[i]; i++){
            const { done: done, value: value } = await iterator.next();
            if (!done) yield value;
            else dones.push(i);
        }
        iterators = iterators.filter((_, i)=>!dones.includes(i));
    }
}
class $eb79d6f33a4e5d0d$export$271f7c16f175f804 extends $eb79d6f33a4e5d0d$export$595dbf49c602a1f {
    constructor(...args){
        super(...args), this.units = [
            '',
            'K',
            'M',
            'G',
            'T',
            'P',
            'E',
            'Z',
            'Y'
        ].map((name, i)=>({
                base: 1024 ** i,
                name: name + 'B'
            }));
    }
}
var $eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$exports = {};
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $eb79d6f33a4e5d0d$export$c489aa6f7fd82b1a;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $eb79d6f33a4e5d0d$export$cbd942915f33be50;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $eb79d6f33a4e5d0d$export$9b886f8493244014;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $eb79d6f33a4e5d0d$export$e99cbb807a5bb10d;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $eb79d6f33a4e5d0d$export$7a9a31a911eb9a20;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $eb79d6f33a4e5d0d$export$fca4f8121099df57;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $eb79d6f33a4e5d0d$export$6ce2f08d515512;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $eb79d6f33a4e5d0d$export$951c8378cdfec6e6;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $eb79d6f33a4e5d0d$export$1a4097b876a13bf7;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $eb79d6f33a4e5d0d$export$d9bcbd5e1ff81430;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $eb79d6f33a4e5d0d$export$506c8e8f8c8edda;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $eb79d6f33a4e5d0d$export$3ae94a2503e890a1;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$exports, "changeYear", function() {
    return $eb79d6f33a4e5d0d$export$7e1c707225b48c34;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $eb79d6f33a4e5d0d$export$62ad822b3a5fd9a0;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$exports, "changeDate", function() {
    return $eb79d6f33a4e5d0d$export$9e85258502147ffb;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$exports, "makeDateRange", function() {
    return $eb79d6f33a4e5d0d$export$3c1f2e5bc03748e2;
});
const $eb79d6f33a4e5d0d$export$c489aa6f7fd82b1a = 1000;
const $eb79d6f33a4e5d0d$export$cbd942915f33be50 = $eb79d6f33a4e5d0d$export$c489aa6f7fd82b1a * 60;
const $eb79d6f33a4e5d0d$export$9b886f8493244014 = $eb79d6f33a4e5d0d$export$cbd942915f33be50 * 15;
const $eb79d6f33a4e5d0d$export$e99cbb807a5bb10d = $eb79d6f33a4e5d0d$export$9b886f8493244014 * 4;
const $eb79d6f33a4e5d0d$export$7a9a31a911eb9a20 = $eb79d6f33a4e5d0d$export$e99cbb807a5bb10d * 24;
const $eb79d6f33a4e5d0d$export$fca4f8121099df57 = $eb79d6f33a4e5d0d$export$7a9a31a911eb9a20 * 7;
const $eb79d6f33a4e5d0d$export$6ce2f08d515512 = $eb79d6f33a4e5d0d$export$7a9a31a911eb9a20 * 365;
const $eb79d6f33a4e5d0d$export$951c8378cdfec6e6 = $eb79d6f33a4e5d0d$export$6ce2f08d515512 / 12;
const $eb79d6f33a4e5d0d$export$1a4097b876a13bf7 = $eb79d6f33a4e5d0d$export$951c8378cdfec6e6 * 3;
class $eb79d6f33a4e5d0d$export$d9bcbd5e1ff81430 extends $eb79d6f33a4e5d0d$export$595dbf49c602a1f {
    toShortString(fractionDigits = 0) {
        return super.toShortString(fractionDigits);
    }
    constructor(...args){
        super(...args), this.units = [
            {
                base: $eb79d6f33a4e5d0d$export$c489aa6f7fd82b1a,
                name: 's'
            },
            {
                base: $eb79d6f33a4e5d0d$export$cbd942915f33be50,
                name: 'm'
            },
            {
                base: $eb79d6f33a4e5d0d$export$e99cbb807a5bb10d,
                name: 'H'
            },
            {
                base: $eb79d6f33a4e5d0d$export$7a9a31a911eb9a20,
                name: 'D'
            },
            {
                base: $eb79d6f33a4e5d0d$export$fca4f8121099df57,
                name: 'W'
            },
            {
                base: $eb79d6f33a4e5d0d$export$951c8378cdfec6e6,
                name: 'M'
            },
            {
                base: $eb79d6f33a4e5d0d$export$6ce2f08d515512,
                name: 'Y'
            }
        ];
    }
}
function $eb79d6f33a4e5d0d$export$506c8e8f8c8edda(end, start = new Date()) {
    const timeDistance = $eb79d6f33a4e5d0d$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    const [value, unit] = timeDistance.toShortString().split(/\s+/);
    return {
        distance: +value,
        unit: unit
    };
}
function $eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + '';
    return (template)=>(value.length < template.length ? value.padStart(template.length, '0') : value).slice(-Math.max(template.length, 2));
}
function $eb79d6f33a4e5d0d$export$3ae94a2503e890a1(time = new Date(), template = 'YYYY-MM-DD HH:mm:ss') {
    const date = new Date(time);
    const localDate = new Date(+date - date.getTimezoneOffset() * $eb79d6f33a4e5d0d$export$cbd942915f33be50);
    const [year, month, day, hour, minute, second, millisecond] = localDate.toJSON().split(/\D/);
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $eb79d6f33a4e5d0d$export$7e1c707225b48c34(date, delta) {
    date = new Date(date);
    date.setFullYear(date.getFullYear() + delta);
    return date;
}
function $eb79d6f33a4e5d0d$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    const month = date.getMonth() + delta;
    date = $eb79d6f33a4e5d0d$export$7e1c707225b48c34(date, Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
const $eb79d6f33a4e5d0d$export$9e85258502147ffb = (date, unit, delta)=>unit === $eb79d6f33a4e5d0d$export$6ce2f08d515512 ? $eb79d6f33a4e5d0d$export$7e1c707225b48c34(date, delta) : unit === $eb79d6f33a4e5d0d$export$951c8378cdfec6e6 ? $eb79d6f33a4e5d0d$export$62ad822b3a5fd9a0(date, delta) : new Date(+new Date(date) + delta * unit);
const $eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$var$DateLength2Unit = {
    4: $eb79d6f33a4e5d0d$export$6ce2f08d515512,
    7: $eb79d6f33a4e5d0d$export$951c8378cdfec6e6,
    10: $eb79d6f33a4e5d0d$export$7a9a31a911eb9a20,
    13: $eb79d6f33a4e5d0d$export$e99cbb807a5bb10d,
    16: $eb79d6f33a4e5d0d$export$cbd942915f33be50,
    19: $eb79d6f33a4e5d0d$export$c489aa6f7fd82b1a
};
function $eb79d6f33a4e5d0d$export$3c1f2e5bc03748e2(value) {
    const defaultValue = `2025-01-01T00:00:00.000Z`;
    const startedAt = new Date(value + defaultValue.slice(value.length));
    const endedAt = $eb79d6f33a4e5d0d$export$9e85258502147ffb(startedAt, $eb79d6f33a4e5d0d$var$$f872d8bba1c0f79f$var$DateLength2Unit[value.length], 1);
    return [
        startedAt,
        endedAt
    ];
}
var $eb79d6f33a4e5d0d$var$$ba0e5dc395660a7c$exports = {};
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $eb79d6f33a4e5d0d$export$27924e57e9afff7f;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $eb79d6f33a4e5d0d$export$7ea17d45ecdcf634;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$ba0e5dc395660a7c$exports, "stringifyTextTable", function() {
    return $eb79d6f33a4e5d0d$export$bf304e455230454a;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $eb79d6f33a4e5d0d$export$bb8626e4916f587b;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$ba0e5dc395660a7c$exports, "parseTextTableAsync", function() {
    return $eb79d6f33a4e5d0d$export$88182f6768071c72;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$ba0e5dc395660a7c$exports, "readTextTable", function() {
    return $eb79d6f33a4e5d0d$export$2427785258f88523;
});
function $eb79d6f33a4e5d0d$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === 'string' && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            const date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    const value = parseItem(raw);
    if (typeof value !== 'string' || $eb79d6f33a4e5d0d$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, (key, value)=>parseItem(value));
    } catch  {
        return raw;
    }
}
function $eb79d6f33a4e5d0d$export$7ea17d45ecdcf634(raw) {
    const parsed = $eb79d6f33a4e5d0d$export$27924e57e9afff7f(raw);
    if (typeof parsed !== 'string') return parsed;
    const number = +parsed;
    return Number.isNaN(number) || number + '' !== parsed ? parsed : number;
}
const $eb79d6f33a4e5d0d$export$bf304e455230454a = (data, separator = ',')=>[
        Object.keys(data[0]).join(separator),
        ...data.map((item)=>Object.values(item).map((value)=>JSON.stringify(value)).join(separator))
    ].join('\n');
function $eb79d6f33a4e5d0d$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    const quote = raw[0];
    const index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError(`A ${quote} is missing`);
    return raw.slice(1, index);
}
function $eb79d6f33a4e5d0d$var$$ba0e5dc395660a7c$var$parseRow(row, separator = ',') {
    const list = [];
    do {
        let value;
        if (row[0] === '"' || row[0] === "'") {
            value = $eb79d6f33a4e5d0d$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
            row = row.slice(value.length + 3);
        } else {
            const index = row.indexOf(separator);
            if (index > -1) {
                value = row.slice(0, index);
                row = row.slice(index + 1);
            } else {
                value = row;
                row = '';
            }
        }
        list.push($eb79d6f33a4e5d0d$export$7ea17d45ecdcf634(value.trim()));
    }while (row);
    return list;
}
function $eb79d6f33a4e5d0d$export$bb8626e4916f587b(raw, header, separator = ',') {
    const data = raw.trim().split(/[\r\n]+/).map((row)=>$eb79d6f33a4e5d0d$var$$ba0e5dc395660a7c$var$parseRow(row, separator));
    return !header ? data : data.slice(1).map((row)=>$eb79d6f33a4e5d0d$export$1c8ba402144543e5(row, data[0]));
}
const $eb79d6f33a4e5d0d$export$88182f6768071c72 = async (raw)=>Array.fromAsync($eb79d6f33a4e5d0d$export$2427785258f88523(raw[Symbol.iterator]()));
async function* $eb79d6f33a4e5d0d$var$$ba0e5dc395660a7c$var$characterStream(chunks) {
    for await (const chunk of chunks)yield* chunk;
}
async function* $eb79d6f33a4e5d0d$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator = ',') {
    let inQuote = false;
    let quoteChar = '';
    let prevChar = '';
    let cellBuffer = '';
    let currentRow = [];
    const completeCell = ()=>{
        currentRow.push($eb79d6f33a4e5d0d$export$7ea17d45ecdcf634(cellBuffer.trim()));
        cellBuffer = '';
    };
    for await (const char of chars){
        if (char === '\n' || char === '\r') {
            if (char === '\n' && prevChar === '\r') {
                prevChar = char;
                continue;
            }
            completeCell();
            if (currentRow.length > 1 || currentRow[0]) yield currentRow;
            currentRow = [];
        } else if ((char === '"' || char === "'") && !inQuote && cellBuffer.trim() === '') {
            inQuote = true;
            quoteChar = char;
        } else if (char === quoteChar && inQuote) {
            inQuote = false;
            quoteChar = '';
        } else if (inQuote) cellBuffer += char;
        else if (char === separator) completeCell();
        else cellBuffer += char;
        prevChar = char;
    }
    if (cellBuffer || currentRow.length > 0) {
        completeCell();
        if (currentRow.length > 1 || currentRow[0]) yield currentRow;
    }
}
async function* $eb79d6f33a4e5d0d$export$2427785258f88523(chunks, header, separator = ',') {
    let headerRow;
    let isFirstRow = true;
    const chars = $eb79d6f33a4e5d0d$var$$ba0e5dc395660a7c$var$characterStream(chunks);
    for await (const row of $eb79d6f33a4e5d0d$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator))if (header && isFirstRow) {
        headerRow = row;
        isFirstRow = false;
    } else yield header && headerRow ? $eb79d6f33a4e5d0d$export$1c8ba402144543e5(row, headerRow) : row;
}
var $eb79d6f33a4e5d0d$var$$083124ac4b1a50a0$exports = {};
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $eb79d6f33a4e5d0d$export$71e6483fc2b024eb;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $eb79d6f33a4e5d0d$export$eb9b2aadbe449a20;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $eb79d6f33a4e5d0d$export$13397a83aa5915d6;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $eb79d6f33a4e5d0d$export$fd89523fba250fa4;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $eb79d6f33a4e5d0d$export$504fbde693c1771c;
});
const $eb79d6f33a4e5d0d$export$71e6483fc2b024eb = (URI)=>new URL(URI, document.baseURI).origin !== location.origin;
function $eb79d6f33a4e5d0d$export$eb9b2aadbe449a20(raw = globalThis.location?.search || '', toBuiltIn = true) {
    const rawData = raw.split('#').map((URI)=>{
        const [before, after] = URI.split('?');
        return new URLSearchParams(after || (before.includes('=') ? before : ''));
    }).join('&');
    const data = new URLSearchParams(rawData);
    return Object.fromEntries([
        ...data.keys()
    ].map((key)=>{
        const list = toBuiltIn ? data.getAll(key).map($eb79d6f33a4e5d0d$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
const $eb79d6f33a4e5d0d$var$$083124ac4b1a50a0$var$stringify = (value)=>typeof value === 'string' ? value : $eb79d6f33a4e5d0d$export$b5a4d6f439a5044d(value) ? $eb79d6f33a4e5d0d$export$7b85fd78dd236198(value) + '' : JSON.stringify(value);
function $eb79d6f33a4e5d0d$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    const list = map.map(([key, value])=>!$eb79d6f33a4e5d0d$export$dd1bc94b04021eeb(value) && [
            key,
            $eb79d6f33a4e5d0d$var$$083124ac4b1a50a0$var$stringify(value)
        ]).filter(Boolean);
    return new URLSearchParams(list);
}
const $eb79d6f33a4e5d0d$export$fd89523fba250fa4 = async (URI)=>(await fetch(URI + '')).blob();
const $eb79d6f33a4e5d0d$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $eb79d6f33a4e5d0d$export$504fbde693c1771c(URI) {
    var [_, type, __, base64, data] = $eb79d6f33a4e5d0d$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [];
    data = base64 ? atob(data) : data;
    const aBuffer = Uint8Array.from(data, (char)=>char.charCodeAt(0));
    return new Blob([
        aBuffer
    ], {
        type: type
    });
}
var $eb79d6f33a4e5d0d$var$$d677628cc2ac1e37$exports = {};
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$d677628cc2ac1e37$exports, "parseCookie", function() {
    return $eb79d6f33a4e5d0d$export$d0eaf3e94be578f6;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$d677628cc2ac1e37$exports, "setCookie", function() {
    return $eb79d6f33a4e5d0d$export$110700823644f4a6;
});
const $eb79d6f33a4e5d0d$export$d0eaf3e94be578f6 = (value = globalThis.document?.cookie)=>value ? Object.fromEntries(value.split(/;\s*/).map((item)=>item.split('='))) : {};
function $eb79d6f33a4e5d0d$export$110700823644f4a6(key, value, attributes = {}) {
    const data = `${key}=${value}`, option = Object.entries(attributes).map(([key, value])=>typeof value === 'boolean' ? value ? key : '' : `${key}=${value}`).filter(Boolean).join('; ');
    document.cookie = `${data}; expires=${new Date(0)}`;
    return document.cookie = `${data}; ${option}`;
}
var $eb79d6f33a4e5d0d$var$$50872bf213056663$exports = {};
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $eb79d6f33a4e5d0d$export$1b9ac4d3de3ffd2e;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$50872bf213056663$exports, "makeSHA", function() {
    return $eb79d6f33a4e5d0d$export$d51f3b55e8d1aa73;
});
const $eb79d6f33a4e5d0d$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), (_, cell)=>{
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $eb79d6f33a4e5d0d$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    for (const char of raw)value = value >> 8 & 0x00ffffff ^ $eb79d6f33a4e5d0d$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
    return '0x' + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if (typeof self === 'object') {
    if ('msCrypto' in globalThis) {
        // @ts-ignore
        const { subtle: subtle } = globalThis.crypto = globalThis.msCrypto;
        for(const key in subtle){
            const origin = subtle[key];
            if (origin instanceof Function) subtle[key] = function() {
                const observer = origin.apply(this, arguments);
                return new Promise((resolve, reject)=>{
                    observer.oncomplete = ({ target: target })=>resolve(target.result);
                    observer.onabort = observer.onerror = reject;
                });
            };
        }
    }
    const { crypto: crypto1 } = globalThis;
    if (!crypto1?.subtle && crypto1?.['webkitSubtle']) crypto1.subtle = crypto1['webkitSubtle'];
}
async function $eb79d6f33a4e5d0d$export$d51f3b55e8d1aa73(raw, algorithm = 'SHA-1') {
    const buffer = await crypto.subtle.digest(algorithm, new TextEncoder().encode(raw));
    return Array.from(new Uint8Array(buffer), (byte)=>byte.toString(16).padStart(2, '0')).join('');
}
var $eb79d6f33a4e5d0d$var$$93a3089d2937b23f$exports = {};
var $eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports = {};
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports, "XMLNamespace", function() {
    return $eb79d6f33a4e5d0d$export$f5a4056b78c72efa;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $eb79d6f33a4e5d0d$export$2ee022bbbc550b25;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $eb79d6f33a4e5d0d$export$a549dd5cef7f8327;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $eb79d6f33a4e5d0d$export$8eece510bcb9c62c;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $eb79d6f33a4e5d0d$export$b8a1af58c024fefd;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $eb79d6f33a4e5d0d$export$a2cf0d4bb6e06de4;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $eb79d6f33a4e5d0d$export$d66b332881d9723f;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $eb79d6f33a4e5d0d$export$b0709844452f8b6b;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $eb79d6f33a4e5d0d$export$5118471ee5d5453b;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports, "inViewport", function() {
    return $eb79d6f33a4e5d0d$export$6e196edbcc00e5bc;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $eb79d6f33a4e5d0d$export$be4650432daa84fd;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $eb79d6f33a4e5d0d$export$578e38b4a3e0b255;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $eb79d6f33a4e5d0d$export$7cd14c57bbb84350;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $eb79d6f33a4e5d0d$export$5100419dfae0456d;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $eb79d6f33a4e5d0d$export$28d9d24a8cd0ffc2;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $eb79d6f33a4e5d0d$export$3f99968195accfaf;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $eb79d6f33a4e5d0d$export$eafdbaa868ea9975;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $eb79d6f33a4e5d0d$export$36a0c1ca2ae264fa;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $eb79d6f33a4e5d0d$export$86d7c59254d6a2c9;
});
const $eb79d6f33a4e5d0d$export$f5a4056b78c72efa = {
    html: 'http://www.w3.org/1999/xhtml',
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
const $eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$var$templateMap = {};
function $eb79d6f33a4e5d0d$export$2ee022bbbc550b25(tagName) {
    if ($eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    const spawn = document.createElement('template');
    spawn.innerHTML = `<${tagName} />`;
    return $eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $eb79d6f33a4e5d0d$export$a549dd5cef7f8327(tagName) {
    if (tagName.includes('-')) return 'html';
    const [prefix, localName] = tagName.split(':');
    if (localName) return prefix === 'html' ? 'html' : 'xml';
    const node = $eb79d6f33a4e5d0d$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? 'html' : 'xml';
}
const $eb79d6f33a4e5d0d$export$8eece510bcb9c62c = (Class)=>$eb79d6f33a4e5d0d$export$170f4e08cad8229d(Class, HTMLElement);
const $eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $eb79d6f33a4e5d0d$export$b8a1af58c024fefd(Class) {
    const name = $eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var { tagName: tagName } = new Class();
    $eb79d6f33a4e5d0d$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $eb79d6f33a4e5d0d$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ const ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                'sizes'
            ]
        ],
        [
            HTMLIFrameElement,
            [
                'sandbox'
            ]
        ],
        [
            HTMLObjectElement,
            [
                'form'
            ]
        ],
        [
            HTMLInputElement,
            [
                'form',
                'list'
            ]
        ],
        [
            HTMLButtonElement,
            [
                'form'
            ]
        ],
        [
            HTMLSelectElement,
            [
                'form'
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                'form'
            ]
        ],
        [
            HTMLOutputElement,
            [
                'form'
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                'form'
            ]
        ]
    ];
    const template = $eb79d6f33a4e5d0d$export$2ee022bbbc550b25(tagName);
    for (const [Class, keys] of ReadOnly_Properties)if (template instanceof Class && keys.includes(propertyName)) return true;
    return false;
}
function $eb79d6f33a4e5d0d$export$d66b332881d9723f(HTML) {
    const spawn = document.createElement('template');
    spawn.innerHTML = HTML;
    return [
        ...spawn.content.childNodes
    ].map((node)=>{
        node.remove();
        return node;
    });
}
const $eb79d6f33a4e5d0d$export$b0709844452f8b6b = (node)=>new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, '');
function* $eb79d6f33a4e5d0d$export$5118471ee5d5453b(root, type) {
    const children = [
        ...root.childNodes
    ];
    if ($eb79d6f33a4e5d0d$export$dd1bc94b04021eeb(type) || type === root.nodeType) yield root;
    for (const node of children)yield* $eb79d6f33a4e5d0d$export$5118471ee5d5453b(node, type);
}
function $eb79d6f33a4e5d0d$export$6e196edbcc00e5bc(element) {
    const { left: left, top: top } = element.getBoundingClientRect();
    return document.elementFromPoint(left, top) === element;
}
function $eb79d6f33a4e5d0d$export$be4650432daa84fd(root) {
    var text = '';
    for (const { nodeType: nodeType, parentElement: parentElement, nodeValue: nodeValue } of $eb79d6f33a4e5d0d$export$5118471ee5d5453b(root))if (nodeType === Node.TEXT_NODE && parentElement.getAttribute('aria-hidden') !== 'true') {
        const { width: width, height: height } = parentElement.getBoundingClientRect();
        if (width && height) text += nodeValue.trim().replace(/\s+/g, ' ');
    }
    return text;
}
function $eb79d6f33a4e5d0d$export$578e38b4a3e0b255({ offsetWidth: offsetWidth, children: children }, pageHeight = 841.89, pageWidth = 595.28) {
    const scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return [
        ...children
    ].reduce((pages, node)=>{
        var { offsetTop: top, offsetHeight: height } = node;
        top += offset;
        var bottom = top + height;
        const bottomOffset = bottom / scrollHeight;
        const topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        (pages[bottomIndex] ||= []).push(node);
        return pages;
    }, []);
}
function $eb79d6f33a4e5d0d$export$7cd14c57bbb84350(URI, { alternate: alternate, ...options } = {}) {
    const style = [
        ...document.styleSheets
    ].find(({ href: href })=>href === URI);
    if (style) return Promise.resolve(style);
    const link = document.createElement('link');
    return new Promise((resolve, reject)=>{
        link.onload = ()=>resolve(link.sheet);
        link.onerror = (_1, _2, _3, _4, error)=>reject(error);
        Object.assign(link, options);
        link.rel = (alternate ? 'alternate ' : '') + 'stylesheet';
        link.href = URI;
        document.head.append(link);
    });
}
function $eb79d6f33a4e5d0d$export$5100419dfae0456d(data, depth = 0, indent = '    ') {
    const padding = indent.repeat(depth);
    return Object.entries(data).map(([key, value])=>typeof value !== 'object' ? `${padding}${$eb79d6f33a4e5d0d$export$3f34ca2fef821bbd(key)}: ${value};` : `${padding}${key} {
${$eb79d6f33a4e5d0d$export$5100419dfae0456d(value, depth + 1, indent)}
${padding}}`).join('\n');
}
function $eb79d6f33a4e5d0d$export$28d9d24a8cd0ffc2(...nodes) {
    const fragment = document.createDocumentFragment();
    fragment.append(...nodes);
    for (const node of $eb79d6f33a4e5d0d$export$5118471ee5d5453b(fragment))if (![
        1,
        3,
        11
    ].includes(node.nodeType) || [
        'meta',
        'title',
        'link',
        'script'
    ].includes(node.nodeName.toLowerCase())) node.replaceWith(...node.childNodes);
    const selection = globalThis.getSelection();
    if (!selection) return;
    const range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $eb79d6f33a4e5d0d$export$3f99968195accfaf(selector, root, align, justify) {
    const [_, ID] = /^#(.+)/.exec(selector) || [];
    if (ID === 'top') window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
    else (root || document).querySelector(ID ? `[id="${ID}"]` : selector)?.scrollIntoView({
        behavior: 'smooth',
        block: align,
        inline: justify
    });
}
const $eb79d6f33a4e5d0d$export$eafdbaa868ea9975 = (box, handler, depth = 6)=>Array.from(box.querySelectorAll(Array.from(new Array(depth), (_, index)=>`h${++index}`) + ''), (header)=>{
        new IntersectionObserver(([item])=>{
            if (!item.isIntersecting) return;
            const target = item.target;
            handler({
                target: target,
                links: [
                    ...target.ownerDocument.querySelectorAll(`[href="#${target.id}"]`)
                ]
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, '-');
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
function $eb79d6f33a4e5d0d$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === 'visible' ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(([{ isIntersecting: isIntersecting }])=>change(isIntersecting ? last | 2 : last & 1)).observe(root);
    document.addEventListener('visibilitychange', ()=>change(document.visibilityState === 'visible' ? last | 1 : last & 2));
}
function $eb79d6f33a4e5d0d$export$86d7c59254d6a2c9(form) {
    const { elements: elements } = form, data = {};
    for (const field of elements){
        let { name: name, value: value, checked: checked, defaultValue: defaultValue, selectedOptions: selectedOptions, files: files } = field;
        const type = field.type;
        if (!name || value === '') continue;
        const box = type !== 'fieldset' && field.closest('fieldset');
        if (box && box !== form) continue;
        let parsedValue = value;
        switch(type){
            case 'radio':
            case 'checkbox':
                if (checked) parsedValue = !defaultValue || $eb79d6f33a4e5d0d$export$7ea17d45ecdcf634(defaultValue);
                else if ($eb79d6f33a4e5d0d$export$b5a4d6f439a5044d(elements.namedItem(name))) continue;
                else parsedValue = false;
                break;
            case 'select-multiple':
                parsedValue = Array.from(selectedOptions, ({ value: value })=>$eb79d6f33a4e5d0d$export$7ea17d45ecdcf634(value));
                break;
            case 'fieldset':
                parsedValue = $eb79d6f33a4e5d0d$export$86d7c59254d6a2c9(field);
                break;
            case 'file':
                parsedValue = files && Array.from(files);
                break;
            case 'date':
            case 'datetime-local':
            case 'month':
            case 'hidden':
            case 'number':
            case 'range':
            case 'select-one':
                parsedValue = $eb79d6f33a4e5d0d$export$7ea17d45ecdcf634(value);
        }
        if (name in data) data[name] = [].concat(data[name], parsedValue);
        else data[name] = !(parsedValue instanceof Array) || !$eb79d6f33a4e5d0d$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
    }
    return data;
}
var $eb79d6f33a4e5d0d$var$$bb23e0c794fefbef$exports = {};
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $eb79d6f33a4e5d0d$export$e772c8ff12451969;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $eb79d6f33a4e5d0d$export$57207d71b8c929c8;
});
function $eb79d6f33a4e5d0d$export$e772c8ff12451969(seconds = 1) {
    return new Promise((resolve)=>setTimeout(resolve, seconds * 1000));
}
function $eb79d6f33a4e5d0d$export$57207d71b8c929c8(executor, seconds = 1) {
    var stop = false;
    (async ()=>{
        while(!stop){
            const result = executor();
            if (result instanceof Promise) await result;
            await $eb79d6f33a4e5d0d$export$e772c8ff12451969(seconds);
        }
    })();
    return ()=>stop = true;
}
var $eb79d6f33a4e5d0d$var$$19ed8aeb7905a045$exports = {};
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $eb79d6f33a4e5d0d$export$10b1921597150314;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $eb79d6f33a4e5d0d$export$3e2b244719956741;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $eb79d6f33a4e5d0d$export$1d1d2ed6b55cf67f;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $eb79d6f33a4e5d0d$export$2155c0b5a4b77fb8;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $eb79d6f33a4e5d0d$export$9d97473344489dfc;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $eb79d6f33a4e5d0d$export$d635d04af3887bbe;
});
function $eb79d6f33a4e5d0d$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
const $eb79d6f33a4e5d0d$export$3e2b244719956741 = typeof window !== 'undefined' ? new Promise((resolve)=>{
    function done() {
        document?.removeEventListener('DOMContentLoaded', done);
        window.removeEventListener('load', done);
        resolve();
    }
    document?.addEventListener('DOMContentLoaded', done);
    window.addEventListener('load', done);
    setTimeout(function check() {
        document?.readyState === 'complete' ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $eb79d6f33a4e5d0d$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise((resolve, reject)=>{
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + 'end', end);
            element.removeEventListener(scope + 'cancel', cancel);
        }
        element.addEventListener(scope + 'end', end);
        element.addEventListener(scope + 'cancel', cancel);
    });
}
function $eb79d6f33a4e5d0d$export$2155c0b5a4b77fb8(handlers) {
    async function server({ data: { type: type, id: id, ...data }, source: source, origin: origin }) {
        var result = handlers[type]?.(data);
        if (result instanceof Promise) result = await result;
        // @ts-ignore
        source.postMessage({
            ...result,
            id: id
        }, origin);
    }
    globalThis.addEventListener('message', server);
    return ()=>globalThis.removeEventListener('message', server);
}
function $eb79d6f33a4e5d0d$export$9d97473344489dfc(target, origin = '*') {
    return (type, data)=>new Promise((resolve)=>{
            const UID = $eb79d6f33a4e5d0d$export$89912e019eef22aa();
            function handler({ data: { id: id, ...data } }) {
                if (id !== UID) return;
                resolve(data);
                globalThis.removeEventListener('message', handler);
            }
            globalThis.addEventListener('message', handler);
            // @ts-ignore
            target.postMessage({
                id: UID,
                type: type,
                ...data
            }, origin);
        });
}
function $eb79d6f33a4e5d0d$export$d635d04af3887bbe(registration) {
    return new Promise((resolve)=>{
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = ()=>registration.installing?.addEventListener('statechange', function() {
                if (this.state === 'installed' && navigator.serviceWorker.controller) resolve(this);
            });
    });
}
var $eb79d6f33a4e5d0d$var$$7a08303ce13c49c5$exports = {};
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $eb79d6f33a4e5d0d$export$1b88f6b6d432a52a;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $eb79d6f33a4e5d0d$export$b70f6380221b1350;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $eb79d6f33a4e5d0d$export$75d6cbe4503e149;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $eb79d6f33a4e5d0d$export$b2618d51188815c2;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $eb79d6f33a4e5d0d$export$490814474ddbb428;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $eb79d6f33a4e5d0d$export$3ea201dffb50dfef;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $eb79d6f33a4e5d0d$export$d1012c7198c6b460;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $eb79d6f33a4e5d0d$export$a35a418b7b17958e;
});
class $eb79d6f33a4e5d0d$export$1b88f6b6d432a52a {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
    get length() {
        const { from: from, to: to } = this;
        return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - from.z, 2) : 0));
    }
    get direction() {
        const { from: from, to: to } = this;
        const XD = to.x - from.x, YD = to.y - from.y, ZD = to.z - from.z;
        const XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
        switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
            case XL:
                return XD > 0 ? 'right' : 'left';
            case YL:
                return YD > 0 ? 'forward' : 'backward';
            case ZL:
                return ZD > 0 ? 'up' : 'down';
        }
    }
}
function $eb79d6f33a4e5d0d$export$b70f6380221b1350(from, to, threshold = parseInt(getComputedStyle(document.body).fontSize) * 6) {
    const vector = new $eb79d6f33a4e5d0d$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !getSelection()?.toString().trim()) return vector;
}
function $eb79d6f33a4e5d0d$export$75d6cbe4503e149(type, element) {
    const { transitionDuration: transitionDuration, animationDuration: animationDuration } = getComputedStyle(element);
    const duration = type === 'animation' ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === 'ms' ? 1 : 1000);
}
function $eb79d6f33a4e5d0d$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $eb79d6f33a4e5d0d$export$1d1d2ed6b55cf67f(type, element).catch((event)=>Promise.resolve(event)),
        new Promise((resolve)=>setTimeout(resolve, $eb79d6f33a4e5d0d$export$75d6cbe4503e149(type, element)))
    ]);
}
function $eb79d6f33a4e5d0d$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    const end = $eb79d6f33a4e5d0d$export$b2618d51188815c2(type, element);
    return new Promise((resolve)=>requestAnimationFrame(()=>{
            element.classList.add(className);
            end.then(resolve);
        }));
}
async function $eb79d6f33a4e5d0d$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    const end = $eb79d6f33a4e5d0d$export$b2618d51188815c2(type, element);
    element.classList.remove(className);
    await end;
    if (remove) element.remove();
    else element.style.display = 'none';
}
function $eb79d6f33a4e5d0d$export$490814474ddbb428(element, className, display = 'block') {
    return $eb79d6f33a4e5d0d$var$$7a08303ce13c49c5$var$fadeIn('transition', element, className, display);
}
function $eb79d6f33a4e5d0d$export$3ea201dffb50dfef(element, className, display = 'block') {
    return $eb79d6f33a4e5d0d$var$$7a08303ce13c49c5$var$fadeIn('animation', element, className, display);
}
function $eb79d6f33a4e5d0d$export$d1012c7198c6b460(element, className, remove) {
    return $eb79d6f33a4e5d0d$var$$7a08303ce13c49c5$var$fadeOut('transition', element, className, remove);
}
function $eb79d6f33a4e5d0d$export$a35a418b7b17958e(element, className, remove) {
    return $eb79d6f33a4e5d0d$var$$7a08303ce13c49c5$var$fadeOut('animation', element, className, remove);
}
var $eb79d6f33a4e5d0d$var$$69bd9f0117925302$exports = {};
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$69bd9f0117925302$exports, "describe", function() {
    return $eb79d6f33a4e5d0d$export$cd5450f3a47e3789;
});
$eb79d6f33a4e5d0d$var$$parcel$export($eb79d6f33a4e5d0d$var$$69bd9f0117925302$exports, "it", function() {
    return $eb79d6f33a4e5d0d$export$3486a10f30cf1ee4;
});
async function $eb79d6f33a4e5d0d$export$cd5450f3a47e3789(title, cases) {
    console.log(title);
    console.time(title);
    await cases();
    console.timeEnd(title);
}
async function $eb79d6f33a4e5d0d$export$3486a10f30cf1ee4(title, userCase, secondsOut = 3) {
    title = '    ' + title;
    console.time(title);
    const expect = (status)=>{
        const assert = typeof status === 'function' ? status : undefined;
        status = assert?.() ?? status;
        if (!status) throw new Error(`Assertion failed: ${title}\n\n${assert || ''}`);
    };
    const timeOut = ()=>$eb79d6f33a4e5d0d$export$e772c8ff12451969(secondsOut).then(()=>Promise.reject(new RangeError('Timed out')));
    try {
        return await Promise.race([
            userCase(expect),
            timeOut()
        ]);
    } finally{
        console.timeEnd(title);
    }
}

});

parcelRegister("bFIzj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VNode = module.exports.VNodeMeta = void 0;

var $gkQP3 = parcelRequire("gkQP3");

var $bkZKU = parcelRequire("bkZKU");

var $kdqQ0 = parcelRequire("kdqQ0");

var $3Ju3H = parcelRequire("3Ju3H");
var $87f6186cfee51fcb$var$VNodeMeta = /** @class */ function() {
    function VNodeMeta() {
        this.children = [];
    }
    return VNodeMeta;
}();
module.exports.VNodeMeta = $87f6186cfee51fcb$var$VNodeMeta;
var $87f6186cfee51fcb$var$VNode = /** @class */ function(_super) {
    $gkQP3.__extends(VNode, _super);
    function VNode(_b) {
        var e_1, _c, _d, e_2, _e;
        var _this = this;
        var children = _b.children, meta = $gkQP3.__rest(_b, [
            "children"
        ]);
        _this = _super.call(this) || this;
        _this.children = [];
        Object.assign(_this, meta);
        try {
            for(var _f = $gkQP3.__values(children || []), _g = _f.next(); !_g.done; _g = _f.next()){
                var vNode = _g.value;
                (_d = _this.children).push.apply(_d, $gkQP3.__spreadArray([], $gkQP3.__read(_a.isFragment(vNode) ? vNode.children || [] : [
                    vNode
                ]), false));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        try {
            for(var _h = $gkQP3.__values(_this.children), _j = _h.next(); !_j.done; _j = _h.next()){
                var child = _j.value;
                child.parent = _this;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_j && !_j.done && (_e = _h.return)) _e.call(_h);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        var tagName = meta.tagName, is = meta.is, props = meta.props;
        if (!tagName && !(props === null || props === void 0 ? void 0 : props.className) && !is) return _this;
        _this.selector = [
            tagName === null || tagName === void 0 ? void 0 : tagName.toLowerCase(),
            (props === null || props === void 0 ? void 0 : props.className) && ".".concat(props.className.trim().replace(/\s+/, '.')),
            is && "[is=\"".concat(is, "\"]")
        ].filter(Boolean).join('');
        return _this;
    }
    VNode.prototype.walkUp = function() {
        var current;
        return $gkQP3.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    current = this;
                    _b.label = 1;
                case 1:
                    if (!(current = current.parent)) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        current
                    ];
                case 2:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    VNode.prototype.namespaceOf = function(tagName) {
        var e_3, _b;
        if ($kdqQ0.XMLNamespace[tagName]) return $kdqQ0.XMLNamespace[tagName];
        try {
            for(var _c = $gkQP3.__values(this.walkUp()), _d = _c.next(); !_d.done; _d = _c.next()){
                var namespace = _d.value.namespace;
                if (namespace) return namespace;
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return $kdqQ0.XMLNamespace.html;
    };
    VNode.prototype.createDOM = function(document) {
        if (document === void 0) document = globalThis.document;
        var _b = this, tagName = _b.tagName, is = _b.is, text = _b.text;
        return this.node = text ? document.createTextNode(text) : !tagName ? document.createDocumentFragment() : document.createElementNS(this.namespace || (this.namespace = this.namespaceOf(tagName)), tagName, {
            is: is
        });
    };
    VNode.prototype.toJSON = function() {
        var _b = this, key = _b.key, text = _b.text, selector = _b.selector, namespace = _b.namespace, tagName = _b.tagName, is = _b.is, props = _b.props, style = _b.style, children = _b.children;
        return JSON.parse(JSON.stringify({
            key: key,
            text: text,
            selector: selector,
            namespace: namespace,
            tagName: tagName,
            is: is,
            props: props,
            style: style,
            children: children
        }));
    };
    VNode.prototype.generateElementXML = function() {
        var _b, tagName, props, style, children, node, currentDocument, body, shadowRoots, innerHTML, restProps, _c, _d, _e, _i, key, _f, _g, _h, _j, key, children_1, children_1_1, child, e_4_1;
        var e_4, _k;
        return $gkQP3.__generator(this, function(_l) {
            switch(_l.label){
                case 0:
                    _b = this, tagName = _b.tagName, props = _b.props, style = _b.style, children = _b.children, node = _b.node;
                    if (!(tagName.includes('-') && (0, $kdqQ0.elementTypeOf)(tagName) === 'html')) return [
                        3 /*break*/ ,
                        2
                    ];
                    currentDocument = (node === null || node === void 0 ? void 0 : node.ownerDocument) || globalThis.document;
                    body = currentDocument.implementation.createHTMLDocument().body;
                    new $3Ju3H.DOMRenderer().render(this, body);
                    currentDocument.importNode(body, true);
                    shadowRoots = $gkQP3.__spreadArray([], $gkQP3.__read((0, $bkZKU.findShadowRoots)(body)), false);
                    return [
                        4 /*yield*/ ,
                        body.getHTML({
                            serializableShadowRoots: true,
                            shadowRoots: shadowRoots
                        })
                    ];
                case 1:
                    _l.sent();
                    return [
                        3 /*break*/ ,
                        29
                    ];
                case 2:
                    innerHTML = props.innerHTML, restProps = $gkQP3.__rest(props, [
                        "innerHTML"
                    ]);
                    return [
                        4 /*yield*/ ,
                        "<".concat(tagName)
                    ];
                case 3:
                    _l.sent();
                    _c = restProps;
                    _d = [];
                    for(_e in _c)_d.push(_e);
                    _i = 0;
                    _l.label = 4;
                case 4:
                    if (!(_i < _d.length)) return [
                        3 /*break*/ ,
                        7
                    ];
                    _e = _d[_i];
                    if (!(_e in _c)) return [
                        3 /*break*/ ,
                        6
                    ];
                    key = _e;
                    return [
                        4 /*yield*/ ,
                        " ".concat(_a.propsMap[key] || key, "=\"").concat(restProps[key], "\"")
                    ];
                case 5:
                    _l.sent();
                    _l.label = 6;
                case 6:
                    _i++;
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 7:
                    if (!style) return [
                        3 /*break*/ ,
                        14
                    ];
                    return [
                        4 /*yield*/ ,
                        " style=\""
                    ];
                case 8:
                    _l.sent();
                    _f = style;
                    _g = [];
                    for(_h in _f)_g.push(_h);
                    _j = 0;
                    _l.label = 9;
                case 9:
                    if (!(_j < _g.length)) return [
                        3 /*break*/ ,
                        12
                    ];
                    _h = _g[_j];
                    if (!(_h in _f)) return [
                        3 /*break*/ ,
                        11
                    ];
                    key = _h;
                    return [
                        4 /*yield*/ ,
                        "".concat((0, $kdqQ0.toHyphenCase)(key), ":").concat(style[key], ";")
                    ];
                case 10:
                    _l.sent();
                    _l.label = 11;
                case 11:
                    _j++;
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 12:
                    return [
                        4 /*yield*/ ,
                        "\""
                    ];
                case 13:
                    _l.sent();
                    _l.label = 14;
                case 14:
                    if (!innerHTML) return [
                        3 /*break*/ ,
                        16
                    ];
                    return [
                        4 /*yield*/ ,
                        ">".concat(innerHTML, "</").concat(tagName, ">")
                    ];
                case 15:
                    _l.sent();
                    return [
                        3 /*break*/ ,
                        29
                    ];
                case 16:
                    if (!children[0]) return [
                        3 /*break*/ ,
                        27
                    ];
                    return [
                        4 /*yield*/ ,
                        '>'
                    ];
                case 17:
                    _l.sent();
                    _l.label = 18;
                case 18:
                    _l.trys.push([
                        18,
                        23,
                        24,
                        25
                    ]);
                    children_1 = $gkQP3.__values(children), children_1_1 = children_1.next();
                    _l.label = 19;
                case 19:
                    if (!!children_1_1.done) return [
                        3 /*break*/ ,
                        22
                    ];
                    child = children_1_1.value;
                    return [
                        5 /*yield**/ ,
                        $gkQP3.__values(child.generateXML())
                    ];
                case 20:
                    _l.sent();
                    _l.label = 21;
                case 21:
                    children_1_1 = children_1.next();
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 22:
                    return [
                        3 /*break*/ ,
                        25
                    ];
                case 23:
                    e_4_1 = _l.sent();
                    e_4 = {
                        error: e_4_1
                    };
                    return [
                        3 /*break*/ ,
                        25
                    ];
                case 24:
                    try {
                        if (children_1_1 && !children_1_1.done && (_k = children_1.return)) _k.call(children_1);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 25:
                    return [
                        4 /*yield*/ ,
                        "</".concat(tagName, ">")
                    ];
                case 26:
                    _l.sent();
                    return [
                        3 /*break*/ ,
                        29
                    ];
                case 27:
                    return [
                        4 /*yield*/ ,
                        tagName === 'script' ? '></script>' : ' />'
                    ];
                case 28:
                    _l.sent();
                    _l.label = 29;
                case 29:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    VNode.prototype.generateXML = function() {
        var mode, _b, _c, child, e_5_1;
        var e_5, _d;
        return $gkQP3.__generator(this, function(_e) {
            switch(_e.label){
                case 0:
                    if (!_a.isFragment(this)) return [
                        3 /*break*/ ,
                        14
                    ];
                    return [
                        4 /*yield*/ ,
                        '<template'
                    ];
                case 1:
                    _e.sent();
                    mode = (this.node || {}).mode;
                    if (!mode) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        " shadowrootmode=\"".concat(mode, "\"")
                    ];
                case 2:
                    _e.sent();
                    _e.label = 3;
                case 3:
                    return [
                        4 /*yield*/ ,
                        '>'
                    ];
                case 4:
                    _e.sent();
                    _e.label = 5;
                case 5:
                    _e.trys.push([
                        5,
                        10,
                        11,
                        12
                    ]);
                    _b = $gkQP3.__values(this.children), _c = _b.next();
                    _e.label = 6;
                case 6:
                    if (!!_c.done) return [
                        3 /*break*/ ,
                        9
                    ];
                    child = _c.value;
                    return [
                        5 /*yield**/ ,
                        $gkQP3.__values(child.generateXML())
                    ];
                case 7:
                    _e.sent();
                    _e.label = 8;
                case 8:
                    _c = _b.next();
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 9:
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 10:
                    e_5_1 = _e.sent();
                    e_5 = {
                        error: e_5_1
                    };
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 11:
                    try {
                        if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                    } finally{
                        if (e_5) throw e_5.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 12:
                    return [
                        4 /*yield*/ ,
                        '</template>'
                    ];
                case 13:
                    _e.sent();
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 14:
                    if (!(this.text != null)) return [
                        3 /*break*/ ,
                        16
                    ];
                    return [
                        4 /*yield*/ ,
                        this.text
                    ];
                case 15:
                    _e.sent();
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 16:
                    return [
                        5 /*yield**/ ,
                        $gkQP3.__values(this.generateElementXML())
                    ];
                case 17:
                    _e.sent();
                    _e.label = 18;
                case 18:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    VNode.isFragment = function(_b) {
        var key = _b.key, node = _b.node, children = _b.children, rest = $gkQP3.__rest(_b, [
            "key",
            "node",
            "children"
        ]);
        for(var key_1 in rest)if (!(0, $kdqQ0.isEmpty)(rest[key_1])) return false;
        return true;
    };
    VNode.fromDOM = function(node) {
        var _this = this;
        if (node instanceof Text) return new _a({
            node: node,
            text: node.nodeValue
        });
        if (!(node instanceof Element)) return new _a({
            node: node
        });
        var _b = node, namespaceURI = _b.namespaceURI, tagName = _b.tagName, attributes = _b.attributes, style = _b.style, childNodes = _b.childNodes;
        var vNode = {
            node: node,
            namespace: namespaceURI,
            tagName: tagName.toLowerCase(),
            is: node.getAttribute('is')
        };
        var props = Array.from(attributes, function(_b) {
            var name = _b.name, value = _b.value;
            return name !== 'style' && [
                _this.attrsMap[name] || name,
                value
            ];
        }).filter(Boolean);
        if (props[0]) vNode.props = Object.fromEntries(props);
        var styles = Array.from(style, function(key) {
            return [
                key,
                style[key]
            ];
        });
        if (styles[0]) vNode.style = Object.fromEntries(styles);
        var children = Array.from(childNodes, function(node) {
            return _a.fromDOM(node);
        });
        if (children[0]) vNode.children = children;
        return new _a(vNode);
    };
    var _a;
    _a = VNode;
    VNode.propsMap = {
        httpEquiv: 'http-equiv',
        className: 'class',
        htmlFor: 'for'
    };
    VNode.attrsMap = Object.fromEntries(Object.entries(_a.propsMap).map(function(item) {
        return item.reverse();
    }));
    return VNode;
}($87f6186cfee51fcb$var$VNodeMeta);
module.exports.VNode = $87f6186cfee51fcb$var$VNode;

});
parcelRegister("bkZKU", function(module, exports) {
var $8411775311bc7bc8$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $8411775311bc7bc8$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $8411775311bc7bc8$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $8411775311bc7bc8$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
(function(factory) {
    if (typeof module.exports === "object") {
        var v = factory(undefined, module.exports);
        if (v !== undefined) module.exports = v;
    } else if (typeof define === "function" && define.amd) define([
        "require",
        "exports"
    ], factory);
})(function(require1, exports1) {
    "use strict";
    var _a, _b, _c, _d;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.encodeHTMLEntities = void 0;
    exports1.findShadowRoots = findShadowRoots;
    exports1.generateHTML = generateHTML;
    exports1.getHTML = getHTML;
    exports1.attachDeclarativeShadowRoots = attachDeclarativeShadowRoots;
    exports1.setHTMLUnsafe = setHTMLUnsafe;
    exports1.parseHTMLUnsafe = parseHTMLUnsafe;
    var xmlSerializer = new XMLSerializer(), attachShadow = HTMLElement.prototype.attachShadow, shadowDOMs = new WeakMap();
    HTMLElement.prototype.attachShadow = function(options) {
        var shadowRoot = attachShadow.call(this, options);
        shadowDOMs.set(this, shadowRoot);
        return shadowRoot;
    };
    function findShadowRoots(root) {
        var walker, currentNode, shadowRoot;
        return $8411775311bc7bc8$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
                        acceptNode: function(node) {
                            return node instanceof HTMLElement ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
                        }
                    });
                    currentNode = null;
                    _a.label = 1;
                case 1:
                    if (!(currentNode = walker.nextNode())) return [
                        3 /*break*/ ,
                        5
                    ];
                    shadowRoot = shadowDOMs.get(currentNode);
                    if (!shadowRoot) return [
                        3 /*break*/ ,
                        4
                    ];
                    return [
                        4 /*yield*/ ,
                        shadowRoot
                    ];
                case 2:
                    _a.sent();
                    return [
                        5 /*yield**/ ,
                        $8411775311bc7bc8$var$__values(findShadowRoots(shadowRoot))
                    ];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    }
    /**
     * @see {@link https://stackoverflow.com/a/18750001}
     *
     * Posted by Chris Baker, modified by community. See post 'Timeline' for change history
     *
     * @license CC-BY-SA-4.0
     */ var encodeHTMLEntities = function(raw) {
        return raw.replace(/[\u00A0-\u9999<>'"&]/g, function(char) {
            return "&#" + char.charCodeAt(0) + ";";
        });
    };
    exports1.encodeHTMLEntities = encodeHTMLEntities;
    function generateHTML(root, _a) {
        var walker, currentNode, tagName, attributes, shadowRoot, shadowRootHTML, nextSibling, parentElement;
        var _b = _a === void 0 ? {} : _a, serializableShadowRoots = _b.serializableShadowRoots, shadowRoots = _b.shadowRoots;
        return $8411775311bc7bc8$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    shadowRoots = (shadowRoots === null || shadowRoots === void 0 ? void 0 : shadowRoots.filter(Boolean)) || [];
                    if (!(!serializableShadowRoots || !shadowRoots[0])) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        root.innerHTML
                    ];
                case 1:
                    _c.sent();
                    return [
                        2 /*return*/ 
                    ];
                case 2:
                    walker = document.createTreeWalker(root, NodeFilter.SHOW_ALL, {
                        acceptNode: function(node) {
                            return node === root || node instanceof SVGElement ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
                        }
                    });
                    currentNode = null;
                    _c.label = 3;
                case 3:
                    if (!(currentNode = walker.nextNode())) return [
                        3 /*break*/ ,
                        19
                    ];
                    if (!(currentNode instanceof CDATASection)) return [
                        3 /*break*/ ,
                        5
                    ];
                    return [
                        4 /*yield*/ ,
                        "<![CDATA[".concat(currentNode.nodeValue, "]]>")
                    ];
                case 4:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 5:
                    if (!(currentNode instanceof Text)) return [
                        3 /*break*/ ,
                        7
                    ];
                    return [
                        4 /*yield*/ ,
                        currentNode.nodeValue || ""
                    ];
                case 6:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 7:
                    if (!(currentNode instanceof Comment)) return [
                        3 /*break*/ ,
                        9
                    ];
                    return [
                        4 /*yield*/ ,
                        "<!--".concat(currentNode.nodeValue, "-->")
                    ];
                case 8:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 9:
                    if (!(currentNode instanceof SVGElement)) return [
                        3 /*break*/ ,
                        11
                    ];
                    return [
                        4 /*yield*/ ,
                        xmlSerializer.serializeToString(currentNode)
                    ];
                case 10:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 11:
                    if (!(currentNode instanceof Element)) return [
                        3 /*break*/ ,
                        16
                    ];
                    tagName = currentNode.tagName.toLowerCase(), attributes = $8411775311bc7bc8$var$__spreadArray([], $8411775311bc7bc8$var$__read(currentNode.attributes), false).map(function(_a) {
                        var name = _a.name, value = _a.value;
                        return "".concat(name, "=\"").concat((0, exports1.encodeHTMLEntities)(value), "\"");
                    }), shadowRoot = shadowDOMs.get(currentNode);
                    return [
                        4 /*yield*/ ,
                        "<".concat($8411775311bc7bc8$var$__spreadArray([
                            tagName
                        ], $8411775311bc7bc8$var$__read(attributes), false).join(" "), ">")
                    ];
                case 12:
                    _c.sent();
                    if (!(shadowRoot && shadowRoots.includes(shadowRoot))) return [
                        3 /*break*/ ,
                        14
                    ];
                    shadowRootHTML = $8411775311bc7bc8$var$__spreadArray([], $8411775311bc7bc8$var$__read(generateHTML(shadowRoot, {
                        serializableShadowRoots: serializableShadowRoots,
                        shadowRoots: shadowRoots
                    })), false).join("");
                    return [
                        4 /*yield*/ ,
                        "<template shadowrootmode=\"".concat(shadowRoot.mode, "\">").concat(shadowRootHTML, "</template>")
                    ];
                case 13:
                    _c.sent();
                    _c.label = 14;
                case 14:
                    if (!!currentNode.childNodes[0]) return [
                        3 /*break*/ ,
                        16
                    ];
                    return [
                        4 /*yield*/ ,
                        "</".concat(tagName, ">")
                    ];
                case 15:
                    _c.sent();
                    _c.label = 16;
                case 16:
                    nextSibling = currentNode.nextSibling, parentElement = currentNode.parentElement;
                    if (!(!nextSibling && parentElement && parentElement !== root)) return [
                        3 /*break*/ ,
                        18
                    ];
                    return [
                        4 /*yield*/ ,
                        "</".concat(parentElement.tagName.toLowerCase(), ">")
                    ];
                case 17:
                    _c.sent();
                    _c.label = 18;
                case 18:
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 19:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    }
    /**
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getHTML}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/getHTML}
     */ function getHTML(options) {
        if (options === void 0) options = {};
        return $8411775311bc7bc8$var$__spreadArray([], $8411775311bc7bc8$var$__read(generateHTML(this, options)), false).join("");
    }
    function attachDeclarativeShadowRoots(root) {
        var e_1, _a;
        var templates = root.querySelectorAll("template[shadowrootmode]");
        try {
            for(var templates_1 = $8411775311bc7bc8$var$__values(templates), templates_1_1 = templates_1.next(); !templates_1_1.done; templates_1_1 = templates_1.next()){
                var template = templates_1_1.value;
                var parentElement = template.parentElement, content = template.content;
                var shadowRoot = parentElement.attachShadow({
                    mode: template.getAttribute("shadowrootmode")
                });
                shadowRoot.append(content);
                template.remove();
                attachDeclarativeShadowRoots(shadowRoot);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (templates_1_1 && !templates_1_1.done && (_a = templates_1.return)) _a.call(templates_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    }
    /**
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setHTMLUnsafe}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/setHTMLUnsafe}
     */ function setHTMLUnsafe(html) {
        this.innerHTML = html;
        attachDeclarativeShadowRoots(this);
    }
    var domParser = new DOMParser(), initDocument = function(_a) {
        var _b = _a === void 0 ? document : _a, documentElement = _b.documentElement;
        return attachDeclarativeShadowRoots(documentElement);
    };
    /**
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Document/parseHTMLUnsafe_static}
     */ function parseHTMLUnsafe(html) {
        var document1 = domParser.parseFromString(html, "text/html");
        initDocument(document1);
        return document1;
    }
    (_a = Element.prototype).getHTML || (_a.getHTML = getHTML);
    (_b = Element.prototype).setHTMLUnsafe || (_b.setHTMLUnsafe = setHTMLUnsafe);
    (_c = ShadowRoot.prototype).getHTML || (_c.getHTML = getHTML);
    (_d = ShadowRoot.prototype).setHTMLUnsafe || (_d.setHTMLUnsafe = setHTMLUnsafe);
    Document.parseHTMLUnsafe || (Document.parseHTMLUnsafe = parseHTMLUnsafe);
    new Promise(function(resolve) {
        if (document.readyState === "complete") resolve();
        else {
            document.addEventListener("DOMContentLoaded", resolve);
            window.addEventListener("load", resolve);
        }
    }).then(function() {
        return initDocument();
    });
});

});

parcelRegister("3Ju3H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DOMRenderer = void 0;

var $gkQP3 = parcelRequire("gkQP3");
parcelRequire("8BuuC");

var $3aaP5 = parcelRequire("3aaP5");

var $kdqQ0 = parcelRequire("kdqQ0");

var $bFIzj = parcelRequire("bFIzj");
var $2b7ce41aa81a81b9$var$DOMRenderer = /** @class */ function() {
    function DOMRenderer() {
        var _this = this;
        this.eventPattern = /^on[A-Z]/;
        this.ariaPattern = /^aira[A-Z]/;
        this.document = globalThis.document;
        this.treeCache = new WeakMap();
        this.signalCache = new WeakMap();
        this.keyOf = function(_a, index) {
            var key = _a.key, text = _a.text, props = _a.props, selector = _a.selector;
            return (key === null || key === void 0 ? void 0 : key.toString()) || (props === null || props === void 0 ? void 0 : props.id) || (text || selector || '') + index;
        };
        this.vNodeOf = function(list, key) {
            return list.find(function(vNode, index) {
                return "".concat(_this.keyOf(vNode, index)) === String(key);
            });
        };
        this.propsKeyOf = function(key) {
            return key.startsWith('aria-') ? (0, $kdqQ0.toCamelCase)(key) : _this.eventPattern.test(key) ? key.toLowerCase() : key;
        };
        this.attrsNameOf = function(key) {
            return $bFIzj.VNode.propsMap[key] || key;
        };
        this.removeProperty = function(node, key) {
            return _this.eventPattern.test(key) ? node[key.toLowerCase()] = null : node.removeAttribute(_this.ariaPattern.test(key) ? (0, $kdqQ0.toHyphenCase)(key) : _this.attrsNameOf(key));
        };
        this.setProperty = function(node, key, value) {
            var isXML = (0, $kdqQ0.templateOf)(node.tagName) && (0, $kdqQ0.elementTypeOf)(node.tagName) === 'xml';
            if (isXML || key.includes('-')) node.setAttribute(_this.attrsNameOf(key), value);
            else try {
                var name_1 = _this.propsKeyOf(key);
                if (_this.eventPattern.test(key) && !(name_1 in node)) _this.handleCustomEvent(node, name_1.slice(2));
                node[name_1] = value;
            } catch (_a) {
                node.setAttribute(_this.attrsNameOf(key), value);
            }
        };
    }
    DOMRenderer.prototype.updateProps = function(node, oldProps, newProps, onDelete, onAdd) {
        var e_1, _a, e_2, _b;
        if (oldProps === void 0) oldProps = {};
        if (newProps === void 0) newProps = {};
        var group = (0, $kdqQ0.diffKeys)(Object.keys(oldProps), Object.keys(newProps)).group;
        try {
            for(var _c = $gkQP3.__values(group[$kdqQ0.DiffStatus.Old] || []), _d = _c.next(); !_d.done; _d = _c.next()){
                var _e = $gkQP3.__read(_d.value, 1), key = _e[0];
                onDelete === null || onDelete === void 0 || onDelete(node, key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        try {
            for(var _f = $gkQP3.__values($gkQP3.__spreadArray($gkQP3.__spreadArray([], $gkQP3.__read(group[$kdqQ0.DiffStatus.Same] || []), false), $gkQP3.__read(group[$kdqQ0.DiffStatus.New] || []), false)), _g = _f.next(); !_g.done; _g = _f.next()){
                var _h = $gkQP3.__read(_g.value, 1), key = _h[0];
                if (oldProps[key] !== newProps[key]) {
                    if (onAdd instanceof Function) onAdd(node, key, newProps[key]);
                    else Reflect.set(node, key, newProps[key]);
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    DOMRenderer.prototype.deleteNode = function(_a) {
        var ref = _a.ref, node = _a.node, children = _a.children;
        if (node instanceof DocumentFragment) children === null || children === void 0 || children.forEach(this.deleteNode);
        else if (node) {
            node.remove();
            ref === null || ref === void 0 || ref();
        }
    };
    DOMRenderer.prototype.commitChild = function(root, node, index) {
        if (index === void 0) index = 0;
        var targetNode = root.childNodes[index];
        if (targetNode === node) return;
        if (!targetNode) root.append(node);
        else targetNode.before(node);
    };
    DOMRenderer.prototype.diffVChildren = function(oldVNode, newVNode) {
        var _a, map, group, deletingGroup, _b, _c, _d, index, newVChild, key, oldVChild, e_3_1, _e, _f, _g, _i, selector, _h, _j, oldVNode_1, e_4_1;
        var e_3, _k, e_4, _l;
        var _this = this;
        var _m;
        return $gkQP3.__generator(this, function(_o) {
            switch(_o.label){
                case 0:
                    newVNode.children = newVNode.children.map(function(vNode) {
                        return new $bFIzj.VNode(vNode);
                    });
                    _a = (0, $kdqQ0.diffKeys)(oldVNode.children.map(this.keyOf), newVNode.children.map(this.keyOf)), map = _a.map, group = _a.group;
                    deletingGroup = group[$kdqQ0.DiffStatus.Old] && (0, $kdqQ0.groupBy)(group[$kdqQ0.DiffStatus.Old].map(function(_a) {
                        var _b = $gkQP3.__read(_a, 1), key = _b[0];
                        return _this.vNodeOf(oldVNode.children, key);
                    }), function(_a) {
                        var selector = _a.selector;
                        return selector + '';
                    });
                    _o.label = 1;
                case 1:
                    _o.trys.push([
                        1,
                        7,
                        8,
                        9
                    ]);
                    _b = $gkQP3.__values(newVNode.children.entries()), _c = _b.next();
                    _o.label = 2;
                case 2:
                    if (!!_c.done) return [
                        3 /*break*/ ,
                        6
                    ];
                    _d = $gkQP3.__read(_c.value, 2), index = _d[0], newVChild = _d[1];
                    key = this.keyOf(newVChild, index);
                    oldVChild = map[key] === $kdqQ0.DiffStatus.Same ? this.vNodeOf(oldVNode.children, key) : (_m = deletingGroup === null || deletingGroup === void 0 ? void 0 : deletingGroup[newVChild.selector]) === null || _m === void 0 ? void 0 : _m.shift();
                    return [
                        4 /*yield*/ ,
                        {
                            index: index,
                            oldVNode: oldVChild,
                            newVNode: newVChild
                        }
                    ];
                case 3:
                    _o.sent();
                    if (!((oldVChild === null || oldVChild === void 0 ? void 0 : oldVChild.children[0]) || newVChild.children[0])) return [
                        3 /*break*/ ,
                        5
                    ];
                    oldVChild || (oldVChild = new $bFIzj.VNode($gkQP3.__assign($gkQP3.__assign({}, newVChild), {
                        children: []
                    })));
                    return [
                        5 /*yield**/ ,
                        $gkQP3.__values(this.diffVChildren(oldVChild, newVChild))
                    ];
                case 4:
                    _o.sent();
                    _o.label = 5;
                case 5:
                    _c = _b.next();
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 7:
                    e_3_1 = _o.sent();
                    e_3 = {
                        error: e_3_1
                    };
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    try {
                        if (_c && !_c.done && (_k = _b.return)) _k.call(_b);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 9:
                    _e = deletingGroup;
                    _f = [];
                    for(_g in _e)_f.push(_g);
                    _i = 0;
                    _o.label = 10;
                case 10:
                    if (!(_i < _f.length)) return [
                        3 /*break*/ ,
                        19
                    ];
                    _g = _f[_i];
                    if (!(_g in _e)) return [
                        3 /*break*/ ,
                        18
                    ];
                    selector = _g;
                    _o.label = 11;
                case 11:
                    _o.trys.push([
                        11,
                        16,
                        17,
                        18
                    ]);
                    _h = (e_4 = void 0, $gkQP3.__values(deletingGroup[selector])), _j = _h.next();
                    _o.label = 12;
                case 12:
                    if (!!_j.done) return [
                        3 /*break*/ ,
                        15
                    ];
                    oldVNode_1 = _j.value;
                    return [
                        4 /*yield*/ ,
                        {
                            oldVNode: oldVNode_1
                        }
                    ];
                case 13:
                    _o.sent();
                    _o.label = 14;
                case 14:
                    _j = _h.next();
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 15:
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 16:
                    e_4_1 = _o.sent();
                    e_4 = {
                        error: e_4_1
                    };
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 17:
                    try {
                        if (_j && !_j.done && (_l = _h.return)) _l.call(_h);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 18:
                    _i++;
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 19:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    DOMRenderer.prototype.handleCustomEvent = function(node, event) {
        var handler;
        Object.defineProperty(node, "on".concat(event), {
            set: function(value) {
                if (handler) node.removeEventListener(event, handler);
                node.addEventListener(event, handler = value);
            },
            get: function() {
                return handler;
            }
        });
    };
    DOMRenderer.prototype.patchNode = function(oldVNode, newVNode) {
        this.updateProps(oldVNode.node, oldVNode.props, newVNode.props, this.removeProperty, this.setProperty);
        this.updateProps(oldVNode.node.style, oldVNode.style, newVNode.style, function(style, key) {
            return style.removeProperty((0, $kdqQ0.toHyphenCase)(key));
        }, function(style, key, value) {
            return style.setProperty((0, $kdqQ0.toHyphenCase)(key), value);
        });
        newVNode.node || (newVNode.node = oldVNode.node);
        return newVNode;
    };
    DOMRenderer.prototype.generateDOM = function(oldVRoot, newVRoot) {
        var _a, _b, _c, index, oldVNode, newVNode, inserting, tagName, node, parent_1, e_5_1;
        var e_5, _d;
        var _e;
        return $gkQP3.__generator(this, function(_f) {
            switch(_f.label){
                case 0:
                    if ($bFIzj.VNode.isFragment(newVRoot)) newVRoot = new $bFIzj.VNode($gkQP3.__assign($gkQP3.__assign({}, oldVRoot), {
                        children: newVRoot.children
                    }));
                    return [
                        4 /*yield*/ ,
                        this.patchNode(oldVRoot, newVRoot)
                    ];
                case 1:
                    _f.sent();
                    _f.label = 2;
                case 2:
                    _f.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _a = $gkQP3.__values(this.diffVChildren(oldVRoot, newVRoot)), _b = _a.next();
                    _f.label = 3;
                case 3:
                    if (!!_b.done) return [
                        3 /*break*/ ,
                        6
                    ];
                    _c = _b.value, index = _c.index, oldVNode = _c.oldVNode, newVNode = _c.newVNode;
                    if (!newVNode) {
                        this.deleteNode(oldVNode);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    }
                    inserting = !oldVNode;
                    if (oldVNode) newVNode.node = oldVNode.node;
                    else {
                        newVNode.createDOM(this.document);
                        tagName = newVNode.tagName, node = newVNode.node, parent_1 = newVNode.parent;
                        oldVNode = new $bFIzj.VNode({
                            tagName: tagName,
                            node: node,
                            parent: parent_1
                        });
                    }
                    if (newVNode.text) oldVNode.node.nodeValue = newVNode.text;
                    else if (!$bFIzj.VNode.isFragment(newVNode)) this.patchNode(oldVNode, newVNode);
                    if (oldVNode.parent) {
                        this.commitChild(oldVNode.parent.node, newVNode.node, index);
                        if (inserting) (_e = newVNode.ref) === null || _e === void 0 || _e.call(newVNode, newVNode.node);
                    }
                    return [
                        4 /*yield*/ ,
                        newVNode
                    ];
                case 4:
                    _f.sent();
                    _f.label = 5;
                case 5:
                    _b = _a.next();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 7:
                    e_5_1 = _f.sent();
                    e_5 = {
                        error: e_5_1
                    };
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    try {
                        if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                    } finally{
                        if (e_5) throw e_5.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 9:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    DOMRenderer.prototype.patch = function(oldVRoot, newVRoot) {
        var e_6, _a;
        var count = 0;
        try {
            for(var _b = $gkQP3.__values(this.generateDOM(oldVRoot, newVRoot)), _c = _b.next(); !_c.done; _c = _b.next()){
                var newVNode = _c.value;
                if (++count === 1) newVRoot = newVNode;
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        return newVRoot;
    };
    DOMRenderer.prototype.patchAsync = function(oldVRoot, newVRoot) {
        return $gkQP3.__awaiter(this, void 0, void 0, function() {
            var oldController, controller, count, _a, _b, newVNode, e_7_1;
            var e_7, _c;
            return $gkQP3.__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        oldController = this.signalCache.get(oldVRoot.node);
                        if (oldController) {
                            oldController.abort();
                            oldVRoot = $bFIzj.VNode.fromDOM(oldVRoot.node);
                        }
                        controller = new AbortController();
                        this.signalCache.set(oldVRoot.node, controller);
                        count = 0;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _a = $gkQP3.__values(this.generateDOM(oldVRoot, newVRoot)), _b = _a.next();
                        _d.label = 2;
                    case 2:
                        if (!!_b.done) return [
                            3 /*break*/ ,
                            5
                        ];
                        newVNode = _b.value;
                        if (++count === 1) newVRoot = newVNode;
                        return [
                            4 /*yield*/ ,
                            scheduler.yield()
                        ];
                    case 3:
                        _d.sent();
                        if (controller.signal.aborted) {
                            this.signalCache.delete(oldVRoot.node);
                            controller.signal.throwIfAborted();
                        }
                        _d.label = 4;
                    case 4:
                        _b = _a.next();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        e_7_1 = _d.sent();
                        e_7 = {
                            error: e_7_1
                        };
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        } finally{
                            if (e_7) throw e_7.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 8:
                        this.signalCache.delete(oldVRoot.node);
                        return [
                            2 /*return*/ ,
                            newVRoot
                        ];
                }
            });
        });
    };
    DOMRenderer.prototype.render = function(vNode, node, mode) {
        var _this = this;
        var _a;
        if (node === void 0) node = (_a = globalThis.document) === null || _a === void 0 ? void 0 : _a.body;
        if (mode === void 0) mode = 'sync';
        this.document = node.ownerDocument;
        var root = this.treeCache.get(node) || $bFIzj.VNode.fromDOM(node);
        var done = function(root) {
            return _this.treeCache.set(node, root) && root;
        };
        return mode === 'sync' ? done(this.patch(root, new $bFIzj.VNode($gkQP3.__assign($gkQP3.__assign({}, root), {
            children: [
                vNode
            ]
        })))) : this.patchAsync(root, new $bFIzj.VNode($gkQP3.__assign($gkQP3.__assign({}, root), {
            children: [
                vNode
            ]
        }))).then(done);
    };
    DOMRenderer.prototype.renderToStaticMarkup = function(tree) {
        return $gkQP3.__spreadArray([], $gkQP3.__read(tree.generateXML()), false).join('');
    };
    DOMRenderer.prototype.renderToReadableStream = function(tree) {
        return $3aaP5.ReadableStream.from(tree.generateXML());
    };
    return DOMRenderer;
}();
module.exports.DOMRenderer = $2b7ce41aa81a81b9$var$DOMRenderer;

});
parcelRegister("8BuuC", function(module, exports) {
!function() {
    var t = [
        "user-blocking",
        "user-visible",
        "background"
    ];
    class i {
        constructor(){
            this.t = new MessageChannel, this.i = this.t.port2, this.l = {}, this.o = 1, this.t.port1.onmessage = (t)=>this.h(t);
        }
        u(t) {
            var i = this.o++;
            return this.l[i] = t, this.i.postMessage(i), i;
        }
        p(t) {
            delete this.l[t];
        }
        h(t) {
            var i = t.data;
            if (i in this.l) {
                var r = this.l[i];
                delete this.l[i], r();
            }
        }
    }
    function r() {
        return r.v || (r.v = new i), r.v;
    }
    class s {
        constructor(t, i, r){
            void 0 === r && (r = 0), this.k = t, this.T = null, this.C = null, this.m = !1, this._(i, r);
        }
        isIdleCallback() {
            return 0 === this.T;
        }
        I() {
            return 2 === this.T;
        }
        cancel() {
            if (!this.m) switch(this.m = !0, this.T){
                case 0:
                    cancelIdleCallback(this.C);
                    break;
                case 1:
                    clearTimeout(this.C);
                    break;
                case 2:
                    r().p(this.C);
                    break;
                default:
                    throw new TypeError("Unknown CallbackType");
            }
        }
        _(i, s) {
            if (s && s > 0) return this.T = 1, void (this.C = setTimeout(()=>{
                this.P();
            }, s));
            if (!t.includes(i)) throw new TypeError("Invalid task priority : " + i);
            return "background" === i && "function" == typeof requestIdleCallback ? (this.T = 0, void (this.C = requestIdleCallback(()=>{
                this.P();
            }))) : "function" == typeof MessageChannel ? (this.T = 2, void (this.C = r().u(()=>{
                this.P();
            }))) : (this.T = 1, void (this.C = setTimeout(()=>{
                this.P();
            })));
        }
        P() {
            this.m || this.k();
        }
    }
    var e = 0;
    class n {
        constructor(){
            this.j = null, this.M = null;
        }
        isEmpty() {
            return null == this.j;
        }
        push(t) {
            if ("object" != typeof t) throw new TypeError("Task must be an Object");
            t.A = e++, this.isEmpty() ? (t.N = null, this.j = t) : (t.N = this.M, this.M.O = t), t.O = null, this.M = t;
        }
        takeNextTask() {
            if (this.isEmpty()) return null;
            var t = this.j;
            return this.q(t), t;
        }
        merge(t, i) {
            if ("function" != typeof i) throw new TypeError("Must provide a selector function.");
            if (null == t) throw new Error("sourceQueue cannot be null");
            for(var r = this.j, s = null, e = t.j; e;){
                var n = e;
                if (e = e.O, i(n)) {
                    for(t.q(n); r && r.A < n.A;)s = r, r = r.O;
                    this.D(n, s), s = n;
                }
            }
        }
        D(t, i) {
            if (i != this.M) {
                var r = i ? i.O : this.j;
                t.O = r, r.N = t, t.N = i, null != i ? i.O = t : this.j = t;
            } else this.push(t);
        }
        q(t) {
            if (null == t) throw new Error("Expected task to be non-null");
            t === this.j && (this.j = t.O), t === this.M && (this.M = this.M.N), t.O && (t.O.N = t.N), t.N && (t.N.O = t.O);
        }
    }
    class l extends Event {
        constructor(i, r){
            if (!r || !t.includes(r.previousPriority)) throw new TypeError("Invalid task priority: '" + r.previousPriority + "'");
            super(i), this.previousPriority = r.previousPriority;
        }
    }
    class o extends AbortController {
        constructor(i){
            if (void 0 === i && (i = {}), super(), null == i && (i = {}), "object" != typeof i) throw new TypeError("'init' is not an object");
            var r, s, e = void 0 === i.priority ? "user-visible" : i.priority;
            if (!t.includes(e)) throw new TypeError("Invalid task priority: '" + e + "'");
            this.H = e, this.R = !1, s = (r = this).signal, Object.defineProperties(s, {
                priority: {
                    get: function() {
                        return r.H;
                    },
                    enumerable: !0
                },
                onprioritychange: {
                    value: null,
                    writable: !0,
                    enumerable: !0
                }
            }), s.addEventListener("prioritychange", (t)=>{
                s.onprioritychange && s.onprioritychange(t);
            });
        }
        setPriority(i) {
            if (!t.includes(i)) throw new TypeError("Invalid task priority: " + i);
            if (this.R) throw new DOMException("", "NotAllowedError");
            if (this.signal.priority !== i) {
                this.R = !0;
                var r = this.H;
                this.H = i;
                var s = new l("prioritychange", {
                    previousPriority: r
                });
                this.signal.dispatchEvent(s), this.R = !1;
            }
        }
    }
    void 0 === self.scheduler ? (self.scheduler = new class {
        constructor(){
            this.S = {}, t.forEach((t)=>{
                this.S[t] = [
                    new n,
                    new n
                ];
            }), this.U = null, this.W = new WeakMap;
        }
        yield() {
            return this.B(()=>{}, {
                priority: "user-visible"
            }, !0);
        }
        postTask(t, i) {
            return this.B(t, i, !1);
        }
        B(i, r, s) {
            if (void 0 !== (r = Object.assign({}, r)).signal) {
                if (null === r.signal || !("aborted" in r.signal) || "function" != typeof r.signal.addEventListener) return Promise.reject(new TypeError("'signal' is not a valid 'AbortSignal'"));
                if (r.signal && r.signal.priority && !t.includes(r.signal.priority)) return Promise.reject(new TypeError("Invalid task priority: '" + r.signal.priority + "'"));
            }
            if (void 0 !== r.priority && (null === r.priority || !t.includes(r.priority))) return Promise.reject(new TypeError("Invalid task priority: '" + r.priority + "'"));
            if (void 0 === r.delay && (r.delay = 0), r.delay = Number(r.delay), r.delay < 0) return Promise.reject(new TypeError("'delay' must be a positive number."));
            var e = {
                callback: i,
                options: r,
                resolve: null,
                reject: null,
                hostCallback: null,
                abortCallback: null,
                onTaskCompleted: function() {
                    this.options.signal && this.abortCallback && (this.options.signal.removeEventListener("abort", this.abortCallback), this.abortCallback = null);
                },
                onTaskAborted: function() {
                    this.hostCallback && (this.hostCallback.cancel(), this.hostCallback = null), this.options.signal.removeEventListener("abort", this.abortCallback), this.abortCallback = null, this.reject(this.options.signal.reason);
                },
                isAborted: function() {
                    return this.options.signal && this.options.signal.aborted;
                },
                isContinuation: s
            }, n = new Promise((t, i)=>{
                e.resolve = t, e.reject = i;
            });
            return this._(e), n;
        }
        _(t) {
            var i = t.options.signal;
            if (i) {
                if (i.aborted) return void t.reject(i.reason);
                t.abortCallback = ()=>{
                    t.onTaskAborted();
                }, i.addEventListener("abort", t.abortCallback);
            }
            t.options.delay > 0 ? t.hostCallback = new s(()=>{
                t.hostCallback = null, this.F(t);
            }, null, t.options.delay) : (this.G(t), this.J());
        }
        F(t) {
            this.G(t), this.U && (this.U.cancel(), this.U = null), this.K();
        }
        L(t) {
            var i = this.W.get(t);
            if (void 0 === i) throw new Error("Attempting to change priority on an unregistered signal");
            if (i !== t.priority) {
                for(var r = 0; r < 2; r++)this.S[t.priority][r].merge(this.S[i][r], (i)=>i.options.signal === t);
                this.W.set(t, t.priority);
            }
        }
        K() {
            this.U = null, this.V(), this.J();
        }
        J() {
            var { priority: t } = this.X();
            null != t && ("background" !== t && this.U && this.U.isIdleCallback() && (this.U.cancel(), this.U = null), this.U || (this.U = new s(()=>{
                this.K();
            }, t, 0)));
        }
        G(i) {
            var r;
            if (!t.includes(r = i.options.priority ? i.options.priority : i.options.signal && i.options.signal.priority ? i.options.signal.priority : "user-visible")) throw new TypeError("Invalid task priority: " + r);
            if (i.options.signal && i.options.signal.priority) {
                var s = i.options.signal;
                this.W.has(s) || (s.addEventListener("prioritychange", ()=>{
                    this.L(s);
                }), this.W.set(s, s.priority));
            }
            this.S[r][i.isContinuation ? 0 : 1].push(i);
        }
        V() {
            var t = null;
            do {
                var { priority: i, type: r } = this.X();
                if (null == i) return;
                t = this.S[i][r].takeNextTask();
            }while (t.isAborted());
            try {
                var s = t.callback();
                t.resolve(s);
            } catch (i) {
                t.reject(i);
            } finally{
                t.onTaskCompleted();
            }
        }
        X() {
            for(var i = 0; i < t.length; i++)for(var r = t[i], s = 0; s < 2; s++)if (!this.S[r][s].isEmpty()) return {
                priority: r,
                type: s
            };
            return {
                priority: null,
                type: 0
            };
        }
    }, self.TaskController = o, self.TaskPriorityChangeEvent = l) : self.scheduler.yield || (self.scheduler.yield = function() {
        return self.scheduler.postTask(()=>{}, {
            priority: "user-blocking"
        });
    });
}();

});

parcelRegister("3aaP5", function(module, exports) {
/**
 * @license
 * web-streams-polyfill v4.2.0
 * Copyright 2025 Mattias Buelens, Diwank Singh Tomer and other contributors.
 * This code is released under the MIT license.
 * SPDX-License-Identifier: MIT
 */ !function(e, t) {
    t(module.exports);
}(module.exports, function(e) {
    "use strict";
    function t() {}
    function r(e) {
        return "object" == typeof e && null !== e || "function" == typeof e;
    }
    const o = t;
    function n(e, t) {
        try {
            Object.defineProperty(e, "name", {
                value: t,
                configurable: !0
            });
        } catch (e) {}
    }
    const a = Promise, i = Promise.resolve.bind(a), l = Promise.prototype.then, s = Promise.reject.bind(a), u = i;
    function c(e) {
        return new a(e);
    }
    function d(e) {
        return c((t)=>t(e));
    }
    function f(e) {
        return s(e);
    }
    function b(e, t, r) {
        return l.call(e, t, r);
    }
    function h(e, t, r) {
        b(b(e, t, r), void 0, o);
    }
    function m(e, t) {
        h(e, t);
    }
    function _(e, t) {
        h(e, void 0, t);
    }
    function p(e, t, r) {
        return b(e, t, r);
    }
    function y(e) {
        b(e, void 0, o);
    }
    let S = (e)=>{
        if ("function" == typeof queueMicrotask) S = queueMicrotask;
        else {
            const e = d(void 0);
            S = (t)=>b(e, t);
        }
        return S(e);
    };
    function g(e, t, r) {
        if ("function" != typeof e) throw new TypeError("Argument is not a function");
        return Function.prototype.apply.call(e, t, r);
    }
    function v(e, t, r) {
        try {
            return d(g(e, t, r));
        } catch (e) {
            return f(e);
        }
    }
    class w {
        constructor(){
            this._cursor = 0, this._size = 0, this._front = {
                _elements: [],
                _next: void 0
            }, this._back = this._front, this._cursor = 0, this._size = 0;
        }
        get length() {
            return this._size;
        }
        push(e) {
            const t = this._back;
            let r = t;
            16383 === t._elements.length && (r = {
                _elements: [],
                _next: void 0
            }), t._elements.push(e), r !== t && (this._back = r, t._next = r), ++this._size;
        }
        shift() {
            const e = this._front;
            let t = e;
            const r = this._cursor;
            let o = r + 1;
            const n = e._elements, a = n[r];
            return 16384 === o && (t = e._next, o = 0), --this._size, this._cursor = o, e !== t && (this._front = t), n[r] = void 0, a;
        }
        forEach(e) {
            let t = this._cursor, r = this._front, o = r._elements;
            for(; !(t === o.length && void 0 === r._next || t === o.length && (r = r._next, o = r._elements, t = 0, 0 === o.length));)e(o[t]), ++t;
        }
        peek() {
            const e = this._front, t = this._cursor;
            return e._elements[t];
        }
    }
    const R = Symbol("[[AbortSteps]]"), T = Symbol("[[ErrorSteps]]"), C = Symbol("[[CancelSteps]]"), P = Symbol("[[PullSteps]]"), q = Symbol("[[ReleaseSteps]]");
    function E(e, t) {
        e._ownerReadableStream = t, t._reader = e, "readable" === t._state ? j(e) : "closed" === t._state ? function(e) {
            j(e), z(e);
        }(e) : k(e, t._storedError);
    }
    function W(e, t) {
        return Or(e._ownerReadableStream, t);
    }
    function B(e) {
        const t = e._ownerReadableStream;
        "readable" === t._state ? A(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")) : function(e, t) {
            k(e, t);
        }(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")), t._readableStreamController[q](), t._reader = void 0, e._ownerReadableStream = void 0;
    }
    function O(e) {
        return new TypeError("Cannot " + e + " a stream using a released reader");
    }
    function j(e) {
        e._closedPromise = c((t, r)=>{
            e._closedPromise_resolve = t, e._closedPromise_reject = r;
        });
    }
    function k(e, t) {
        j(e), A(e, t);
    }
    function A(e, t) {
        void 0 !== e._closedPromise_reject && (y(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
    }
    function z(e) {
        void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
    }
    const D = Number.isFinite || function(e) {
        return "number" == typeof e && isFinite(e);
    }, L = Math.trunc || function(e) {
        return e < 0 ? Math.ceil(e) : Math.floor(e);
    };
    function F(e, t) {
        if (void 0 !== e && "object" != typeof (r = e) && "function" != typeof r) throw new TypeError(`${t} is not an object.`);
        var r;
    }
    function I(e, t) {
        if ("function" != typeof e) throw new TypeError(`${t} is not a function.`);
    }
    function $(e, t) {
        if (!function(e) {
            return "object" == typeof e && null !== e || "function" == typeof e;
        }(e)) throw new TypeError(`${t} is not an object.`);
    }
    function M(e, t, r) {
        if (void 0 === e) throw new TypeError(`Parameter ${t} is required in '${r}'.`);
    }
    function Y(e, t, r) {
        if (void 0 === e) throw new TypeError(`${t} is required in '${r}'.`);
    }
    function x(e) {
        return Number(e);
    }
    function Q(e) {
        return 0 === e ? 0 : e;
    }
    function N(e, t) {
        const r = Number.MAX_SAFE_INTEGER;
        let o = Number(e);
        if (o = Q(o), !D(o)) throw new TypeError(`${t} is not a finite number`);
        if (o = function(e) {
            return Q(L(e));
        }(o), o < 0 || o > r) throw new TypeError(`${t} is outside the accepted range of 0 to ${r}, inclusive`);
        return D(o) && 0 !== o ? o : 0;
    }
    function H(e, t) {
        if (!Wr(e)) throw new TypeError(`${t} is not a ReadableStream.`);
    }
    function V(e) {
        return new ReadableStreamDefaultReader(e);
    }
    function U(e, t) {
        e._reader._readRequests.push(t);
    }
    function G(e, t, r) {
        const o = e._reader._readRequests.shift();
        r ? o._closeSteps() : o._chunkSteps(t);
    }
    function X(e) {
        return e._reader._readRequests.length;
    }
    function J(e) {
        const t = e._reader;
        return void 0 !== t && !!K(t);
    }
    class ReadableStreamDefaultReader {
        constructor(e){
            if (M(e, 1, "ReadableStreamDefaultReader"), H(e, "First parameter"), Br(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
            E(this, e), this._readRequests = new w;
        }
        get closed() {
            return K(this) ? this._closedPromise : f(te("closed"));
        }
        cancel(e) {
            return K(this) ? void 0 === this._ownerReadableStream ? f(O("cancel")) : W(this, e) : f(te("cancel"));
        }
        read() {
            if (!K(this)) return f(te("read"));
            if (void 0 === this._ownerReadableStream) return f(O("read from"));
            let e, t;
            const r = c((r, o)=>{
                e = r, t = o;
            });
            return Z(this, {
                _chunkSteps: (t)=>e({
                        value: t,
                        done: !1
                    }),
                _closeSteps: ()=>e({
                        value: void 0,
                        done: !0
                    }),
                _errorSteps: (e)=>t(e)
            }), r;
        }
        releaseLock() {
            if (!K(this)) throw te("releaseLock");
            void 0 !== this._ownerReadableStream && function(e) {
                B(e);
                const t = new TypeError("Reader was released");
                ee(e, t);
            }(this);
        }
    }
    function K(e) {
        return !!r(e) && !!Object.prototype.hasOwnProperty.call(e, "_readRequests") && e instanceof ReadableStreamDefaultReader;
    }
    function Z(e, t) {
        const r = e._ownerReadableStream;
        r._disturbed = !0, "closed" === r._state ? t._closeSteps() : "errored" === r._state ? t._errorSteps(r._storedError) : r._readableStreamController[P](t);
    }
    function ee(e, t) {
        const r = e._readRequests;
        e._readRequests = new w, r.forEach((e)=>{
            e._errorSteps(t);
        });
    }
    function te(e) {
        return new TypeError(`ReadableStreamDefaultReader.prototype.${e} can only be used on a ReadableStreamDefaultReader`);
    }
    var re, oe, ne;
    function ae(e) {
        return e.slice();
    }
    function ie(e, t, r, o, n) {
        new Uint8Array(e).set(new Uint8Array(r, o, n), t);
    }
    Object.defineProperties(ReadableStreamDefaultReader.prototype, {
        cancel: {
            enumerable: !0
        },
        read: {
            enumerable: !0
        },
        releaseLock: {
            enumerable: !0
        },
        closed: {
            enumerable: !0
        }
    }), n(ReadableStreamDefaultReader.prototype.cancel, "cancel"), n(ReadableStreamDefaultReader.prototype.read, "read"), n(ReadableStreamDefaultReader.prototype.releaseLock, "releaseLock"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty(ReadableStreamDefaultReader.prototype, Symbol.toStringTag, {
        value: "ReadableStreamDefaultReader",
        configurable: !0
    });
    let le = (e)=>(le = "function" == typeof e.transfer ? (e)=>e.transfer() : "function" == typeof structuredClone ? (e)=>structuredClone(e, {
                transfer: [
                    e
                ]
            }) : (e)=>e, le(e)), se = (e)=>(se = "boolean" == typeof e.detached ? (e)=>e.detached : (e)=>0 === e.byteLength, se(e));
    function ue(e, t, r) {
        if (e.slice) return e.slice(t, r);
        const o = r - t, n = new ArrayBuffer(o);
        return ie(n, 0, e, t, o), n;
    }
    function ce(e, t) {
        const r = e[t];
        if (null != r) {
            if ("function" != typeof r) throw new TypeError(`${String(t)} is not a function`);
            return r;
        }
    }
    function de(e) {
        try {
            const t = e.done, r = e.value;
            return b(u(r), (e)=>({
                    done: t,
                    value: e
                }));
        } catch (e) {
            return f(e);
        }
    }
    const fe = null !== (ne = null !== (re = Symbol.asyncIterator) && void 0 !== re ? re : null === (oe = Symbol.for) || void 0 === oe ? void 0 : oe.call(Symbol, "Symbol.asyncIterator")) && void 0 !== ne ? ne : "@@asyncIterator";
    function be(e, t = "sync", o) {
        if (void 0 === o) {
            if ("async" === t) {
                if (void 0 === (o = ce(e, fe))) return function(e) {
                    const t = {
                        next () {
                            let t;
                            try {
                                t = he(e);
                            } catch (e) {
                                return f(e);
                            }
                            return de(t);
                        },
                        return (t) {
                            let o;
                            try {
                                const r = ce(e.iterator, "return");
                                if (void 0 === r) return d({
                                    done: !0,
                                    value: t
                                });
                                o = g(r, e.iterator, [
                                    t
                                ]);
                            } catch (e) {
                                return f(e);
                            }
                            return r(o) ? de(o) : f(new TypeError("The iterator.return() method must return an object"));
                        }
                    };
                    return {
                        iterator: t,
                        nextMethod: t.next,
                        done: !1
                    };
                }(be(e, "sync", ce(e, Symbol.iterator)));
            } else o = ce(e, Symbol.iterator);
        }
        if (void 0 === o) throw new TypeError("The object is not iterable");
        const n = g(o, e, []);
        if (!r(n)) throw new TypeError("The iterator method must return an object");
        return {
            iterator: n,
            nextMethod: n.next,
            done: !1
        };
    }
    function he(e) {
        const t = g(e.nextMethod, e.iterator, []);
        if (!r(t)) throw new TypeError("The iterator.next() method must return an object");
        return t;
    }
    class me {
        constructor(e, t){
            this._ongoingPromise = void 0, this._isFinished = !1, this._reader = e, this._preventCancel = t;
        }
        next() {
            const e = ()=>this._nextSteps();
            return this._ongoingPromise = this._ongoingPromise ? p(this._ongoingPromise, e, e) : e(), this._ongoingPromise;
        }
        return(e) {
            const t = ()=>this._returnSteps(e);
            return this._ongoingPromise = this._ongoingPromise ? p(this._ongoingPromise, t, t) : t(), this._ongoingPromise;
        }
        _nextSteps() {
            if (this._isFinished) return Promise.resolve({
                value: void 0,
                done: !0
            });
            const e = this._reader;
            let t, r;
            const o = c((e, o)=>{
                t = e, r = o;
            });
            return Z(e, {
                _chunkSteps: (e)=>{
                    this._ongoingPromise = void 0, S(()=>t({
                            value: e,
                            done: !1
                        }));
                },
                _closeSteps: ()=>{
                    this._ongoingPromise = void 0, this._isFinished = !0, B(e), t({
                        value: void 0,
                        done: !0
                    });
                },
                _errorSteps: (t)=>{
                    this._ongoingPromise = void 0, this._isFinished = !0, B(e), r(t);
                }
            }), o;
        }
        _returnSteps(e) {
            if (this._isFinished) return Promise.resolve({
                value: e,
                done: !0
            });
            this._isFinished = !0;
            const t = this._reader;
            if (!this._preventCancel) {
                const r = W(t, e);
                return B(t), p(r, ()=>({
                        value: e,
                        done: !0
                    }));
            }
            return B(t), d({
                value: e,
                done: !0
            });
        }
    }
    const _e = {
        next () {
            return pe(this) ? this._asyncIteratorImpl.next() : f(ye("next"));
        },
        return (e) {
            return pe(this) ? this._asyncIteratorImpl.return(e) : f(ye("return"));
        },
        [fe] () {
            return this;
        }
    };
    function pe(e) {
        if (!r(e)) return !1;
        if (!Object.prototype.hasOwnProperty.call(e, "_asyncIteratorImpl")) return !1;
        try {
            return e._asyncIteratorImpl instanceof me;
        } catch (e) {
            return !1;
        }
    }
    function ye(e) {
        return new TypeError(`ReadableStreamAsyncIterator.${e} can only be used on a ReadableSteamAsyncIterator`);
    }
    Object.defineProperty(_e, fe, {
        enumerable: !1
    });
    const Se = Number.isNaN || function(e) {
        return e != e;
    };
    function ge(e) {
        const t = ue(e.buffer, e.byteOffset, e.byteOffset + e.byteLength);
        return new Uint8Array(t);
    }
    function ve(e) {
        const t = e._queue.shift();
        return e._queueTotalSize -= t.size, e._queueTotalSize < 0 && (e._queueTotalSize = 0), t.value;
    }
    function we(e, t, r) {
        if ("number" != typeof (o = r) || Se(o) || o < 0 || r === 1 / 0) throw new RangeError("Size must be a finite, non-NaN, non-negative number.");
        var o;
        e._queue.push({
            value: t,
            size: r
        }), e._queueTotalSize += r;
    }
    function Re(e) {
        e._queue = new w, e._queueTotalSize = 0;
    }
    function Te(e) {
        return e === DataView;
    }
    class ReadableStreamBYOBRequest {
        constructor(){
            throw new TypeError("Illegal constructor");
        }
        get view() {
            if (!Pe(this)) throw Ze("view");
            return this._view;
        }
        respond(e) {
            if (!Pe(this)) throw Ze("respond");
            if (M(e, 1, "respond"), e = N(e, "First parameter"), void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
            if (se(this._view.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be used as a response");
            Xe(this._associatedReadableByteStreamController, e);
        }
        respondWithNewView(e) {
            if (!Pe(this)) throw Ze("respondWithNewView");
            if (M(e, 1, "respondWithNewView"), !ArrayBuffer.isView(e)) throw new TypeError("You can only respond with array buffer views");
            if (void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
            if (se(e.buffer)) throw new TypeError("The given view's buffer has been detached and so cannot be used as a response");
            Je(this._associatedReadableByteStreamController, e);
        }
    }
    Object.defineProperties(ReadableStreamBYOBRequest.prototype, {
        respond: {
            enumerable: !0
        },
        respondWithNewView: {
            enumerable: !0
        },
        view: {
            enumerable: !0
        }
    }), n(ReadableStreamBYOBRequest.prototype.respond, "respond"), n(ReadableStreamBYOBRequest.prototype.respondWithNewView, "respondWithNewView"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty(ReadableStreamBYOBRequest.prototype, Symbol.toStringTag, {
        value: "ReadableStreamBYOBRequest",
        configurable: !0
    });
    class ReadableByteStreamController {
        constructor(){
            throw new TypeError("Illegal constructor");
        }
        get byobRequest() {
            if (!Ce(this)) throw et("byobRequest");
            return Ue(this);
        }
        get desiredSize() {
            if (!Ce(this)) throw et("desiredSize");
            return Ge(this);
        }
        close() {
            if (!Ce(this)) throw et("close");
            if (this._closeRequested) throw new TypeError("The stream has already been closed; do not close it again!");
            const e = this._controlledReadableByteStream._state;
            if ("readable" !== e) throw new TypeError(`The stream (in ${e} state) is not in the readable state and cannot be closed`);
            Qe(this);
        }
        enqueue(e) {
            if (!Ce(this)) throw et("enqueue");
            if (M(e, 1, "enqueue"), !ArrayBuffer.isView(e)) throw new TypeError("chunk must be an array buffer view");
            if (0 === e.byteLength) throw new TypeError("chunk must have non-zero byteLength");
            if (0 === e.buffer.byteLength) throw new TypeError("chunk's buffer must have non-zero byteLength");
            if (this._closeRequested) throw new TypeError("stream is closed or draining");
            const t = this._controlledReadableByteStream._state;
            if ("readable" !== t) throw new TypeError(`The stream (in ${t} state) is not in the readable state and cannot be enqueued to`);
            Ne(this, e);
        }
        error(e) {
            if (!Ce(this)) throw et("error");
            He(this, e);
        }
        [C](e) {
            Ee(this), Re(this);
            const t = this._cancelAlgorithm(e);
            return xe(this), t;
        }
        [P](e) {
            const t = this._controlledReadableByteStream;
            if (this._queueTotalSize > 0) return void Ve(this, e);
            const r = this._autoAllocateChunkSize;
            if (void 0 !== r) {
                let t;
                try {
                    t = new ArrayBuffer(r);
                } catch (t) {
                    return void e._errorSteps(t);
                }
                const o = {
                    buffer: t,
                    bufferByteLength: r,
                    byteOffset: 0,
                    byteLength: r,
                    bytesFilled: 0,
                    minimumFill: 1,
                    elementSize: 1,
                    viewConstructor: Uint8Array,
                    readerType: "default"
                };
                this._pendingPullIntos.push(o);
            }
            U(t, e), qe(this);
        }
        [q]() {
            if (this._pendingPullIntos.length > 0) {
                const e = this._pendingPullIntos.peek();
                e.readerType = "none", this._pendingPullIntos = new w, this._pendingPullIntos.push(e);
            }
        }
    }
    function Ce(e) {
        return !!r(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableByteStream") && e instanceof ReadableByteStreamController;
    }
    function Pe(e) {
        return !!r(e) && !!Object.prototype.hasOwnProperty.call(e, "_associatedReadableByteStreamController") && e instanceof ReadableStreamBYOBRequest;
    }
    function qe(e) {
        const t = function(e) {
            const t = e._controlledReadableByteStream;
            if ("readable" !== t._state) return !1;
            if (e._closeRequested) return !1;
            if (!e._started) return !1;
            if (J(t) && X(t) > 0) return !0;
            if (at(t) && nt(t) > 0) return !0;
            const r = Ge(e);
            if (r > 0) return !0;
            return !1;
        }(e);
        if (!t) return;
        if (e._pulling) return void (e._pullAgain = !0);
        e._pulling = !0;
        h(e._pullAlgorithm(), ()=>(e._pulling = !1, e._pullAgain && (e._pullAgain = !1, qe(e)), null), (t)=>(He(e, t), null));
    }
    function Ee(e) {
        Fe(e), e._pendingPullIntos = new w;
    }
    function We(e, t) {
        let r = !1;
        "closed" === e._state && (r = !0);
        const o = Oe(t);
        "default" === t.readerType ? G(e, o, r) : function(e, t, r) {
            const o = e._reader, n = o._readIntoRequests.shift();
            r ? n._closeSteps(t) : n._chunkSteps(t);
        }(e, o, r);
    }
    function Be(e, t) {
        for(let r = 0; r < t.length; ++r)We(e, t[r]);
    }
    function Oe(e) {
        const t = e.bytesFilled, r = e.elementSize;
        return new e.viewConstructor(e.buffer, e.byteOffset, t / r);
    }
    function je(e, t, r, o) {
        e._queue.push({
            buffer: t,
            byteOffset: r,
            byteLength: o
        }), e._queueTotalSize += o;
    }
    function ke(e, t, r, o) {
        let n;
        try {
            n = ue(t, r, r + o);
        } catch (t) {
            throw He(e, t), t;
        }
        je(e, n, 0, o);
    }
    function Ae(e, t) {
        t.bytesFilled > 0 && ke(e, t.buffer, t.byteOffset, t.bytesFilled), Ye(e);
    }
    function ze(e, t) {
        const r = Math.min(e._queueTotalSize, t.byteLength - t.bytesFilled), o = t.bytesFilled + r;
        let n = r, a = !1;
        const i = o - o % t.elementSize;
        i >= t.minimumFill && (n = i - t.bytesFilled, a = !0);
        const l = e._queue;
        for(; n > 0;){
            const r = l.peek(), o = Math.min(n, r.byteLength), a = t.byteOffset + t.bytesFilled;
            ie(t.buffer, a, r.buffer, r.byteOffset, o), r.byteLength === o ? l.shift() : (r.byteOffset += o, r.byteLength -= o), e._queueTotalSize -= o, De(e, o, t), n -= o;
        }
        return a;
    }
    function De(e, t, r) {
        r.bytesFilled += t;
    }
    function Le(e) {
        0 === e._queueTotalSize && e._closeRequested ? (xe(e), jr(e._controlledReadableByteStream)) : qe(e);
    }
    function Fe(e) {
        null !== e._byobRequest && (e._byobRequest._associatedReadableByteStreamController = void 0, e._byobRequest._view = null, e._byobRequest = null);
    }
    function Ie(e) {
        const t = [];
        for(; e._pendingPullIntos.length > 0 && 0 !== e._queueTotalSize;){
            const r = e._pendingPullIntos.peek();
            ze(e, r) && (Ye(e), t.push(r));
        }
        return t;
    }
    function $e(e, t, r, o) {
        const n = e._controlledReadableByteStream, a = t.constructor, i = function(e) {
            return Te(e) ? 1 : e.BYTES_PER_ELEMENT;
        }(a), { byteOffset: l, byteLength: s } = t, u = r * i;
        let c;
        try {
            c = le(t.buffer);
        } catch (e) {
            return void o._errorSteps(e);
        }
        const d = {
            buffer: c,
            bufferByteLength: c.byteLength,
            byteOffset: l,
            byteLength: s,
            bytesFilled: 0,
            minimumFill: u,
            elementSize: i,
            viewConstructor: a,
            readerType: "byob"
        };
        if (e._pendingPullIntos.length > 0) return e._pendingPullIntos.push(d), void ot(n, o);
        if ("closed" === n._state) {
            const e = new a(d.buffer, d.byteOffset, 0);
            return void o._closeSteps(e);
        }
        if (e._queueTotalSize > 0) {
            if (ze(e, d)) {
                const t = Oe(d);
                return Le(e), void o._chunkSteps(t);
            }
            if (e._closeRequested) {
                const t = new TypeError("Insufficient bytes to fill elements in the given buffer");
                return He(e, t), void o._errorSteps(t);
            }
        }
        e._pendingPullIntos.push(d), ot(n, o), qe(e);
    }
    function Me(e, t) {
        const r = e._pendingPullIntos.peek();
        Fe(e);
        "closed" === e._controlledReadableByteStream._state ? function(e, t) {
            "none" === t.readerType && Ye(e);
            const r = e._controlledReadableByteStream;
            if (at(r)) {
                const t = [];
                for(; t.length < nt(r);)t.push(Ye(e));
                Be(r, t);
            }
        }(e, r) : function(e, t, r) {
            if (De(0, t, r), "none" === r.readerType) {
                Ae(e, r);
                const t = Ie(e);
                return void Be(e._controlledReadableByteStream, t);
            }
            if (r.bytesFilled < r.minimumFill) return;
            Ye(e);
            const o = r.bytesFilled % r.elementSize;
            if (o > 0) {
                const t = r.byteOffset + r.bytesFilled;
                ke(e, r.buffer, t - o, o);
            }
            r.bytesFilled -= o;
            const n = Ie(e);
            We(e._controlledReadableByteStream, r), Be(e._controlledReadableByteStream, n);
        }(e, t, r), qe(e);
    }
    function Ye(e) {
        return e._pendingPullIntos.shift();
    }
    function xe(e) {
        e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0;
    }
    function Qe(e) {
        const t = e._controlledReadableByteStream;
        if (!e._closeRequested && "readable" === t._state) {
            if (e._queueTotalSize > 0) e._closeRequested = !0;
            else {
                if (e._pendingPullIntos.length > 0) {
                    const t = e._pendingPullIntos.peek();
                    if (t.bytesFilled % t.elementSize !== 0) {
                        const t = new TypeError("Insufficient bytes to fill elements in the given buffer");
                        throw He(e, t), t;
                    }
                }
                xe(e), jr(t);
            }
        }
    }
    function Ne(e, t) {
        const r = e._controlledReadableByteStream;
        if (e._closeRequested || "readable" !== r._state) return;
        const { buffer: o, byteOffset: n, byteLength: a } = t;
        if (se(o)) throw new TypeError("chunk's buffer is detached and so cannot be enqueued");
        const i = le(o);
        if (e._pendingPullIntos.length > 0) {
            const t = e._pendingPullIntos.peek();
            if (se(t.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be filled with an enqueued chunk");
            Fe(e), t.buffer = le(t.buffer), "none" === t.readerType && Ae(e, t);
        }
        if (J(r)) {
            if (function(e) {
                const t = e._controlledReadableByteStream._reader;
                for(; t._readRequests.length > 0;){
                    if (0 === e._queueTotalSize) return;
                    Ve(e, t._readRequests.shift());
                }
            }(e), 0 === X(r)) je(e, i, n, a);
            else {
                e._pendingPullIntos.length > 0 && Ye(e);
                G(r, new Uint8Array(i, n, a), !1);
            }
        } else if (at(r)) {
            je(e, i, n, a);
            Be(r, Ie(e));
        } else je(e, i, n, a);
        qe(e);
    }
    function He(e, t) {
        const r = e._controlledReadableByteStream;
        "readable" === r._state && (Ee(e), Re(e), xe(e), kr(r, t));
    }
    function Ve(e, t) {
        const r = e._queue.shift();
        e._queueTotalSize -= r.byteLength, Le(e);
        const o = new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
        t._chunkSteps(o);
    }
    function Ue(e) {
        if (null === e._byobRequest && e._pendingPullIntos.length > 0) {
            const t = e._pendingPullIntos.peek(), r = new Uint8Array(t.buffer, t.byteOffset + t.bytesFilled, t.byteLength - t.bytesFilled), o = Object.create(ReadableStreamBYOBRequest.prototype);
            !function(e, t, r) {
                e._associatedReadableByteStreamController = t, e._view = r;
            }(o, e, r), e._byobRequest = o;
        }
        return e._byobRequest;
    }
    function Ge(e) {
        const t = e._controlledReadableByteStream._state;
        return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
    }
    function Xe(e, t) {
        const r = e._pendingPullIntos.peek();
        if ("closed" === e._controlledReadableByteStream._state) {
            if (0 !== t) throw new TypeError("bytesWritten must be 0 when calling respond() on a closed stream");
        } else {
            if (0 === t) throw new TypeError("bytesWritten must be greater than 0 when calling respond() on a readable stream");
            if (r.bytesFilled + t > r.byteLength) throw new RangeError("bytesWritten out of range");
        }
        r.buffer = le(r.buffer), Me(e, t);
    }
    function Je(e, t) {
        const r = e._pendingPullIntos.peek();
        if ("closed" === e._controlledReadableByteStream._state) {
            if (0 !== t.byteLength) throw new TypeError("The view's length must be 0 when calling respondWithNewView() on a closed stream");
        } else if (0 === t.byteLength) throw new TypeError("The view's length must be greater than 0 when calling respondWithNewView() on a readable stream");
        if (r.byteOffset + r.bytesFilled !== t.byteOffset) throw new RangeError("The region specified by view does not match byobRequest");
        if (r.bufferByteLength !== t.buffer.byteLength) throw new RangeError("The buffer of view has different capacity than byobRequest");
        if (r.bytesFilled + t.byteLength > r.byteLength) throw new RangeError("The region specified by view is larger than byobRequest");
        const o = t.byteLength;
        r.buffer = le(t.buffer), Me(e, o);
    }
    function Ke(e, t, r, o, n, a, i) {
        t._controlledReadableByteStream = e, t._pullAgain = !1, t._pulling = !1, t._byobRequest = null, t._queue = t._queueTotalSize = void 0, Re(t), t._closeRequested = !1, t._started = !1, t._strategyHWM = a, t._pullAlgorithm = o, t._cancelAlgorithm = n, t._autoAllocateChunkSize = i, t._pendingPullIntos = new w, e._readableStreamController = t;
        h(d(r()), ()=>(t._started = !0, qe(t), null), (e)=>(He(t, e), null));
    }
    function Ze(e) {
        return new TypeError(`ReadableStreamBYOBRequest.prototype.${e} can only be used on a ReadableStreamBYOBRequest`);
    }
    function et(e) {
        return new TypeError(`ReadableByteStreamController.prototype.${e} can only be used on a ReadableByteStreamController`);
    }
    function tt(e, t) {
        if ("byob" !== (e = `${e}`)) throw new TypeError(`${t} '${e}' is not a valid enumeration value for ReadableStreamReaderMode`);
        return e;
    }
    function rt(e) {
        return new ReadableStreamBYOBReader(e);
    }
    function ot(e, t) {
        e._reader._readIntoRequests.push(t);
    }
    function nt(e) {
        return e._reader._readIntoRequests.length;
    }
    function at(e) {
        const t = e._reader;
        return void 0 !== t && !!it(t);
    }
    Object.defineProperties(ReadableByteStreamController.prototype, {
        close: {
            enumerable: !0
        },
        enqueue: {
            enumerable: !0
        },
        error: {
            enumerable: !0
        },
        byobRequest: {
            enumerable: !0
        },
        desiredSize: {
            enumerable: !0
        }
    }), n(ReadableByteStreamController.prototype.close, "close"), n(ReadableByteStreamController.prototype.enqueue, "enqueue"), n(ReadableByteStreamController.prototype.error, "error"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty(ReadableByteStreamController.prototype, Symbol.toStringTag, {
        value: "ReadableByteStreamController",
        configurable: !0
    });
    class ReadableStreamBYOBReader {
        constructor(e){
            if (M(e, 1, "ReadableStreamBYOBReader"), H(e, "First parameter"), Br(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
            if (!Ce(e._readableStreamController)) throw new TypeError("Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte source");
            E(this, e), this._readIntoRequests = new w;
        }
        get closed() {
            return it(this) ? this._closedPromise : f(ut("closed"));
        }
        cancel(e) {
            return it(this) ? void 0 === this._ownerReadableStream ? f(O("cancel")) : W(this, e) : f(ut("cancel"));
        }
        read(e, t = {}) {
            if (!it(this)) return f(ut("read"));
            if (!ArrayBuffer.isView(e)) return f(new TypeError("view must be an array buffer view"));
            if (0 === e.byteLength) return f(new TypeError("view must have non-zero byteLength"));
            if (0 === e.buffer.byteLength) return f(new TypeError("view's buffer must have non-zero byteLength"));
            if (se(e.buffer)) return f(new TypeError("view's buffer has been detached"));
            let r;
            try {
                r = function(e, t) {
                    var r;
                    return F(e, t), {
                        min: N(null !== (r = null == e ? void 0 : e.min) && void 0 !== r ? r : 1, `${t} has member 'min' that`)
                    };
                }(t, "options");
            } catch (e) {
                return f(e);
            }
            const o = r.min;
            if (0 === o) return f(new TypeError("options.min must be greater than 0"));
            if (function(e) {
                return Te(e.constructor);
            }(e)) {
                if (o > e.byteLength) return f(new RangeError("options.min must be less than or equal to view's byteLength"));
            } else if (o > e.length) return f(new RangeError("options.min must be less than or equal to view's length"));
            if (void 0 === this._ownerReadableStream) return f(O("read from"));
            let n, a;
            const i = c((e, t)=>{
                n = e, a = t;
            });
            return lt(this, e, o, {
                _chunkSteps: (e)=>n({
                        value: e,
                        done: !1
                    }),
                _closeSteps: (e)=>n({
                        value: e,
                        done: !0
                    }),
                _errorSteps: (e)=>a(e)
            }), i;
        }
        releaseLock() {
            if (!it(this)) throw ut("releaseLock");
            void 0 !== this._ownerReadableStream && function(e) {
                B(e);
                const t = new TypeError("Reader was released");
                st(e, t);
            }(this);
        }
    }
    function it(e) {
        return !!r(e) && !!Object.prototype.hasOwnProperty.call(e, "_readIntoRequests") && e instanceof ReadableStreamBYOBReader;
    }
    function lt(e, t, r, o) {
        const n = e._ownerReadableStream;
        n._disturbed = !0, "errored" === n._state ? o._errorSteps(n._storedError) : $e(n._readableStreamController, t, r, o);
    }
    function st(e, t) {
        const r = e._readIntoRequests;
        e._readIntoRequests = new w, r.forEach((e)=>{
            e._errorSteps(t);
        });
    }
    function ut(e) {
        return new TypeError(`ReadableStreamBYOBReader.prototype.${e} can only be used on a ReadableStreamBYOBReader`);
    }
    function ct(e, t) {
        const { highWaterMark: r } = e;
        if (void 0 === r) return t;
        if (Se(r) || r < 0) throw new RangeError("Invalid highWaterMark");
        return r;
    }
    function dt(e) {
        const { size: t } = e;
        return t || (()=>1);
    }
    function ft(e, t) {
        F(e, t);
        const r = null == e ? void 0 : e.highWaterMark, o = null == e ? void 0 : e.size;
        return {
            highWaterMark: void 0 === r ? void 0 : x(r),
            size: void 0 === o ? void 0 : bt(o, `${t} has member 'size' that`)
        };
    }
    function bt(e, t) {
        return I(e, t), (t)=>x(e(t));
    }
    function ht(e, t, r) {
        return I(e, r), (r)=>v(e, t, [
                r
            ]);
    }
    function mt(e, t, r) {
        return I(e, r), ()=>v(e, t, []);
    }
    function _t(e, t, r) {
        return I(e, r), (r)=>g(e, t, [
                r
            ]);
    }
    function pt(e, t, r) {
        return I(e, r), (r, o)=>v(e, t, [
                r,
                o
            ]);
    }
    function yt(e, t) {
        if (!vt(e)) throw new TypeError(`${t} is not a WritableStream.`);
    }
    Object.defineProperties(ReadableStreamBYOBReader.prototype, {
        cancel: {
            enumerable: !0
        },
        read: {
            enumerable: !0
        },
        releaseLock: {
            enumerable: !0
        },
        closed: {
            enumerable: !0
        }
    }), n(ReadableStreamBYOBReader.prototype.cancel, "cancel"), n(ReadableStreamBYOBReader.prototype.read, "read"), n(ReadableStreamBYOBReader.prototype.releaseLock, "releaseLock"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty(ReadableStreamBYOBReader.prototype, Symbol.toStringTag, {
        value: "ReadableStreamBYOBReader",
        configurable: !0
    });
    class WritableStream {
        constructor(e = {}, t = {}){
            void 0 === e ? e = null : $(e, "First parameter");
            const r = ft(t, "Second parameter"), o = function(e, t) {
                F(e, t);
                const r = null == e ? void 0 : e.abort, o = null == e ? void 0 : e.close, n = null == e ? void 0 : e.start, a = null == e ? void 0 : e.type, i = null == e ? void 0 : e.write;
                return {
                    abort: void 0 === r ? void 0 : ht(r, e, `${t} has member 'abort' that`),
                    close: void 0 === o ? void 0 : mt(o, e, `${t} has member 'close' that`),
                    start: void 0 === n ? void 0 : _t(n, e, `${t} has member 'start' that`),
                    write: void 0 === i ? void 0 : pt(i, e, `${t} has member 'write' that`),
                    type: a
                };
            }(e, "First parameter");
            gt(this);
            if (void 0 !== o.type) throw new RangeError("Invalid type is specified");
            const n = dt(r);
            !function(e, t, r, o) {
                const n = Object.create(WritableStreamDefaultController.prototype);
                let a, i, l, s;
                a = void 0 !== t.start ? ()=>t.start(n) : ()=>{};
                i = void 0 !== t.write ? (e)=>t.write(e, n) : ()=>d(void 0);
                l = void 0 !== t.close ? ()=>t.close() : ()=>d(void 0);
                s = void 0 !== t.abort ? (e)=>t.abort(e) : ()=>d(void 0);
                It(e, n, a, i, l, s, r, o);
            }(this, o, ct(r, 1), n);
        }
        get locked() {
            if (!vt(this)) throw Ht("locked");
            return wt(this);
        }
        abort(e) {
            return vt(this) ? wt(this) ? f(new TypeError("Cannot abort a stream that already has a writer")) : Rt(this, e) : f(Ht("abort"));
        }
        close() {
            return vt(this) ? wt(this) ? f(new TypeError("Cannot close a stream that already has a writer")) : Et(this) ? f(new TypeError("Cannot close an already-closing stream")) : Tt(this) : f(Ht("close"));
        }
        getWriter() {
            if (!vt(this)) throw Ht("getWriter");
            return St(this);
        }
    }
    function St(e) {
        return new WritableStreamDefaultWriter(e);
    }
    function gt(e) {
        e._state = "writable", e._storedError = void 0, e._writer = void 0, e._writableStreamController = void 0, e._writeRequests = new w, e._inFlightWriteRequest = void 0, e._closeRequest = void 0, e._inFlightCloseRequest = void 0, e._pendingAbortRequest = void 0, e._backpressure = !1;
    }
    function vt(e) {
        return !!r(e) && !!Object.prototype.hasOwnProperty.call(e, "_writableStreamController") && e instanceof WritableStream;
    }
    function wt(e) {
        return void 0 !== e._writer;
    }
    function Rt(e, t) {
        var r;
        if ("closed" === e._state || "errored" === e._state) return d(void 0);
        e._writableStreamController._abortReason = t, null === (r = e._writableStreamController._abortController) || void 0 === r || r.abort(t);
        const o = e._state;
        if ("closed" === o || "errored" === o) return d(void 0);
        if (void 0 !== e._pendingAbortRequest) return e._pendingAbortRequest._promise;
        let n = !1;
        "erroring" === o && (n = !0, t = void 0);
        const a = c((r, o)=>{
            e._pendingAbortRequest = {
                _promise: void 0,
                _resolve: r,
                _reject: o,
                _reason: t,
                _wasAlreadyErroring: n
            };
        });
        return e._pendingAbortRequest._promise = a, n || Pt(e, t), a;
    }
    function Tt(e) {
        const t = e._state;
        if ("closed" === t || "errored" === t) return f(new TypeError(`The stream (in ${t} state) is not in the writable state and cannot be closed`));
        const r = c((t, r)=>{
            const o = {
                _resolve: t,
                _reject: r
            };
            e._closeRequest = o;
        }), o = e._writer;
        var n;
        return void 0 !== o && e._backpressure && "writable" === t && nr(o), we(n = e._writableStreamController, Lt, 0), Yt(n), r;
    }
    function Ct(e, t) {
        "writable" !== e._state ? qt(e) : Pt(e, t);
    }
    function Pt(e, t) {
        const r = e._writableStreamController;
        e._state = "erroring", e._storedError = t;
        const o = e._writer;
        void 0 !== o && At(o, t), !function(e) {
            if (void 0 === e._inFlightWriteRequest && void 0 === e._inFlightCloseRequest) return !1;
            return !0;
        }(e) && r._started && qt(e);
    }
    function qt(e) {
        e._state = "errored", e._writableStreamController[T]();
        const t = e._storedError;
        if (e._writeRequests.forEach((e)=>{
            e._reject(t);
        }), e._writeRequests = new w, void 0 === e._pendingAbortRequest) return void Wt(e);
        const r = e._pendingAbortRequest;
        if (e._pendingAbortRequest = void 0, r._wasAlreadyErroring) return r._reject(t), void Wt(e);
        h(e._writableStreamController[R](r._reason), ()=>(r._resolve(), Wt(e), null), (t)=>(r._reject(t), Wt(e), null));
    }
    function Et(e) {
        return void 0 !== e._closeRequest || void 0 !== e._inFlightCloseRequest;
    }
    function Wt(e) {
        void 0 !== e._closeRequest && (e._closeRequest._reject(e._storedError), e._closeRequest = void 0);
        const t = e._writer;
        void 0 !== t && Kt(t, e._storedError);
    }
    function Bt(e, t) {
        const r = e._writer;
        void 0 !== r && t !== e._backpressure && (t ? function(e) {
            er(e);
        }(r) : nr(r)), e._backpressure = t;
    }
    Object.defineProperties(WritableStream.prototype, {
        abort: {
            enumerable: !0
        },
        close: {
            enumerable: !0
        },
        getWriter: {
            enumerable: !0
        },
        locked: {
            enumerable: !0
        }
    }), n(WritableStream.prototype.abort, "abort"), n(WritableStream.prototype.close, "close"), n(WritableStream.prototype.getWriter, "getWriter"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty(WritableStream.prototype, Symbol.toStringTag, {
        value: "WritableStream",
        configurable: !0
    });
    class WritableStreamDefaultWriter {
        constructor(e){
            if (M(e, 1, "WritableStreamDefaultWriter"), yt(e, "First parameter"), wt(e)) throw new TypeError("This stream has already been locked for exclusive writing by another writer");
            this._ownerWritableStream = e, e._writer = this;
            const t = e._state;
            if ("writable" === t) !Et(e) && e._backpressure ? er(this) : rr(this), Xt(this);
            else if ("erroring" === t) tr(this, e._storedError), Xt(this);
            else if ("closed" === t) rr(this), Xt(r = this), Zt(r);
            else {
                const t = e._storedError;
                tr(this, t), Jt(this, t);
            }
            var r;
        }
        get closed() {
            return Ot(this) ? this._closedPromise : f(Ut("closed"));
        }
        get desiredSize() {
            if (!Ot(this)) throw Ut("desiredSize");
            if (void 0 === this._ownerWritableStream) throw Gt("desiredSize");
            return function(e) {
                const t = e._ownerWritableStream, r = t._state;
                if ("errored" === r || "erroring" === r) return null;
                if ("closed" === r) return 0;
                return Mt(t._writableStreamController);
            }(this);
        }
        get ready() {
            return Ot(this) ? this._readyPromise : f(Ut("ready"));
        }
        abort(e) {
            return Ot(this) ? void 0 === this._ownerWritableStream ? f(Gt("abort")) : function(e, t) {
                return Rt(e._ownerWritableStream, t);
            }(this, e) : f(Ut("abort"));
        }
        close() {
            if (!Ot(this)) return f(Ut("close"));
            const e = this._ownerWritableStream;
            return void 0 === e ? f(Gt("close")) : Et(e) ? f(new TypeError("Cannot close an already-closing stream")) : jt(this);
        }
        releaseLock() {
            if (!Ot(this)) throw Ut("releaseLock");
            void 0 !== this._ownerWritableStream && zt(this);
        }
        write(e) {
            return Ot(this) ? void 0 === this._ownerWritableStream ? f(Gt("write to")) : Dt(this, e) : f(Ut("write"));
        }
    }
    function Ot(e) {
        return !!r(e) && !!Object.prototype.hasOwnProperty.call(e, "_ownerWritableStream") && e instanceof WritableStreamDefaultWriter;
    }
    function jt(e) {
        return Tt(e._ownerWritableStream);
    }
    function kt(e, t) {
        "pending" === e._closedPromiseState ? Kt(e, t) : function(e, t) {
            Jt(e, t);
        }(e, t);
    }
    function At(e, t) {
        "pending" === e._readyPromiseState ? or(e, t) : function(e, t) {
            tr(e, t);
        }(e, t);
    }
    function zt(e) {
        const t = e._ownerWritableStream, r = new TypeError("Writer was released and can no longer be used to monitor the stream's closedness");
        At(e, r), kt(e, r), t._writer = void 0, e._ownerWritableStream = void 0;
    }
    function Dt(e, t) {
        const r = e._ownerWritableStream, o = r._writableStreamController, n = function(e, t) {
            if (void 0 === e._strategySizeAlgorithm) return 1;
            try {
                return e._strategySizeAlgorithm(t);
            } catch (t) {
                return xt(e, t), 1;
            }
        }(o, t);
        if (r !== e._ownerWritableStream) return f(Gt("write to"));
        const a = r._state;
        if ("errored" === a) return f(r._storedError);
        if (Et(r) || "closed" === a) return f(new TypeError("The stream is closing or closed and cannot be written to"));
        if ("erroring" === a) return f(r._storedError);
        const i = function(e) {
            return c((t, r)=>{
                const o = {
                    _resolve: t,
                    _reject: r
                };
                e._writeRequests.push(o);
            });
        }(r);
        return function(e, t, r) {
            try {
                we(e, t, r);
            } catch (t) {
                return void xt(e, t);
            }
            const o = e._controlledWritableStream;
            if (!Et(o) && "writable" === o._state) Bt(o, Qt(e));
            Yt(e);
        }(o, t, n), i;
    }
    Object.defineProperties(WritableStreamDefaultWriter.prototype, {
        abort: {
            enumerable: !0
        },
        close: {
            enumerable: !0
        },
        releaseLock: {
            enumerable: !0
        },
        write: {
            enumerable: !0
        },
        closed: {
            enumerable: !0
        },
        desiredSize: {
            enumerable: !0
        },
        ready: {
            enumerable: !0
        }
    }), n(WritableStreamDefaultWriter.prototype.abort, "abort"), n(WritableStreamDefaultWriter.prototype.close, "close"), n(WritableStreamDefaultWriter.prototype.releaseLock, "releaseLock"), n(WritableStreamDefaultWriter.prototype.write, "write"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty(WritableStreamDefaultWriter.prototype, Symbol.toStringTag, {
        value: "WritableStreamDefaultWriter",
        configurable: !0
    });
    const Lt = {};
    class WritableStreamDefaultController {
        constructor(){
            throw new TypeError("Illegal constructor");
        }
        get abortReason() {
            if (!Ft(this)) throw Vt("abortReason");
            return this._abortReason;
        }
        get signal() {
            if (!Ft(this)) throw Vt("signal");
            if (void 0 === this._abortController) throw new TypeError("WritableStreamDefaultController.prototype.signal is not supported");
            return this._abortController.signal;
        }
        error(e) {
            if (!Ft(this)) throw Vt("error");
            "writable" === this._controlledWritableStream._state && Nt(this, e);
        }
        [R](e) {
            const t = this._abortAlgorithm(e);
            return $t(this), t;
        }
        [T]() {
            Re(this);
        }
    }
    function Ft(e) {
        return !!r(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledWritableStream") && e instanceof WritableStreamDefaultController;
    }
    function It(e, t, r, o, n, a, i, l) {
        t._controlledWritableStream = e, e._writableStreamController = t, t._queue = void 0, t._queueTotalSize = void 0, Re(t), t._abortReason = void 0, t._abortController = function() {
            if ("function" == typeof AbortController) return new AbortController;
        }(), t._started = !1, t._strategySizeAlgorithm = l, t._strategyHWM = i, t._writeAlgorithm = o, t._closeAlgorithm = n, t._abortAlgorithm = a;
        const s = Qt(t);
        Bt(e, s);
        h(d(r()), ()=>(t._started = !0, Yt(t), null), (r)=>(t._started = !0, Ct(e, r), null));
    }
    function $t(e) {
        e._writeAlgorithm = void 0, e._closeAlgorithm = void 0, e._abortAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
    }
    function Mt(e) {
        return e._strategyHWM - e._queueTotalSize;
    }
    function Yt(e) {
        const t = e._controlledWritableStream;
        if (!e._started) return;
        if (void 0 !== t._inFlightWriteRequest) return;
        if ("erroring" === t._state) return void qt(t);
        if (0 === e._queue.length) return;
        const r = e._queue.peek().value;
        r === Lt ? function(e) {
            const t = e._controlledWritableStream;
            (function(e) {
                e._inFlightCloseRequest = e._closeRequest, e._closeRequest = void 0;
            })(t), ve(e);
            const r = e._closeAlgorithm();
            $t(e), h(r, ()=>((function(e) {
                    e._inFlightCloseRequest._resolve(void 0), e._inFlightCloseRequest = void 0, "erroring" === e._state && (e._storedError = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._resolve(), e._pendingAbortRequest = void 0)), e._state = "closed";
                    const t = e._writer;
                    void 0 !== t && Zt(t);
                })(t), null), (e)=>((function(e, t) {
                    e._inFlightCloseRequest._reject(t), e._inFlightCloseRequest = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._reject(t), e._pendingAbortRequest = void 0), Ct(e, t);
                })(t, e), null));
        }(e) : function(e, t) {
            const r = e._controlledWritableStream;
            !function(e) {
                e._inFlightWriteRequest = e._writeRequests.shift();
            }(r);
            const o = e._writeAlgorithm(t);
            h(o, ()=>{
                !function(e) {
                    e._inFlightWriteRequest._resolve(void 0), e._inFlightWriteRequest = void 0;
                }(r);
                const t = r._state;
                if (ve(e), !Et(r) && "writable" === t) {
                    const t = Qt(e);
                    Bt(r, t);
                }
                return Yt(e), null;
            }, (t)=>("writable" === r._state && $t(e), function(e, t) {
                    e._inFlightWriteRequest._reject(t), e._inFlightWriteRequest = void 0, Ct(e, t);
                }(r, t), null));
        }(e, r);
    }
    function xt(e, t) {
        "writable" === e._controlledWritableStream._state && Nt(e, t);
    }
    function Qt(e) {
        return Mt(e) <= 0;
    }
    function Nt(e, t) {
        const r = e._controlledWritableStream;
        $t(e), Pt(r, t);
    }
    function Ht(e) {
        return new TypeError(`WritableStream.prototype.${e} can only be used on a WritableStream`);
    }
    function Vt(e) {
        return new TypeError(`WritableStreamDefaultController.prototype.${e} can only be used on a WritableStreamDefaultController`);
    }
    function Ut(e) {
        return new TypeError(`WritableStreamDefaultWriter.prototype.${e} can only be used on a WritableStreamDefaultWriter`);
    }
    function Gt(e) {
        return new TypeError("Cannot " + e + " a stream using a released writer");
    }
    function Xt(e) {
        e._closedPromise = c((t, r)=>{
            e._closedPromise_resolve = t, e._closedPromise_reject = r, e._closedPromiseState = "pending";
        });
    }
    function Jt(e, t) {
        Xt(e), Kt(e, t);
    }
    function Kt(e, t) {
        void 0 !== e._closedPromise_reject && (y(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "rejected");
    }
    function Zt(e) {
        void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "resolved");
    }
    function er(e) {
        e._readyPromise = c((t, r)=>{
            e._readyPromise_resolve = t, e._readyPromise_reject = r;
        }), e._readyPromiseState = "pending";
    }
    function tr(e, t) {
        er(e), or(e, t);
    }
    function rr(e) {
        er(e), nr(e);
    }
    function or(e, t) {
        void 0 !== e._readyPromise_reject && (y(e._readyPromise), e._readyPromise_reject(t), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "rejected");
    }
    function nr(e) {
        void 0 !== e._readyPromise_resolve && (e._readyPromise_resolve(void 0), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "fulfilled");
    }
    Object.defineProperties(WritableStreamDefaultController.prototype, {
        abortReason: {
            enumerable: !0
        },
        signal: {
            enumerable: !0
        },
        error: {
            enumerable: !0
        }
    }), "symbol" == typeof Symbol.toStringTag && Object.defineProperty(WritableStreamDefaultController.prototype, Symbol.toStringTag, {
        value: "WritableStreamDefaultController",
        configurable: !0
    });
    const ar = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof $parcel$global ? $parcel$global : void 0;
    const ir = function() {
        const e = null == ar ? void 0 : ar.DOMException;
        return function(e) {
            if ("function" != typeof e && "object" != typeof e) return !1;
            if ("DOMException" !== e.name) return !1;
            try {
                return new e, !0;
            } catch (e) {
                return !1;
            }
        }(e) ? e : void 0;
    }() || function() {
        const e = function(e, t) {
            this.message = e || "", this.name = t || "Error", Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
        };
        return n(e, "DOMException"), e.prototype = Object.create(Error.prototype), Object.defineProperty(e.prototype, "constructor", {
            value: e,
            writable: !0,
            configurable: !0
        }), e;
    }();
    function lr(e, r, o, n, a, i) {
        const l = V(e), s = St(r);
        e._disturbed = !0;
        let u = !1, p = d(void 0);
        return c((S, g)=>{
            let v;
            if (void 0 !== i) {
                if (v = ()=>{
                    const t = void 0 !== i.reason ? i.reason : new ir("Aborted", "AbortError"), o = [];
                    n || o.push(()=>"writable" === r._state ? Rt(r, t) : d(void 0)), a || o.push(()=>"readable" === e._state ? Or(e, t) : d(void 0)), q(()=>Promise.all(o.map((e)=>e())), !0, t);
                }, i.aborted) return void v();
                i.addEventListener("abort", v);
            }
            var w, R, T;
            if (P(e, l._closedPromise, (e)=>(n ? E(!0, e) : q(()=>Rt(r, e), !0, e), null)), P(r, s._closedPromise, (t)=>(a ? E(!0, t) : q(()=>Or(e, t), !0, t), null)), w = e, R = l._closedPromise, T = ()=>(o ? E() : q(()=>(function(e) {
                        const t = e._ownerWritableStream, r = t._state;
                        return Et(t) || "closed" === r ? d(void 0) : "errored" === r ? f(t._storedError) : jt(e);
                    })(s)), null), "closed" === w._state ? T() : m(R, T), Et(r) || "closed" === r._state) {
                const t = new TypeError("the destination writable stream closed before all data could be piped to it");
                a ? E(!0, t) : q(()=>Or(e, t), !0, t);
            }
            function C() {
                const e = p;
                return b(p, ()=>e !== p ? C() : void 0);
            }
            function P(e, t, r) {
                "errored" === e._state ? r(e._storedError) : _(t, r);
            }
            function q(e, t, o) {
                function n() {
                    return h(e(), ()=>W(t, o), (e)=>W(!0, e)), null;
                }
                u || (u = !0, "writable" !== r._state || Et(r) ? n() : m(C(), n));
            }
            function E(e, t) {
                u || (u = !0, "writable" !== r._state || Et(r) ? W(e, t) : m(C(), ()=>W(e, t)));
            }
            function W(e, t) {
                return zt(s), B(l), void 0 !== i && i.removeEventListener("abort", v), e ? g(t) : S(void 0), null;
            }
            y(c((e, r)=>{
                !function o(n) {
                    n ? e() : b(u ? d(!0) : b(s._readyPromise, ()=>c((e, r)=>{
                            Z(l, {
                                _chunkSteps: (r)=>{
                                    p = b(Dt(s, r), void 0, t), e(!1);
                                },
                                _closeSteps: ()=>e(!0),
                                _errorSteps: r
                            });
                        })), o, r);
                }(!1);
            }));
        });
    }
    class ReadableStreamDefaultController {
        constructor(){
            throw new TypeError("Illegal constructor");
        }
        get desiredSize() {
            if (!sr(this)) throw yr("desiredSize");
            return mr(this);
        }
        close() {
            if (!sr(this)) throw yr("close");
            if (!_r(this)) throw new TypeError("The stream is not in a state that permits close");
            fr(this);
        }
        enqueue(e) {
            if (!sr(this)) throw yr("enqueue");
            if (!_r(this)) throw new TypeError("The stream is not in a state that permits enqueue");
            return br(this, e);
        }
        error(e) {
            if (!sr(this)) throw yr("error");
            hr(this, e);
        }
        [C](e) {
            Re(this);
            const t = this._cancelAlgorithm(e);
            return dr(this), t;
        }
        [P](e) {
            const t = this._controlledReadableStream;
            if (this._queue.length > 0) {
                const r = ve(this);
                this._closeRequested && 0 === this._queue.length ? (dr(this), jr(t)) : ur(this), e._chunkSteps(r);
            } else U(t, e), ur(this);
        }
        [q]() {}
    }
    function sr(e) {
        return !!r(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableStream") && e instanceof ReadableStreamDefaultController;
    }
    function ur(e) {
        if (!cr(e)) return;
        if (e._pulling) return void (e._pullAgain = !0);
        e._pulling = !0;
        h(e._pullAlgorithm(), ()=>(e._pulling = !1, e._pullAgain && (e._pullAgain = !1, ur(e)), null), (t)=>(hr(e, t), null));
    }
    function cr(e) {
        const t = e._controlledReadableStream;
        if (!_r(e)) return !1;
        if (!e._started) return !1;
        if (Br(t) && X(t) > 0) return !0;
        return mr(e) > 0;
    }
    function dr(e) {
        e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
    }
    function fr(e) {
        if (!_r(e)) return;
        const t = e._controlledReadableStream;
        e._closeRequested = !0, 0 === e._queue.length && (dr(e), jr(t));
    }
    function br(e, t) {
        if (!_r(e)) return;
        const r = e._controlledReadableStream;
        if (Br(r) && X(r) > 0) G(r, t, !1);
        else {
            let r;
            try {
                r = e._strategySizeAlgorithm(t);
            } catch (t) {
                throw hr(e, t), t;
            }
            try {
                we(e, t, r);
            } catch (t) {
                throw hr(e, t), t;
            }
        }
        ur(e);
    }
    function hr(e, t) {
        const r = e._controlledReadableStream;
        "readable" === r._state && (Re(e), dr(e), kr(r, t));
    }
    function mr(e) {
        const t = e._controlledReadableStream._state;
        return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
    }
    function _r(e) {
        const t = e._controlledReadableStream._state;
        return !e._closeRequested && "readable" === t;
    }
    function pr(e, t, r, o, n, a, i) {
        t._controlledReadableStream = e, t._queue = void 0, t._queueTotalSize = void 0, Re(t), t._started = !1, t._closeRequested = !1, t._pullAgain = !1, t._pulling = !1, t._strategySizeAlgorithm = i, t._strategyHWM = a, t._pullAlgorithm = o, t._cancelAlgorithm = n, e._readableStreamController = t;
        h(d(r()), ()=>(t._started = !0, ur(t), null), (e)=>(hr(t, e), null));
    }
    function yr(e) {
        return new TypeError(`ReadableStreamDefaultController.prototype.${e} can only be used on a ReadableStreamDefaultController`);
    }
    function Sr(e, t) {
        return Ce(e._readableStreamController) ? function(e) {
            let t, r, o, n, a, i = V(e), l = !1, s = !1, u = !1, f = !1, b = !1;
            const h = c((e)=>{
                a = e;
            });
            function m(e) {
                _(e._closedPromise, (t)=>(e !== i || (He(o._readableStreamController, t), He(n._readableStreamController, t), f && b || a(void 0)), null));
            }
            function p() {
                it(i) && (B(i), i = V(e), m(i));
                Z(i, {
                    _chunkSteps: (t)=>{
                        S(()=>{
                            s = !1, u = !1;
                            const r = t;
                            let i = t;
                            if (!f && !b) try {
                                i = ge(t);
                            } catch (t) {
                                return He(o._readableStreamController, t), He(n._readableStreamController, t), void a(Or(e, t));
                            }
                            f || Ne(o._readableStreamController, r), b || Ne(n._readableStreamController, i), l = !1, s ? g() : u && v();
                        });
                    },
                    _closeSteps: ()=>{
                        l = !1, f || Qe(o._readableStreamController), b || Qe(n._readableStreamController), o._readableStreamController._pendingPullIntos.length > 0 && Xe(o._readableStreamController, 0), n._readableStreamController._pendingPullIntos.length > 0 && Xe(n._readableStreamController, 0), f && b || a(void 0);
                    },
                    _errorSteps: ()=>{
                        l = !1;
                    }
                });
            }
            function y(t, r) {
                K(i) && (B(i), i = rt(e), m(i));
                const c = r ? n : o, d = r ? o : n;
                lt(i, t, 1, {
                    _chunkSteps: (t)=>{
                        S(()=>{
                            s = !1, u = !1;
                            const o = r ? b : f;
                            if (r ? f : b) o || Je(c._readableStreamController, t);
                            else {
                                let r;
                                try {
                                    r = ge(t);
                                } catch (t) {
                                    return He(c._readableStreamController, t), He(d._readableStreamController, t), void a(Or(e, t));
                                }
                                o || Je(c._readableStreamController, t), Ne(d._readableStreamController, r);
                            }
                            l = !1, s ? g() : u && v();
                        });
                    },
                    _closeSteps: (e)=>{
                        l = !1;
                        const t = r ? b : f, o = r ? f : b;
                        t || Qe(c._readableStreamController), o || Qe(d._readableStreamController), void 0 !== e && (t || Je(c._readableStreamController, e), !o && d._readableStreamController._pendingPullIntos.length > 0 && Xe(d._readableStreamController, 0)), t && o || a(void 0);
                    },
                    _errorSteps: ()=>{
                        l = !1;
                    }
                });
            }
            function g() {
                if (l) return s = !0, d(void 0);
                l = !0;
                const e = Ue(o._readableStreamController);
                return null === e ? p() : y(e._view, !1), d(void 0);
            }
            function v() {
                if (l) return u = !0, d(void 0);
                l = !0;
                const e = Ue(n._readableStreamController);
                return null === e ? p() : y(e._view, !0), d(void 0);
            }
            function w(o) {
                if (f = !0, t = o, b) {
                    const o = ae([
                        t,
                        r
                    ]), n = Or(e, o);
                    a(n);
                }
                return h;
            }
            function R(o) {
                if (b = !0, r = o, f) {
                    const o = ae([
                        t,
                        r
                    ]), n = Or(e, o);
                    a(n);
                }
                return h;
            }
            function T() {}
            return o = qr(T, g, w), n = qr(T, v, R), m(i), [
                o,
                n
            ];
        }(e) : function(e) {
            const t = V(e);
            let r, o, n, a, i, l = !1, s = !1, u = !1, f = !1;
            const b = c((e)=>{
                i = e;
            });
            function h() {
                if (l) return s = !0, d(void 0);
                l = !0;
                return Z(t, {
                    _chunkSteps: (e)=>{
                        S(()=>{
                            s = !1;
                            const t = e, r = e;
                            u || br(n._readableStreamController, t), f || br(a._readableStreamController, r), l = !1, s && h();
                        });
                    },
                    _closeSteps: ()=>{
                        l = !1, u || fr(n._readableStreamController), f || fr(a._readableStreamController), u && f || i(void 0);
                    },
                    _errorSteps: ()=>{
                        l = !1;
                    }
                }), d(void 0);
            }
            function m(t) {
                if (u = !0, r = t, f) {
                    const t = ae([
                        r,
                        o
                    ]), n = Or(e, t);
                    i(n);
                }
                return b;
            }
            function p(t) {
                if (f = !0, o = t, u) {
                    const t = ae([
                        r,
                        o
                    ]), n = Or(e, t);
                    i(n);
                }
                return b;
            }
            function y() {}
            return n = Pr(y, h, m), a = Pr(y, h, p), _(t._closedPromise, (e)=>(hr(n._readableStreamController, e), hr(a._readableStreamController, e), u && f || i(void 0), null)), [
                n,
                a
            ];
        }(e);
    }
    function gr(e) {
        var o;
        return r(o = e) && void 0 !== o.getReader ? function(e) {
            let o;
            function n() {
                let t;
                try {
                    t = e.read();
                } catch (e) {
                    return f(e);
                }
                return p(t, (e)=>{
                    if (!r(e)) throw new TypeError("The promise returned by the reader.read() method must fulfill with an object");
                    if (e.done) fr(o._readableStreamController);
                    else {
                        const t = e.value;
                        br(o._readableStreamController, t);
                    }
                });
            }
            function a(t) {
                try {
                    return d(e.cancel(t));
                } catch (e) {
                    return f(e);
                }
            }
            return o = Pr(t, n, a, 0), o;
        }(e.getReader()) : function(e) {
            let o;
            const n = be(e, "async");
            function a() {
                let e;
                try {
                    e = he(n);
                } catch (e) {
                    return f(e);
                }
                return p(d(e), (e)=>{
                    if (!r(e)) throw new TypeError("The promise returned by the iterator.next() method must fulfill with an object");
                    if (e.done) fr(o._readableStreamController);
                    else {
                        const t = e.value;
                        br(o._readableStreamController, t);
                    }
                });
            }
            function i(e) {
                const t = n.iterator;
                let o;
                try {
                    o = ce(t, "return");
                } catch (e) {
                    return f(e);
                }
                if (void 0 === o) return d(void 0);
                return p(v(o, t, [
                    e
                ]), (e)=>{
                    if (!r(e)) throw new TypeError("The promise returned by the iterator.return() method must fulfill with an object");
                });
            }
            return o = Pr(t, a, i, 0), o;
        }(e);
    }
    function vr(e, t, r) {
        return I(e, r), (r)=>v(e, t, [
                r
            ]);
    }
    function wr(e, t, r) {
        return I(e, r), (r)=>v(e, t, [
                r
            ]);
    }
    function Rr(e, t, r) {
        return I(e, r), (r)=>g(e, t, [
                r
            ]);
    }
    function Tr(e, t) {
        if ("bytes" !== (e = `${e}`)) throw new TypeError(`${t} '${e}' is not a valid enumeration value for ReadableStreamType`);
        return e;
    }
    function Cr(e, t) {
        F(e, t);
        const r = null == e ? void 0 : e.preventAbort, o = null == e ? void 0 : e.preventCancel, n = null == e ? void 0 : e.preventClose, a = null == e ? void 0 : e.signal;
        return void 0 !== a && function(e, t) {
            if (!function(e) {
                if ("object" != typeof e || null === e) return !1;
                try {
                    return "boolean" == typeof e.aborted;
                } catch (e) {
                    return !1;
                }
            }(e)) throw new TypeError(`${t} is not an AbortSignal.`);
        }(a, `${t} has member 'signal' that`), {
            preventAbort: Boolean(r),
            preventCancel: Boolean(o),
            preventClose: Boolean(n),
            signal: a
        };
    }
    Object.defineProperties(ReadableStreamDefaultController.prototype, {
        close: {
            enumerable: !0
        },
        enqueue: {
            enumerable: !0
        },
        error: {
            enumerable: !0
        },
        desiredSize: {
            enumerable: !0
        }
    }), n(ReadableStreamDefaultController.prototype.close, "close"), n(ReadableStreamDefaultController.prototype.enqueue, "enqueue"), n(ReadableStreamDefaultController.prototype.error, "error"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty(ReadableStreamDefaultController.prototype, Symbol.toStringTag, {
        value: "ReadableStreamDefaultController",
        configurable: !0
    });
    class ReadableStream {
        constructor(e = {}, t = {}){
            void 0 === e ? e = null : $(e, "First parameter");
            const r = ft(t, "Second parameter"), o = function(e, t) {
                F(e, t);
                const r = e, o = null == r ? void 0 : r.autoAllocateChunkSize, n = null == r ? void 0 : r.cancel, a = null == r ? void 0 : r.pull, i = null == r ? void 0 : r.start, l = null == r ? void 0 : r.type;
                return {
                    autoAllocateChunkSize: void 0 === o ? void 0 : N(o, `${t} has member 'autoAllocateChunkSize' that`),
                    cancel: void 0 === n ? void 0 : vr(n, r, `${t} has member 'cancel' that`),
                    pull: void 0 === a ? void 0 : wr(a, r, `${t} has member 'pull' that`),
                    start: void 0 === i ? void 0 : Rr(i, r, `${t} has member 'start' that`),
                    type: void 0 === l ? void 0 : Tr(l, `${t} has member 'type' that`)
                };
            }(e, "First parameter");
            if (Er(this), "bytes" === o.type) {
                if (void 0 !== r.size) throw new RangeError("The strategy for a byte stream cannot have a size function");
                !function(e, t, r) {
                    const o = Object.create(ReadableByteStreamController.prototype);
                    let n, a, i;
                    n = void 0 !== t.start ? ()=>t.start(o) : ()=>{}, a = void 0 !== t.pull ? ()=>t.pull(o) : ()=>d(void 0), i = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>d(void 0);
                    const l = t.autoAllocateChunkSize;
                    if (0 === l) throw new TypeError("autoAllocateChunkSize must be greater than 0");
                    Ke(e, o, n, a, i, r, l);
                }(this, o, ct(r, 0));
            } else {
                const e = dt(r);
                !function(e, t, r, o) {
                    const n = Object.create(ReadableStreamDefaultController.prototype);
                    let a, i, l;
                    a = void 0 !== t.start ? ()=>t.start(n) : ()=>{}, i = void 0 !== t.pull ? ()=>t.pull(n) : ()=>d(void 0), l = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>d(void 0), pr(e, n, a, i, l, r, o);
                }(this, o, ct(r, 1), e);
            }
        }
        get locked() {
            if (!Wr(this)) throw Ar("locked");
            return Br(this);
        }
        cancel(e) {
            return Wr(this) ? Br(this) ? f(new TypeError("Cannot cancel a stream that already has a reader")) : Or(this, e) : f(Ar("cancel"));
        }
        getReader(e) {
            if (!Wr(this)) throw Ar("getReader");
            return void 0 === function(e, t) {
                F(e, t);
                const r = null == e ? void 0 : e.mode;
                return {
                    mode: void 0 === r ? void 0 : tt(r, `${t} has member 'mode' that`)
                };
            }(e, "First parameter").mode ? V(this) : rt(this);
        }
        pipeThrough(e, t = {}) {
            if (!Wr(this)) throw Ar("pipeThrough");
            M(e, 1, "pipeThrough");
            const r = function(e, t) {
                F(e, t);
                const r = null == e ? void 0 : e.readable;
                Y(r, "readable", "ReadableWritablePair"), H(r, `${t} has member 'readable' that`);
                const o = null == e ? void 0 : e.writable;
                return Y(o, "writable", "ReadableWritablePair"), yt(o, `${t} has member 'writable' that`), {
                    readable: r,
                    writable: o
                };
            }(e, "First parameter"), o = Cr(t, "Second parameter");
            if (Br(this)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked ReadableStream");
            if (wt(r.writable)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked WritableStream");
            return y(lr(this, r.writable, o.preventClose, o.preventAbort, o.preventCancel, o.signal)), r.readable;
        }
        pipeTo(e, t = {}) {
            if (!Wr(this)) return f(Ar("pipeTo"));
            if (void 0 === e) return f("Parameter 1 is required in 'pipeTo'.");
            if (!vt(e)) return f(new TypeError("ReadableStream.prototype.pipeTo's first argument must be a WritableStream"));
            let r;
            try {
                r = Cr(t, "Second parameter");
            } catch (e) {
                return f(e);
            }
            return Br(this) ? f(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream")) : wt(e) ? f(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream")) : lr(this, e, r.preventClose, r.preventAbort, r.preventCancel, r.signal);
        }
        tee() {
            if (!Wr(this)) throw Ar("tee");
            return ae(Sr(this));
        }
        values(e) {
            if (!Wr(this)) throw Ar("values");
            return function(e, t) {
                const r = V(e), o = new me(r, t), n = Object.create(_e);
                return n._asyncIteratorImpl = o, n;
            }(this, function(e, t) {
                F(e, t);
                const r = null == e ? void 0 : e.preventCancel;
                return {
                    preventCancel: Boolean(r)
                };
            }(e, "First parameter").preventCancel);
        }
        [fe](e) {
            return this.values(e);
        }
        static from(e) {
            return gr(e);
        }
    }
    function Pr(e, t, r, o = 1, n = ()=>1) {
        const a = Object.create(ReadableStream.prototype);
        Er(a);
        return pr(a, Object.create(ReadableStreamDefaultController.prototype), e, t, r, o, n), a;
    }
    function qr(e, t, r) {
        const o = Object.create(ReadableStream.prototype);
        Er(o);
        return Ke(o, Object.create(ReadableByteStreamController.prototype), e, t, r, 0, void 0), o;
    }
    function Er(e) {
        e._state = "readable", e._reader = void 0, e._storedError = void 0, e._disturbed = !1;
    }
    function Wr(e) {
        return !!r(e) && !!Object.prototype.hasOwnProperty.call(e, "_readableStreamController") && e instanceof ReadableStream;
    }
    function Br(e) {
        return void 0 !== e._reader;
    }
    function Or(e, r) {
        if (e._disturbed = !0, "closed" === e._state) return d(void 0);
        if ("errored" === e._state) return f(e._storedError);
        jr(e);
        const o = e._reader;
        if (void 0 !== o && it(o)) {
            const e = o._readIntoRequests;
            o._readIntoRequests = new w, e.forEach((e)=>{
                e._closeSteps(void 0);
            });
        }
        return p(e._readableStreamController[C](r), t);
    }
    function jr(e) {
        e._state = "closed";
        const t = e._reader;
        if (void 0 !== t && (z(t), K(t))) {
            const e = t._readRequests;
            t._readRequests = new w, e.forEach((e)=>{
                e._closeSteps();
            });
        }
    }
    function kr(e, t) {
        e._state = "errored", e._storedError = t;
        const r = e._reader;
        void 0 !== r && (A(r, t), K(r) ? ee(r, t) : st(r, t));
    }
    function Ar(e) {
        return new TypeError(`ReadableStream.prototype.${e} can only be used on a ReadableStream`);
    }
    function zr(e, t) {
        F(e, t);
        const r = null == e ? void 0 : e.highWaterMark;
        return Y(r, "highWaterMark", "QueuingStrategyInit"), {
            highWaterMark: x(r)
        };
    }
    Object.defineProperties(ReadableStream, {
        from: {
            enumerable: !0
        }
    }), Object.defineProperties(ReadableStream.prototype, {
        cancel: {
            enumerable: !0
        },
        getReader: {
            enumerable: !0
        },
        pipeThrough: {
            enumerable: !0
        },
        pipeTo: {
            enumerable: !0
        },
        tee: {
            enumerable: !0
        },
        values: {
            enumerable: !0
        },
        locked: {
            enumerable: !0
        }
    }), n(ReadableStream.from, "from"), n(ReadableStream.prototype.cancel, "cancel"), n(ReadableStream.prototype.getReader, "getReader"), n(ReadableStream.prototype.pipeThrough, "pipeThrough"), n(ReadableStream.prototype.pipeTo, "pipeTo"), n(ReadableStream.prototype.tee, "tee"), n(ReadableStream.prototype.values, "values"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty(ReadableStream.prototype, Symbol.toStringTag, {
        value: "ReadableStream",
        configurable: !0
    }), Object.defineProperty(ReadableStream.prototype, fe, {
        value: ReadableStream.prototype.values,
        writable: !0,
        configurable: !0
    });
    const Dr = (e)=>e.byteLength;
    n(Dr, "size");
    class ByteLengthQueuingStrategy {
        constructor(e){
            M(e, 1, "ByteLengthQueuingStrategy"), e = zr(e, "First parameter"), this._byteLengthQueuingStrategyHighWaterMark = e.highWaterMark;
        }
        get highWaterMark() {
            if (!Fr(this)) throw Lr("highWaterMark");
            return this._byteLengthQueuingStrategyHighWaterMark;
        }
        get size() {
            if (!Fr(this)) throw Lr("size");
            return Dr;
        }
    }
    function Lr(e) {
        return new TypeError(`ByteLengthQueuingStrategy.prototype.${e} can only be used on a ByteLengthQueuingStrategy`);
    }
    function Fr(e) {
        return !!r(e) && !!Object.prototype.hasOwnProperty.call(e, "_byteLengthQueuingStrategyHighWaterMark") && e instanceof ByteLengthQueuingStrategy;
    }
    Object.defineProperties(ByteLengthQueuingStrategy.prototype, {
        highWaterMark: {
            enumerable: !0
        },
        size: {
            enumerable: !0
        }
    }), "symbol" == typeof Symbol.toStringTag && Object.defineProperty(ByteLengthQueuingStrategy.prototype, Symbol.toStringTag, {
        value: "ByteLengthQueuingStrategy",
        configurable: !0
    });
    const Ir = ()=>1;
    n(Ir, "size");
    class CountQueuingStrategy {
        constructor(e){
            M(e, 1, "CountQueuingStrategy"), e = zr(e, "First parameter"), this._countQueuingStrategyHighWaterMark = e.highWaterMark;
        }
        get highWaterMark() {
            if (!Mr(this)) throw $r("highWaterMark");
            return this._countQueuingStrategyHighWaterMark;
        }
        get size() {
            if (!Mr(this)) throw $r("size");
            return Ir;
        }
    }
    function $r(e) {
        return new TypeError(`CountQueuingStrategy.prototype.${e} can only be used on a CountQueuingStrategy`);
    }
    function Mr(e) {
        return !!r(e) && !!Object.prototype.hasOwnProperty.call(e, "_countQueuingStrategyHighWaterMark") && e instanceof CountQueuingStrategy;
    }
    function Yr(e, t, r) {
        return I(e, r), (r)=>v(e, t, [
                r
            ]);
    }
    function xr(e, t, r) {
        return I(e, r), (r)=>g(e, t, [
                r
            ]);
    }
    function Qr(e, t, r) {
        return I(e, r), (r, o)=>v(e, t, [
                r,
                o
            ]);
    }
    function Nr(e, t, r) {
        return I(e, r), (r)=>v(e, t, [
                r
            ]);
    }
    Object.defineProperties(CountQueuingStrategy.prototype, {
        highWaterMark: {
            enumerable: !0
        },
        size: {
            enumerable: !0
        }
    }), "symbol" == typeof Symbol.toStringTag && Object.defineProperty(CountQueuingStrategy.prototype, Symbol.toStringTag, {
        value: "CountQueuingStrategy",
        configurable: !0
    });
    class TransformStream {
        constructor(e = {}, t = {}, r = {}){
            void 0 === e && (e = null);
            const o = ft(t, "Second parameter"), n = ft(r, "Third parameter"), a = function(e, t) {
                F(e, t);
                const r = null == e ? void 0 : e.cancel, o = null == e ? void 0 : e.flush, n = null == e ? void 0 : e.readableType, a = null == e ? void 0 : e.start, i = null == e ? void 0 : e.transform, l = null == e ? void 0 : e.writableType;
                return {
                    cancel: void 0 === r ? void 0 : Nr(r, e, `${t} has member 'cancel' that`),
                    flush: void 0 === o ? void 0 : Yr(o, e, `${t} has member 'flush' that`),
                    readableType: n,
                    start: void 0 === a ? void 0 : xr(a, e, `${t} has member 'start' that`),
                    transform: void 0 === i ? void 0 : Qr(i, e, `${t} has member 'transform' that`),
                    writableType: l
                };
            }(e, "First parameter");
            if (void 0 !== a.readableType) throw new RangeError("Invalid readableType specified");
            if (void 0 !== a.writableType) throw new RangeError("Invalid writableType specified");
            const i = ct(n, 0), l = dt(n), s = ct(o, 1), u = dt(o);
            let b;
            !function(e, t, r, o, n, a) {
                function i() {
                    return t;
                }
                function l(t) {
                    return function(e, t) {
                        const r = e._transformStreamController;
                        if (e._backpressure) return p(e._backpressureChangePromise, ()=>{
                            const o = e._writable;
                            if ("erroring" === o._state) throw o._storedError;
                            return eo(r, t);
                        });
                        return eo(r, t);
                    }(e, t);
                }
                function s(t) {
                    return function(e, t) {
                        const r = e._transformStreamController;
                        if (void 0 !== r._finishPromise) return r._finishPromise;
                        const o = e._readable;
                        r._finishPromise = c((e, t)=>{
                            r._finishPromise_resolve = e, r._finishPromise_reject = t;
                        });
                        const n = r._cancelAlgorithm(t);
                        return Kr(r), h(n, ()=>("errored" === o._state ? oo(r, o._storedError) : (hr(o._readableStreamController, t), ro(r)), null), (e)=>(hr(o._readableStreamController, e), oo(r, e), null)), r._finishPromise;
                    }(e, t);
                }
                function u() {
                    return function(e) {
                        const t = e._transformStreamController;
                        if (void 0 !== t._finishPromise) return t._finishPromise;
                        const r = e._readable;
                        t._finishPromise = c((e, r)=>{
                            t._finishPromise_resolve = e, t._finishPromise_reject = r;
                        });
                        const o = t._flushAlgorithm();
                        return Kr(t), h(o, ()=>("errored" === r._state ? oo(t, r._storedError) : (fr(r._readableStreamController), ro(t)), null), (e)=>(hr(r._readableStreamController, e), oo(t, e), null)), t._finishPromise;
                    }(e);
                }
                function d() {
                    return function(e) {
                        return Xr(e, !1), e._backpressureChangePromise;
                    }(e);
                }
                function f(t) {
                    return function(e, t) {
                        const r = e._transformStreamController;
                        if (void 0 !== r._finishPromise) return r._finishPromise;
                        const o = e._writable;
                        r._finishPromise = c((e, t)=>{
                            r._finishPromise_resolve = e, r._finishPromise_reject = t;
                        });
                        const n = r._cancelAlgorithm(t);
                        return Kr(r), h(n, ()=>("errored" === o._state ? oo(r, o._storedError) : (xt(o._writableStreamController, t), Gr(e), ro(r)), null), (t)=>(xt(o._writableStreamController, t), Gr(e), oo(r, t), null)), r._finishPromise;
                    }(e, t);
                }
                e._writable = function(e, t, r, o, n = 1, a = ()=>1) {
                    const i = Object.create(WritableStream.prototype);
                    return gt(i), It(i, Object.create(WritableStreamDefaultController.prototype), e, t, r, o, n, a), i;
                }(i, l, u, s, r, o), e._readable = Pr(i, d, f, n, a), e._backpressure = void 0, e._backpressureChangePromise = void 0, e._backpressureChangePromise_resolve = void 0, Xr(e, !0), e._transformStreamController = void 0;
            }(this, c((e)=>{
                b = e;
            }), s, u, i, l), function(e, t) {
                const r = Object.create(TransformStreamDefaultController.prototype);
                let o, n, a;
                o = void 0 !== t.transform ? (e)=>t.transform(e, r) : (e)=>{
                    try {
                        return Zr(r, e), d(void 0);
                    } catch (e) {
                        return f(e);
                    }
                };
                n = void 0 !== t.flush ? ()=>t.flush(r) : ()=>d(void 0);
                a = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>d(void 0);
                !function(e, t, r, o, n) {
                    t._controlledTransformStream = e, e._transformStreamController = t, t._transformAlgorithm = r, t._flushAlgorithm = o, t._cancelAlgorithm = n, t._finishPromise = void 0, t._finishPromise_resolve = void 0, t._finishPromise_reject = void 0;
                }(e, r, o, n, a);
            }(this, a), void 0 !== a.start ? b(a.start(this._transformStreamController)) : b(void 0);
        }
        get readable() {
            if (!Hr(this)) throw no("readable");
            return this._readable;
        }
        get writable() {
            if (!Hr(this)) throw no("writable");
            return this._writable;
        }
    }
    function Hr(e) {
        return !!r(e) && !!Object.prototype.hasOwnProperty.call(e, "_transformStreamController") && e instanceof TransformStream;
    }
    function Vr(e, t) {
        hr(e._readable._readableStreamController, t), Ur(e, t);
    }
    function Ur(e, t) {
        Kr(e._transformStreamController), xt(e._writable._writableStreamController, t), Gr(e);
    }
    function Gr(e) {
        e._backpressure && Xr(e, !1);
    }
    function Xr(e, t) {
        void 0 !== e._backpressureChangePromise && e._backpressureChangePromise_resolve(), e._backpressureChangePromise = c((t)=>{
            e._backpressureChangePromise_resolve = t;
        }), e._backpressure = t;
    }
    Object.defineProperties(TransformStream.prototype, {
        readable: {
            enumerable: !0
        },
        writable: {
            enumerable: !0
        }
    }), "symbol" == typeof Symbol.toStringTag && Object.defineProperty(TransformStream.prototype, Symbol.toStringTag, {
        value: "TransformStream",
        configurable: !0
    });
    class TransformStreamDefaultController {
        constructor(){
            throw new TypeError("Illegal constructor");
        }
        get desiredSize() {
            if (!Jr(this)) throw to("desiredSize");
            return mr(this._controlledTransformStream._readable._readableStreamController);
        }
        enqueue(e) {
            if (!Jr(this)) throw to("enqueue");
            Zr(this, e);
        }
        error(e) {
            if (!Jr(this)) throw to("error");
            var t;
            t = e, Vr(this._controlledTransformStream, t);
        }
        terminate() {
            if (!Jr(this)) throw to("terminate");
            !function(e) {
                const t = e._controlledTransformStream;
                fr(t._readable._readableStreamController);
                const r = new TypeError("TransformStream terminated");
                Ur(t, r);
            }(this);
        }
    }
    function Jr(e) {
        return !!r(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledTransformStream") && e instanceof TransformStreamDefaultController;
    }
    function Kr(e) {
        e._transformAlgorithm = void 0, e._flushAlgorithm = void 0, e._cancelAlgorithm = void 0;
    }
    function Zr(e, t) {
        const r = e._controlledTransformStream, o = r._readable._readableStreamController;
        if (!_r(o)) throw new TypeError("Readable side is not in a state that permits enqueue");
        try {
            br(o, t);
        } catch (e) {
            throw Ur(r, e), r._readable._storedError;
        }
        const n = function(e) {
            return !cr(e);
        }(o);
        n !== r._backpressure && Xr(r, !0);
    }
    function eo(e, t) {
        return p(e._transformAlgorithm(t), void 0, (t)=>{
            throw Vr(e._controlledTransformStream, t), t;
        });
    }
    function to(e) {
        return new TypeError(`TransformStreamDefaultController.prototype.${e} can only be used on a TransformStreamDefaultController`);
    }
    function ro(e) {
        void 0 !== e._finishPromise_resolve && (e._finishPromise_resolve(), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
    }
    function oo(e, t) {
        void 0 !== e._finishPromise_reject && (y(e._finishPromise), e._finishPromise_reject(t), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
    }
    function no(e) {
        return new TypeError(`TransformStream.prototype.${e} can only be used on a TransformStream`);
    }
    Object.defineProperties(TransformStreamDefaultController.prototype, {
        enqueue: {
            enumerable: !0
        },
        error: {
            enumerable: !0
        },
        terminate: {
            enumerable: !0
        },
        desiredSize: {
            enumerable: !0
        }
    }), n(TransformStreamDefaultController.prototype.enqueue, "enqueue"), n(TransformStreamDefaultController.prototype.error, "error"), n(TransformStreamDefaultController.prototype.terminate, "terminate"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty(TransformStreamDefaultController.prototype, Symbol.toStringTag, {
        value: "TransformStreamDefaultController",
        configurable: !0
    }), e.ByteLengthQueuingStrategy = ByteLengthQueuingStrategy, e.CountQueuingStrategy = CountQueuingStrategy, e.ReadableByteStreamController = ReadableByteStreamController, e.ReadableStream = ReadableStream, e.ReadableStreamBYOBReader = ReadableStreamBYOBReader, e.ReadableStreamBYOBRequest = ReadableStreamBYOBRequest, e.ReadableStreamDefaultController = ReadableStreamDefaultController, e.ReadableStreamDefaultReader = ReadableStreamDefaultReader, e.TransformStream = TransformStream, e.TransformStreamDefaultController = TransformStreamDefaultController, e.WritableStream = WritableStream, e.WritableStreamDefaultController = WritableStreamDefaultController, e.WritableStreamDefaultWriter = WritableStreamDefaultWriter;
});

});




parcelRegister("dtjlP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gkQP3 = parcelRequire("gkQP3");

$gkQP3.__exportStar((parcelRequire("bFIzj")), module.exports);

$gkQP3.__exportStar((parcelRequire("3Ju3H")), module.exports);

});

parcelRegister("8T2E9", function(module, exports) {

$parcel$export(module.exports, "observable", () => observable);
$parcel$export(module.exports, "computed", () => computed);
$parcel$export(module.exports, "autorun", () => autorun);
$parcel$export(module.exports, "action", () => action);
$parcel$export(module.exports, "reaction", () => reaction);
$parcel$export(module.exports, "configure", () => configure);
$parcel$export(module.exports, "toJS", () => toJS);
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _construct(t, e, r) {
    if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && _setPrototypeOf(p, r.prototype), p;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function() {
        return !!t;
    })();
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return _wrapNativeSuper = function(t) {
        if (null === t || !_isNativeFunction(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return _construct(t, arguments, _getPrototypeOf(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), _setPrototypeOf(Wrapper, t);
    }, _wrapNativeSuper(t);
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    };
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var mthd = initMthd;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = isAction(descriptor.set) ? descriptor.set // See #4553
         : createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        var _this$value_;
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "\t".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        if ("dispose" in Symbol && typeof Symbol.dispose === "symbol") dispose[Symbol.dispose] = dispose;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
var FlowCancellationError = /*#__PURE__*/ function(_Error) {
    function FlowCancellationError() {
        var _this;
        _this = _Error.call(this, "FLOW_CANCELLED") || this;
        Object.setPrototypeOf(_this, (this instanceof FlowCancellationError ? this.constructor : void 0).prototype);
        _this.name = "FlowCancellationError";
        return _this;
    }
    _inheritsLoose(FlowCancellationError, _Error);
    var _proto = FlowCancellationError.prototype;
    _proto.toString = function toString() {
        return "Error: " + this.message;
    };
    return FlowCancellationError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    };
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var values = this.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next = values.next(), value = _values$next.value, done = _values$next.done;
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var values = this.data_.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next2 = values.next(), value = _values$next2.value, done = _values$next2.done;
                return !done ? {
                    value: self1.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    };
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    };
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    };
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    };
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(var i = 0; i < _length; i++){
            // Deep compare each member
            var key = keys[i];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _getGlobal$Iterator;
// safely get iterator prototype if available
var maybeIteratorPrototype = ((_getGlobal$Iterator = /*#__PURE__*/ getGlobal().Iterator) == null ? void 0 : _getGlobal$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("9zAQJ", function(module, exports) {

$parcel$export(module.exports, "observer", () => $6f83f77ba8e7af5c$export$b6ae1bc530f4c149);
$parcel$export(module.exports, "attribute", () => $6f83f77ba8e7af5c$export$af4b9a83f4b00434);
$parcel$export(module.exports, "reaction", () => $6f83f77ba8e7af5c$export$7203b476385689ae);
$parcel$export(module.exports, "lazy", () => $6f83f77ba8e7af5c$export$488013bae63b21da);
$parcel$export(module.exports, "component", () => $6f83f77ba8e7af5c$export$d8556a2a8f973135);
$parcel$export(module.exports, "on", () => $6f83f77ba8e7af5c$export$af631764ddc44097);

var $1jJwX = parcelRequire("1jJwX");

var $8T2E9 = parcelRequire("8T2E9");

var $kdqQ0 = parcelRequire("kdqQ0");

var $dtjlP = parcelRequire("dtjlP");
function $6f83f77ba8e7af5c$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $6f83f77ba8e7af5c$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $6f83f77ba8e7af5c$var$$d4436c849e74ae70$exports = {};
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$d4436c849e74ae70$exports, "AnimateCSS", function() {
    return $6f83f77ba8e7af5c$export$2e9a7bb10257a509;
});
var $6f83f77ba8e7af5c$var$$f0344b6cd718ce24$exports = {};
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$f0344b6cd718ce24$exports, "observer", function() {
    return $6f83f77ba8e7af5c$export$b6ae1bc530f4c149;
});
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$f0344b6cd718ce24$exports, "attribute", function() {
    return $6f83f77ba8e7af5c$export$af4b9a83f4b00434;
});
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$f0344b6cd718ce24$exports, "reaction", function() {
    return $6f83f77ba8e7af5c$export$7203b476385689ae;
});
var $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$exports = {};
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$exports, "FunctionCell", function() {
    return $6f83f77ba8e7af5c$export$62c4dbcb062576f6;
});
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$exports, "lazy", function() {
    return $6f83f77ba8e7af5c$export$488013bae63b21da;
});
var $6f83f77ba8e7af5c$var$$317b1f21909c74b8$exports = {};
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$317b1f21909c74b8$exports, "component", function() {
    return $6f83f77ba8e7af5c$export$d8556a2a8f973135;
});
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$317b1f21909c74b8$exports, "on", function() {
    return $6f83f77ba8e7af5c$export$af631764ddc44097;
});
const $6f83f77ba8e7af5c$var$$317b1f21909c74b8$var$eventMap = new WeakMap();
function $6f83f77ba8e7af5c$export$d8556a2a8f973135(meta) {
    return (Class, { addInitializer: addInitializer })=>{
        class RendererComponent extends Class {
            get root() {
                return this.shadowRoot || this.internals.shadowRoot || this;
            }
            constructor(){
                var _a;
                super();
                Object.defineProperty(this, "internals", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: this.tagName.includes('-') ? this.attachInternals() : undefined
                });
                Object.defineProperty(this, "renderer", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: new (0, $dtjlP.DOMRenderer)()
                });
                Object.defineProperty(this, "mounted", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: false
                });
                if (meta.mode && !((_a = this.internals) === null || _a === void 0 ? void 0 : _a.shadowRoot)) this.attachShadow(meta);
            }
            async connectedCallback() {
                var _a, _b;
                const { mode: mode } = meta;
                const renderChildren = !(mode != null);
                const { root: root } = this, events = $6f83f77ba8e7af5c$var$$317b1f21909c74b8$var$eventMap.get(this) || [];
                for (const { type: type, selector: selector, handler: handler } of events){
                    if (renderChildren && /^:host/.test(selector)) console.warn(`[WebCell] DOM Event delegation of "${selector}" won't work if you don't invoke "this.attachShadow()" manually.`);
                    root.addEventListener(type, handler);
                }
                (_a = super['connectedCallback']) === null || _a === void 0 || _a.call(this);
                if (this.mounted) return;
                await this.update();
                this.mounted = true;
                (_b = this.mountedCallback) === null || _b === void 0 || _b.call(this);
            }
            updateDOM(content) {
                var _a, _b;
                const result = this.renderer.render(content, this.root, meta.renderMode);
                return result instanceof Promise ? result.then((_a = this.updatedCallback) === null || _a === void 0 ? void 0 : _a.bind(this)) : (_b = this.updatedCallback) === null || _b === void 0 ? void 0 : _b.call(this);
            }
            async update() {
                var _a;
                const vNode = (_a = this.render) === null || _a === void 0 ? void 0 : _a.call(this);
                const content = (0, $kdqQ0.isEmpty)(vNode) ? meta.mode ? (0, $1jJwX.jsx)("slot", {}) : null : vNode;
                if (!(content != null)) return;
                if (!meta.transitible || typeof document.startViewTransition !== 'function') return this.updateDOM(content);
                const { updateCallbackDone: updateCallbackDone, finished: finished } = document.startViewTransition(()=>this.updateDOM(content));
                try {
                    await finished;
                } catch (_b) {
                    return updateCallbackDone;
                }
            }
            disconnectedCallback() {
                var _a;
                const { root: root } = this, events = $6f83f77ba8e7af5c$var$$317b1f21909c74b8$var$eventMap.get(this) || [];
                for (const { type: type, handler: handler } of events)root.removeEventListener(type, handler);
                (_a = super['disconnectedCallback']) === null || _a === void 0 || _a.call(this);
            }
            emit(event, detail, { cancelable: cancelable, bubbles: bubbles, composed: composed } = {}) {
                return this.dispatchEvent(new CustomEvent(event, {
                    detail: detail,
                    cancelable: cancelable,
                    bubbles: bubbles,
                    composed: composed
                }));
            }
        }
        addInitializer(function() {
            var _a;
            (_a = globalThis.customElements) === null || _a === void 0 || _a.define(meta.tagName, this, meta);
        });
        return RendererComponent;
    };
}
function $6f83f77ba8e7af5c$export$af631764ddc44097(type, selector) {
    return (method, { addInitializer: addInitializer })=>addInitializer(function() {
            const events = $6f83f77ba8e7af5c$var$$317b1f21909c74b8$var$eventMap.get(this) || [], handler = (0, $kdqQ0.delegate)(selector, method.bind(this));
            events.push({
                type: type,
                selector: selector,
                handler: handler
            });
            $6f83f77ba8e7af5c$var$$317b1f21909c74b8$var$eventMap.set(this, events);
        });
}
var $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $6f83f77ba8e7af5c$export$62c4dbcb062576f6 = (()=>{
    var _FunctionCell_component_accessor_storage, _FunctionCell_vNode_accessor_storage;
    let _classDecorators = [
        $6f83f77ba8e7af5c$export$d8556a2a8f973135({
            tagName: 'function-cell'
        }),
        $6f83f77ba8e7af5c$export$b6ae1bc530f4c149
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _component_decorators;
    let _component_initializers = [];
    let _component_extraInitializers = [];
    let _vNode_decorators;
    let _vNode_initializers = [];
    let _vNode_extraInitializers = [];
    var FunctionCell = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _FunctionCell_component_accessor_storage.set(this, $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__runInitializers(this, _component_initializers, void 0));
            _FunctionCell_vNode_accessor_storage.set(this, ($6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__runInitializers(this, _component_extraInitializers), $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__runInitializers(this, _vNode_initializers, void 0)));
            Object.defineProperty(this, "disconnectedCallback", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__runInitializers(this, _vNode_extraInitializers), (0, $8T2E9.reaction)(()=>this.component, ()=>this.vNode = undefined))
            });
        }
        get component() {
            return $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__classPrivateFieldGet(this, _FunctionCell_component_accessor_storage, "f");
        }
        set component(value) {
            $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__classPrivateFieldSet(this, _FunctionCell_component_accessor_storage, value, "f");
        }
        get vNode() {
            return $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__classPrivateFieldGet(this, _FunctionCell_vNode_accessor_storage, "f");
        }
        set vNode(value) {
            $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__classPrivateFieldSet(this, _FunctionCell_vNode_accessor_storage, value, "f");
        }
        render() {
            const result = this.vNode || this.component({});
            if (!(result instanceof Promise)) return result;
            result.then((vNode)=>this.vNode = vNode);
        }
    };
    _FunctionCell_component_accessor_storage = new WeakMap();
    _FunctionCell_vNode_accessor_storage = new WeakMap();
    $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__setFunctionName(_classThis, "FunctionCell");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _component_decorators = [
            (0, $8T2E9.observable)
        ];
        _vNode_decorators = [
            (0, $8T2E9.observable)
        ];
        $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__esDecorate(_classThis, null, _component_decorators, {
            kind: "accessor",
            name: "component",
            static: false,
            private: false,
            access: {
                has: (obj)=>"component" in obj,
                get: (obj)=>obj.component,
                set: (obj, value)=>{
                    obj.component = value;
                }
            },
            metadata: _metadata
        }, _component_initializers, _component_extraInitializers);
        $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__esDecorate(_classThis, null, _vNode_decorators, {
            kind: "accessor",
            name: "vNode",
            static: false,
            private: false,
            access: {
                has: (obj)=>"vNode" in obj,
                get: (obj)=>obj.vNode,
                set: (obj, value)=>{
                    obj.vNode = value;
                }
            },
            metadata: _metadata
        }, _vNode_initializers, _vNode_extraInitializers);
        $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        FunctionCell = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return FunctionCell = _classThis;
})();
const $6f83f77ba8e7af5c$export$488013bae63b21da = (loader)=>(props)=>(0, $1jJwX.jsx)($6f83f77ba8e7af5c$export$62c4dbcb062576f6, {
            component: async ()=>{
                const { default: Tag } = await loader();
                return (0, $1jJwX.jsx)(Tag, Object.assign({}, props));
            }
        });
var $6f83f77ba8e7af5c$var$$552a56cc5ff3f479$exports = {};
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$552a56cc5ff3f479$exports, "Defer", function() {
    return $6f83f77ba8e7af5c$export$c7e91f8aec23ae14;
});
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$552a56cc5ff3f479$exports, "getMobxData", function() {
    return $6f83f77ba8e7af5c$export$b06b4c21253e26e2;
});
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$552a56cc5ff3f479$exports, "animated", function() {
    return $6f83f77ba8e7af5c$export$4077c0dfbe9c3861;
});
class $6f83f77ba8e7af5c$export$c7e91f8aec23ae14 {
    constructor(){
        Object.defineProperty(this, "resolve", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reject", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "promise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Promise((resolve, reject)=>{
                this.resolve = resolve;
                this.reject = reject;
            })
        });
    }
}
function $6f83f77ba8e7af5c$export$b06b4c21253e26e2(observable) {
    var _a;
    for (const key of Object.getOwnPropertySymbols(observable)){
        const store = (_a = observable[key]) === null || _a === void 0 ? void 0 : _a.values_;
        if (store instanceof Map) return Object.fromEntries(Array.from(store, ([key, { value_: value_ }])=>[
                key,
                value_
            ]));
    }
}
const $6f83f77ba8e7af5c$export$4077c0dfbe9c3861 = (root, targetSelector)=>new Promise((resolve)=>{
        const ended = (0, $kdqQ0.delegate)(targetSelector, (event)=>{
            root.removeEventListener('animationend', ended);
            root.removeEventListener('animationcancel', ended);
            resolve(event);
        });
        root.addEventListener('animationend', ended);
        root.addEventListener('animationcancel', ended);
    });
var $6f83f77ba8e7af5c$var$$f0344b6cd718ce24$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
const $6f83f77ba8e7af5c$var$$f0344b6cd718ce24$var$reactionMap = new WeakMap();
function $6f83f77ba8e7af5c$var$$f0344b6cd718ce24$var$wrapClass(Component) {
    var _ObserverComponent_instances, _ObserverComponent_boot;
    class ObserverComponent extends Component {
        get props() {
            return $6f83f77ba8e7af5c$export$b06b4c21253e26e2(this);
        }
        constructor(){
            super();
            _ObserverComponent_instances.add(this);
            Object.defineProperty(this, "disposers", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            Object.defineProperty(this, "update", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>{
                    const { update: update } = Object.getPrototypeOf(this);
                    return new Promise((resolve)=>this.disposers.push((0, $8T2E9.autorun)(()=>update.call(this).then(resolve))));
                }
            });
            Promise.resolve().then(()=>$6f83f77ba8e7af5c$var$$f0344b6cd718ce24$var$__classPrivateFieldGet(this, _ObserverComponent_instances, "m", _ObserverComponent_boot).call(this));
        }
        disconnectedCallback() {
            var _a;
            for (const disposer of this.disposers)disposer();
            this.disposers.length = 0;
            (_a = super['disconnectedCallback']) === null || _a === void 0 || _a.call(this);
        }
        setAttribute(name, value) {
            const old = super.getAttribute(name), names = this.constructor['observedAttributes'];
            super.setAttribute(name, value);
            if (names.includes(name)) this.attributeChangedCallback(name, old, value);
        }
        attributeChangedCallback(name, old, value) {
            var _a;
            this[(0, $kdqQ0.toCamelCase)(name)] = (0, $kdqQ0.parseJSON)(value);
            (_a = super['attributeChangedCallback']) === null || _a === void 0 || _a.call(this, name, old, value);
        }
        syncPropAttr(name) {
            var _a;
            let value = this[(0, $kdqQ0.toCamelCase)(name)];
            if (!(value != null) || value === false) return this.removeAttribute(name);
            value = value === true ? name : value;
            if (typeof value === 'object') {
                value = (_a = value.toJSON) === null || _a === void 0 ? void 0 : _a.call(value);
                value = typeof value === 'object' ? JSON.stringify(value) : value;
            }
            super.setAttribute(name, value);
        }
    }
    _ObserverComponent_instances = new WeakSet(), _ObserverComponent_boot = function _ObserverComponent_boot() {
        const names = this.constructor['observedAttributes'] || [], reactions = $6f83f77ba8e7af5c$var$$f0344b6cd718ce24$var$reactionMap.get(this) || [];
        this.disposers.push(...names.map((name)=>(0, $8T2E9.autorun)(()=>this.syncPropAttr(name))), ...reactions.map(({ expression: expression, effect: effect })=>(0, $8T2E9.reaction)((reaction)=>expression(this, reaction), effect.bind(this))));
    };
    Object.defineProperty(ObserverComponent, "observedAttributes", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: []
    });
    return ObserverComponent;
}
function $6f83f77ba8e7af5c$export$b6ae1bc530f4c149(func, _) {
    return (0, $kdqQ0.isHTMLElementClass)(func) ? $6f83f77ba8e7af5c$var$$f0344b6cd718ce24$var$wrapClass(func) : (props)=>(0, $1jJwX.jsx)($6f83f77ba8e7af5c$export$62c4dbcb062576f6, {
            component: ()=>func(props)
        });
}
function $6f83f77ba8e7af5c$export$af4b9a83f4b00434(_, { name: name, addInitializer: addInitializer }) {
    addInitializer(function() {
        const names = this.constructor['observedAttributes'], attribute = (0, $kdqQ0.toHyphenCase)(name.toString());
        if (!names.includes(attribute)) names.push(attribute);
    });
}
const $6f83f77ba8e7af5c$export$7203b476385689ae = (expression)=>(effect, { addInitializer: addInitializer })=>addInitializer(function() {
            const reactions = $6f83f77ba8e7af5c$var$$f0344b6cd718ce24$var$reactionMap.get(this) || [];
            reactions.push({
                expression: expression,
                effect: effect
            });
            $6f83f77ba8e7af5c$var$$f0344b6cd718ce24$var$reactionMap.set(this, reactions);
        });
var $6f83f77ba8e7af5c$var$$819b340f625a29f4$exports = {};
var $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $6f83f77ba8e7af5c$export$2e9a7bb10257a509 = (()=>{
    var _AnimateCSS_type_accessor_storage, _AnimateCSS_playing_accessor_storage;
    let _classDecorators = [
        $6f83f77ba8e7af5c$export$d8556a2a8f973135({
            tagName: 'animation-css'
        }),
        $6f83f77ba8e7af5c$export$b6ae1bc530f4c149
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _type_decorators;
    let _type_initializers = [];
    let _type_extraInitializers = [];
    let _playing_decorators;
    let _playing_initializers = [];
    let _playing_extraInitializers = [];
    let _typeChanged_decorators;
    var AnimateCSS = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _AnimateCSS_type_accessor_storage.set(this, ($6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__runInitializers(this, _instanceExtraInitializers), $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__runInitializers(this, _type_initializers, void 0)));
            _AnimateCSS_playing_accessor_storage.set(this, ($6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__runInitializers(this, _type_extraInitializers), $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__runInitializers(this, _playing_initializers, false)));
            Object.defineProperty(this, "component", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__runInitializers(this, _playing_extraInitializers)
            });
        }
        get type() {
            return $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__classPrivateFieldGet(this, _AnimateCSS_type_accessor_storage, "f");
        }
        set type(value) {
            $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__classPrivateFieldSet(this, _AnimateCSS_type_accessor_storage, value, "f");
        }
        get playing() {
            return $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__classPrivateFieldGet(this, _AnimateCSS_playing_accessor_storage, "f");
        }
        set playing(value) {
            $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__classPrivateFieldSet(this, _AnimateCSS_playing_accessor_storage, value, "f");
        }
        async connectedCallback() {
            await (0, $kdqQ0.importCSS)('https://unpkg.com/animate.css@4/animate.min.css');
            this.typeChanged();
        }
        async typeChanged() {
            this.playing = true;
            await $6f83f77ba8e7af5c$export$4077c0dfbe9c3861(this, '.animate__animated');
            this.playing = false;
        }
        render() {
            const { type: type, playing: playing, component: Tag } = this;
            return playing ? (0, $1jJwX.jsx)(Tag, {
                className: `animate__animated animate__${type}`
            }) : type.includes('Out') ? (0, $1jJwX.jsx)((0, $1jJwX.Fragment), {}) : (0, $1jJwX.jsx)(Tag, {});
        }
    };
    _AnimateCSS_type_accessor_storage = new WeakMap();
    _AnimateCSS_playing_accessor_storage = new WeakMap();
    $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__setFunctionName(_classThis, "AnimateCSS");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _type_decorators = [
            $6f83f77ba8e7af5c$export$af4b9a83f4b00434,
            (0, $8T2E9.observable)
        ];
        _playing_decorators = [
            $6f83f77ba8e7af5c$export$af4b9a83f4b00434,
            (0, $8T2E9.observable)
        ];
        _typeChanged_decorators = [
            $6f83f77ba8e7af5c$export$7203b476385689ae(({ type: type })=>type)
        ];
        $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__esDecorate(_classThis, null, _type_decorators, {
            kind: "accessor",
            name: "type",
            static: false,
            private: false,
            access: {
                has: (obj)=>"type" in obj,
                get: (obj)=>obj.type,
                set: (obj, value)=>{
                    obj.type = value;
                }
            },
            metadata: _metadata
        }, _type_initializers, _type_extraInitializers);
        $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__esDecorate(_classThis, null, _playing_decorators, {
            kind: "accessor",
            name: "playing",
            static: false,
            private: false,
            access: {
                has: (obj)=>"playing" in obj,
                get: (obj)=>obj.playing,
                set: (obj, value)=>{
                    obj.playing = value;
                }
            },
            metadata: _metadata
        }, _playing_initializers, _playing_extraInitializers);
        $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__esDecorate(_classThis, null, _typeChanged_decorators, {
            kind: "method",
            name: "typeChanged",
            static: false,
            private: false,
            access: {
                has: (obj)=>"typeChanged" in obj,
                get: (obj)=>obj.typeChanged
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        AnimateCSS = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return AnimateCSS = _classThis;
})();
$6f83f77ba8e7af5c$var$$parcel$exportWildcard($6f83f77ba8e7af5c$var$$d4436c849e74ae70$exports, $6f83f77ba8e7af5c$var$$819b340f625a29f4$exports);
var $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$exports = {};
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$29675797ddd6c4f7$exports, "formField", function() {
    return $6f83f77ba8e7af5c$export$2a668e8d088a0667;
});
var $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
function $6f83f77ba8e7af5c$export$2a668e8d088a0667(Class, _) {
    let FormFieldComponent = (()=>{
        var _a, _FormFieldComponent_name_accessor_storage, _FormFieldComponent_value_accessor_storage, _FormFieldComponent_required_accessor_storage, _FormFieldComponent_disabled_accessor_storage, _FormFieldComponent_autofocus_accessor_storage;
        let _classSuper = Class;
        let _instanceExtraInitializers = [];
        let _setValue_decorators;
        let _name_decorators;
        let _name_initializers = [];
        let _name_extraInitializers = [];
        let _value_decorators;
        let _value_initializers = [];
        let _value_extraInitializers = [];
        let _required_decorators;
        let _required_initializers = [];
        let _required_extraInitializers = [];
        let _disabled_decorators;
        let _disabled_initializers = [];
        let _disabled_extraInitializers = [];
        let _autofocus_decorators;
        let _autofocus_initializers = [];
        let _autofocus_extraInitializers = [];
        return _a = class FormFieldComponent extends _classSuper {
            setValue(value) {
                this.internals.setFormValue(value);
            }
            formDisabledCallback(disabled) {
                this.disabled = disabled;
            }
            get name() {
                return $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_name_accessor_storage, "f");
            }
            set name(value) {
                $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_name_accessor_storage, value, "f");
            }
            get value() {
                return $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_value_accessor_storage, "f");
            }
            set value(value) {
                $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_value_accessor_storage, value, "f");
            }
            get required() {
                return $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_required_accessor_storage, "f");
            }
            set required(value) {
                $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_required_accessor_storage, value, "f");
            }
            get disabled() {
                return $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_disabled_accessor_storage, "f");
            }
            set disabled(value) {
                $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_disabled_accessor_storage, value, "f");
            }
            get autofocus() {
                return $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_autofocus_accessor_storage, "f");
            }
            set autofocus(value) {
                $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_autofocus_accessor_storage, value, "f");
            }
            set defaultValue(raw) {
                var _b;
                this.setAttribute('value', raw);
                (_b = this.value) !== null && _b !== void 0 ? _b : this.value = raw;
            }
            get defaultValue() {
                return this.getAttribute('value');
            }
            get form() {
                return this.internals.form;
            }
            get validity() {
                return this.internals.validity;
            }
            get validationMessage() {
                return this.internals.validationMessage;
            }
            get willValidate() {
                return this.internals.willValidate;
            }
            checkValidity() {
                return this.internals.checkValidity();
            }
            reportValidity() {
                return this.internals.reportValidity();
            }
            constructor(){
                super(...arguments);
                _FormFieldComponent_name_accessor_storage.set(this, ($6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _instanceExtraInitializers), $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _name_initializers, void 0)));
                _FormFieldComponent_value_accessor_storage.set(this, ($6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _name_extraInitializers), $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _value_initializers, void 0)));
                _FormFieldComponent_required_accessor_storage.set(this, ($6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _value_extraInitializers), $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _required_initializers, void 0)));
                _FormFieldComponent_disabled_accessor_storage.set(this, ($6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _required_extraInitializers), $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _disabled_initializers, void 0)));
                _FormFieldComponent_autofocus_accessor_storage.set(this, ($6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _disabled_extraInitializers), $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _autofocus_initializers, void 0)));
                $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _autofocus_extraInitializers);
            }
        }, _FormFieldComponent_name_accessor_storage = new WeakMap(), _FormFieldComponent_value_accessor_storage = new WeakMap(), _FormFieldComponent_required_accessor_storage = new WeakMap(), _FormFieldComponent_disabled_accessor_storage = new WeakMap(), _FormFieldComponent_autofocus_accessor_storage = new WeakMap(), (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _setValue_decorators = [
                $6f83f77ba8e7af5c$export$7203b476385689ae(({ value: value })=>value)
            ];
            _name_decorators = [
                $6f83f77ba8e7af5c$export$af4b9a83f4b00434,
                (0, $8T2E9.observable)
            ];
            _value_decorators = [
                (0, $8T2E9.observable)
            ];
            _required_decorators = [
                $6f83f77ba8e7af5c$export$af4b9a83f4b00434,
                (0, $8T2E9.observable)
            ];
            _disabled_decorators = [
                $6f83f77ba8e7af5c$export$af4b9a83f4b00434,
                (0, $8T2E9.observable)
            ];
            _autofocus_decorators = [
                $6f83f77ba8e7af5c$export$af4b9a83f4b00434,
                (0, $8T2E9.observable)
            ];
            $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _setValue_decorators, {
                kind: "method",
                name: "setValue",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"setValue" in obj,
                    get: (obj)=>obj.setValue
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _name_decorators, {
                kind: "accessor",
                name: "name",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"name" in obj,
                    get: (obj)=>obj.name,
                    set: (obj, value)=>{
                        obj.name = value;
                    }
                },
                metadata: _metadata
            }, _name_initializers, _name_extraInitializers);
            $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _value_decorators, {
                kind: "accessor",
                name: "value",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"value" in obj,
                    get: (obj)=>obj.value,
                    set: (obj, value)=>{
                        obj.value = value;
                    }
                },
                metadata: _metadata
            }, _value_initializers, _value_extraInitializers);
            $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _required_decorators, {
                kind: "accessor",
                name: "required",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"required" in obj,
                    get: (obj)=>obj.required,
                    set: (obj, value)=>{
                        obj.required = value;
                    }
                },
                metadata: _metadata
            }, _required_initializers, _required_extraInitializers);
            $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _disabled_decorators, {
                kind: "accessor",
                name: "disabled",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"disabled" in obj,
                    get: (obj)=>obj.disabled,
                    set: (obj, value)=>{
                        obj.disabled = value;
                    }
                },
                metadata: _metadata
            }, _disabled_initializers, _disabled_extraInitializers);
            $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _autofocus_decorators, {
                kind: "accessor",
                name: "autofocus",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"autofocus" in obj,
                    get: (obj)=>obj.autofocus,
                    set: (obj, value)=>{
                        obj.autofocus = value;
                    }
                },
                metadata: _metadata
            }, _autofocus_initializers, _autofocus_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), Object.defineProperty(_a, "formAssociated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        }), _a;
    })();
    return FormFieldComponent;
}

});


//# sourceMappingURL=Users.d37eb542.js.map
